/*
 RequireJS 2.2.0 Copyright jQuery Foundation and other contributors.
 Released under MIT license, http://github.com/requirejs/requirejs/LICENSE
*/
var requirejs,require,define;
(function(ga){function ka(b,c,d,g){return g||""}function K(b){return"[object Function]"===Q.call(b)}function L(b){return"[object Array]"===Q.call(b)}function y(b,c){if(b){var d;for(d=0;d<b.length&&(!b[d]||!c(b[d],d,b));d+=1);}}function X(b,c){if(b){var d;for(d=b.length-1;-1<d&&(!b[d]||!c(b[d],d,b));--d);}}function x(b,c){return la.call(b,c)}function e(b,c){return x(b,c)&&b[c]}function D(b,c){for(var d in b)if(x(b,d)&&c(b[d],d))break}function Y(b,c,d,g){c&&D(c,function(c,e){if(d||!x(b,e))!g||"object"!==
typeof c||!c||L(c)||K(c)||c instanceof RegExp?b[e]=c:(b[e]||(b[e]={}),Y(b[e],c,d,g))});return b}function z(b,c){return function(){return c.apply(b,arguments)}}function ha(b){throw b;}function ia(b){if(!b)return b;var c=ga;y(b.split("."),function(b){c=c[b]});return c}function F(b,c,d,g){c=Error(c+"\nhttp://requirejs.org/docs/errors.html#"+b);c.requireType=b;c.requireModules=g;d&&(c.originalError=d);return c}function ma(b){function c(a,n,b){var h,k,f,c,d,l,g,r;n=n&&n.split("/");var q=p.map,m=q&&q["*"];
if(a){a=a.split("/");k=a.length-1;p.nodeIdCompat&&U.test(a[k])&&(a[k]=a[k].replace(U,""));"."===a[0].charAt(0)&&n&&(k=n.slice(0,n.length-1),a=k.concat(a));k=a;for(f=0;f<k.length;f++)c=k[f],"."===c?(k.splice(f,1),--f):".."===c&&0!==f&&(1!==f||".."!==k[2])&&".."!==k[f-1]&&0<f&&(k.splice(f-1,2),f-=2);a=a.join("/")}if(b&&q&&(n||m)){k=a.split("/");f=k.length;a:for(;0<f;--f){d=k.slice(0,f).join("/");if(n)for(c=n.length;0<c;--c)if(b=e(q,n.slice(0,c).join("/")))if(b=e(b,d)){h=b;l=f;break a}!g&&m&&e(m,d)&&
(g=e(m,d),r=f)}!h&&g&&(h=g,l=r);h&&(k.splice(0,l,h),a=k.join("/"))}return(h=e(p.pkgs,a))?h:a}function d(a){E&&y(document.getElementsByTagName("script"),function(n){if(n.getAttribute("data-requiremodule")===a&&n.getAttribute("data-requirecontext")===l.contextName)return n.parentNode.removeChild(n),!0})}function m(a){var n=e(p.paths,a);if(n&&L(n)&&1<n.length)return n.shift(),l.require.undef(a),l.makeRequire(null,{skipMap:!0})([a]),!0}function r(a){var n,b=a?a.indexOf("!"):-1;-1<b&&(n=a.substring(0,
b),a=a.substring(b+1,a.length));return[n,a]}function q(a,n,b,h){var k,f,d=null,g=n?n.name:null,p=a,q=!0,m="";a||(q=!1,a="_@r"+(Q+=1));a=r(a);d=a[0];a=a[1];d&&(d=c(d,g,h),f=e(v,d));a&&(d?m=f&&f.normalize?f.normalize(a,function(a){return c(a,g,h)}):-1===a.indexOf("!")?c(a,g,h):a:(m=c(a,g,h),a=r(m),d=a[0],m=a[1],b=!0,k=l.nameToUrl(m)));b=!d||f||b?"":"_unnormalized"+(T+=1);return{prefix:d,name:m,parentMap:n,unnormalized:!!b,url:k,originalName:p,isDefine:q,id:(d?d+"!"+m:m)+b}}function u(a){var b=a.id,
c=e(t,b);c||(c=t[b]=new l.Module(a));return c}function w(a,b,c){var h=a.id,k=e(t,h);if(!x(v,h)||k&&!k.defineEmitComplete)if(k=u(a),k.error&&"error"===b)c(k.error);else k.on(b,c);else"defined"===b&&c(v[h])}function A(a,b){var c=a.requireModules,h=!1;if(b)b(a);else if(y(c,function(b){if(b=e(t,b))b.error=a,b.events.error&&(h=!0,b.emit("error",a))}),!h)g.onError(a)}function B(){V.length&&(y(V,function(a){var b=a[0];"string"===typeof b&&(l.defQueueMap[b]=!0);G.push(a)}),V=[])}function C(a){delete t[a];
delete Z[a]}function J(a,b,c){var h=a.map.id;a.error?a.emit("error",a.error):(b[h]=!0,y(a.depMaps,function(h,f){var d=h.id,g=e(t,d);!g||a.depMatched[f]||c[d]||(e(b,d)?(a.defineDep(f,v[d]),a.check()):J(g,b,c))}),c[h]=!0)}function H(){var a,b,c=(a=1E3*p.waitSeconds)&&l.startTime+a<(new Date).getTime(),h=[],k=[],f=!1,g=!0;if(!aa){aa=!0;D(Z,function(a){var l=a.map,e=l.id;if(a.enabled&&(l.isDefine||k.push(a),!a.error))if(!a.inited&&c)m(e)?f=b=!0:(h.push(e),d(e));else if(!a.inited&&a.fetched&&l.isDefine&&
(f=!0,!l.prefix))return g=!1});if(c&&h.length)return a=F("timeout","Load timeout for modules: "+h,null,h),a.contextName=l.contextName,A(a);g&&y(k,function(a){J(a,{},{})});c&&!b||!f||!E&&!ja||ba||(ba=setTimeout(function(){ba=0;H()},50));aa=!1}}function I(a){x(v,a[0])||u(q(a[0],null,!0)).init(a[1],a[2])}function O(a){a=a.currentTarget||a.srcElement;var b=l.onScriptLoad;a.detachEvent&&!ca?a.detachEvent("onreadystatechange",b):a.removeEventListener("load",b,!1);b=l.onScriptError;a.detachEvent&&!ca||a.removeEventListener("error",
b,!1);return{node:a,id:a&&a.getAttribute("data-requiremodule")}}function P(){var a;for(B();G.length;){a=G.shift();if(null===a[0])return A(F("mismatch","Mismatched anonymous define() module: "+a[a.length-1]));I(a)}l.defQueueMap={}}var aa,da,l,R,ba,p={waitSeconds:7,baseUrl:"./",paths:{},bundles:{},pkgs:{},shim:{},config:{}},t={},Z={},ea={},G=[],v={},W={},fa={},Q=1,T=1;R={require:function(a){return a.require?a.require:a.require=l.makeRequire(a.map)},exports:function(a){a.usingExports=!0;if(a.map.isDefine)return a.exports?
v[a.map.id]=a.exports:a.exports=v[a.map.id]={}},module:function(a){return a.module?a.module:a.module={id:a.map.id,uri:a.map.url,config:function(){return e(p.config,a.map.id)||{}},exports:a.exports||(a.exports={})}}};da=function(a){this.events=e(ea,a.id)||{};this.map=a;this.shim=e(p.shim,a.id);this.depExports=[];this.depMaps=[];this.depMatched=[];this.pluginMaps={};this.depCount=0};da.prototype={init:function(a,b,c,h){h=h||{};if(!this.inited){this.factory=b;if(c)this.on("error",c);else this.events.error&&
(c=z(this,function(a){this.emit("error",a)}));this.depMaps=a&&a.slice(0);this.errback=c;this.inited=!0;this.ignore=h.ignore;h.enabled||this.enabled?this.enable():this.check()}},defineDep:function(a,b){this.depMatched[a]||(this.depMatched[a]=!0,--this.depCount,this.depExports[a]=b)},fetch:function(){if(!this.fetched){this.fetched=!0;l.startTime=(new Date).getTime();var a=this.map;if(this.shim)l.makeRequire(this.map,{enableBuildCallback:!0})(this.shim.deps||[],z(this,function(){return a.prefix?this.callPlugin():
this.load()}));else return a.prefix?this.callPlugin():this.load()}},load:function(){var a=this.map.url;W[a]||(W[a]=!0,l.load(this.map.id,a))},check:function(){if(this.enabled&&!this.enabling){var a,b,c=this.map.id;b=this.depExports;var h=this.exports,k=this.factory;if(!this.inited)x(l.defQueueMap,c)||this.fetch();else if(this.error)this.emit("error",this.error);else if(!this.defining){this.defining=!0;if(1>this.depCount&&!this.defined){if(K(k)){if(this.events.error&&this.map.isDefine||g.onError!==
ha)try{h=l.execCb(c,k,b,h)}catch(d){a=d}else h=l.execCb(c,k,b,h);this.map.isDefine&&void 0===h&&((b=this.module)?h=b.exports:this.usingExports&&(h=this.exports));if(a)return a.requireMap=this.map,a.requireModules=this.map.isDefine?[this.map.id]:null,a.requireType=this.map.isDefine?"define":"require",A(this.error=a)}else h=k;this.exports=h;if(this.map.isDefine&&!this.ignore&&(v[c]=h,g.onResourceLoad)){var f=[];y(this.depMaps,function(a){f.push(a.normalizedMap||a)});g.onResourceLoad(l,this.map,f)}C(c);
this.defined=!0}this.defining=!1;this.defined&&!this.defineEmitted&&(this.defineEmitted=!0,this.emit("defined",this.exports),this.defineEmitComplete=!0)}}},callPlugin:function(){var a=this.map,b=a.id,d=q(a.prefix);this.depMaps.push(d);w(d,"defined",z(this,function(h){var k,f,d=e(fa,this.map.id),M=this.map.name,r=this.map.parentMap?this.map.parentMap.name:null,m=l.makeRequire(a.parentMap,{enableBuildCallback:!0});if(this.map.unnormalized){if(h.normalize&&(M=h.normalize(M,function(a){return c(a,r,!0)})||
""),f=q(a.prefix+"!"+M,this.map.parentMap),w(f,"defined",z(this,function(a){this.map.normalizedMap=f;this.init([],function(){return a},null,{enabled:!0,ignore:!0})})),h=e(t,f.id)){this.depMaps.push(f);if(this.events.error)h.on("error",z(this,function(a){this.emit("error",a)}));h.enable()}}else d?(this.map.url=l.nameToUrl(d),this.load()):(k=z(this,function(a){this.init([],function(){return a},null,{enabled:!0})}),k.error=z(this,function(a){this.inited=!0;this.error=a;a.requireModules=[b];D(t,function(a){0===
a.map.id.indexOf(b+"_unnormalized")&&C(a.map.id)});A(a)}),k.fromText=z(this,function(h,c){var d=a.name,f=q(d),M=S;c&&(h=c);M&&(S=!1);u(f);x(p.config,b)&&(p.config[d]=p.config[b]);try{g.exec(h)}catch(e){return A(F("fromtexteval","fromText eval for "+b+" failed: "+e,e,[b]))}M&&(S=!0);this.depMaps.push(f);l.completeLoad(d);m([d],k)}),h.load(a.name,m,k,p))}));l.enable(d,this);this.pluginMaps[d.id]=d},enable:function(){Z[this.map.id]=this;this.enabling=this.enabled=!0;y(this.depMaps,z(this,function(a,
b){var c,h;if("string"===typeof a){a=q(a,this.map.isDefine?this.map:this.map.parentMap,!1,!this.skipMap);this.depMaps[b]=a;if(c=e(R,a.id)){this.depExports[b]=c(this);return}this.depCount+=1;w(a,"defined",z(this,function(a){this.undefed||(this.defineDep(b,a),this.check())}));this.errback?w(a,"error",z(this,this.errback)):this.events.error&&w(a,"error",z(this,function(a){this.emit("error",a)}))}c=a.id;h=t[c];x(R,c)||!h||h.enabled||l.enable(a,this)}));D(this.pluginMaps,z(this,function(a){var b=e(t,a.id);
b&&!b.enabled&&l.enable(a,this)}));this.enabling=!1;this.check()},on:function(a,b){var c=this.events[a];c||(c=this.events[a]=[]);c.push(b)},emit:function(a,b){y(this.events[a],function(a){a(b)});"error"===a&&delete this.events[a]}};l={config:p,contextName:b,registry:t,defined:v,urlFetched:W,defQueue:G,defQueueMap:{},Module:da,makeModuleMap:q,nextTick:g.nextTick,onError:A,configure:function(a){a.baseUrl&&"/"!==a.baseUrl.charAt(a.baseUrl.length-1)&&(a.baseUrl+="/");if("string"===typeof a.urlArgs){var b=
a.urlArgs;a.urlArgs=function(a,c){return(-1===c.indexOf("?")?"?":"&")+b}}var c=p.shim,h={paths:!0,bundles:!0,config:!0,map:!0};D(a,function(a,b){h[b]?(p[b]||(p[b]={}),Y(p[b],a,!0,!0)):p[b]=a});a.bundles&&D(a.bundles,function(a,b){y(a,function(a){a!==b&&(fa[a]=b)})});a.shim&&(D(a.shim,function(a,b){L(a)&&(a={deps:a});!a.exports&&!a.init||a.exportsFn||(a.exportsFn=l.makeShimExports(a));c[b]=a}),p.shim=c);a.packages&&y(a.packages,function(a){var b;a="string"===typeof a?{name:a}:a;b=a.name;a.location&&
(p.paths[b]=a.location);p.pkgs[b]=a.name+"/"+(a.main||"main").replace(na,"").replace(U,"")});D(t,function(a,b){a.inited||a.map.unnormalized||(a.map=q(b,null,!0))});(a.deps||a.callback)&&l.require(a.deps||[],a.callback)},makeShimExports:function(a){return function(){var b;a.init&&(b=a.init.apply(ga,arguments));return b||a.exports&&ia(a.exports)}},makeRequire:function(a,n){function m(c,d,f){var e,r;n.enableBuildCallback&&d&&K(d)&&(d.__requireJsBuild=!0);if("string"===typeof c){if(K(d))return A(F("requireargs",
"Invalid require call"),f);if(a&&x(R,c))return R[c](t[a.id]);if(g.get)return g.get(l,c,a,m);e=q(c,a,!1,!0);e=e.id;return x(v,e)?v[e]:A(F("notloaded",'Module name "'+e+'" has not been loaded yet for context: '+b+(a?"":". Use require([])")))}P();l.nextTick(function(){P();r=u(q(null,a));r.skipMap=n.skipMap;r.init(c,d,f,{enabled:!0});H()});return m}n=n||{};Y(m,{isBrowser:E,toUrl:function(b){var d,f=b.lastIndexOf("."),g=b.split("/")[0];-1!==f&&("."!==g&&".."!==g||1<f)&&(d=b.substring(f,b.length),b=b.substring(0,
f));return l.nameToUrl(c(b,a&&a.id,!0),d,!0)},defined:function(b){return x(v,q(b,a,!1,!0).id)},specified:function(b){b=q(b,a,!1,!0).id;return x(v,b)||x(t,b)}});a||(m.undef=function(b){B();var c=q(b,a,!0),f=e(t,b);f.undefed=!0;d(b);delete v[b];delete W[c.url];delete ea[b];X(G,function(a,c){a[0]===b&&G.splice(c,1)});delete l.defQueueMap[b];f&&(f.events.defined&&(ea[b]=f.events),C(b))});return m},enable:function(a){e(t,a.id)&&u(a).enable()},completeLoad:function(a){var b,c,d=e(p.shim,a)||{},g=d.exports;
for(B();G.length;){c=G.shift();if(null===c[0]){c[0]=a;if(b)break;b=!0}else c[0]===a&&(b=!0);I(c)}l.defQueueMap={};c=e(t,a);if(!b&&!x(v,a)&&c&&!c.inited)if(!p.enforceDefine||g&&ia(g))I([a,d.deps||[],d.exportsFn]);else return m(a)?void 0:A(F("nodefine","No define call for "+a,null,[a]));H()},nameToUrl:function(a,b,c){var d,k,f,m;(d=e(p.pkgs,a))&&(a=d);if(d=e(fa,a))return l.nameToUrl(d,b,c);if(g.jsExtRegExp.test(a))d=a+(b||"");else{d=p.paths;k=a.split("/");for(f=k.length;0<f;--f)if(m=k.slice(0,f).join("/"),
m=e(d,m)){L(m)&&(m=m[0]);k.splice(0,f,m);break}d=k.join("/");d+=b||(/^data\:|^blob\:|\?/.test(d)||c?"":".js");d=("/"===d.charAt(0)||d.match(/^[\w\+\.\-]+:/)?"":p.baseUrl)+d}return p.urlArgs&&!/^blob\:/.test(d)?d+p.urlArgs(a,d):d},load:function(a,b){g.load(l,a,b)},execCb:function(a,b,c,d){return b.apply(d,c)},onScriptLoad:function(a){if("load"===a.type||oa.test((a.currentTarget||a.srcElement).readyState))N=null,a=O(a),l.completeLoad(a.id)},onScriptError:function(a){var b=O(a);if(!m(b.id)){var c=[];
D(t,function(a,d){0!==d.indexOf("_@r")&&y(a.depMaps,function(a){if(a.id===b.id)return c.push(d),!0})});return A(F("scripterror",'Script error for "'+b.id+(c.length?'", needed by: '+c.join(", "):'"'),a,[b.id]))}}};l.require=l.makeRequire();return l}function pa(){if(N&&"interactive"===N.readyState)return N;X(document.getElementsByTagName("script"),function(b){if("interactive"===b.readyState)return N=b});return N}var g,B,C,H,O,I,N,P,u,T,qa=/(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/mg,ra=/[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,
U=/\.js$/,na=/^\.\//;B=Object.prototype;var Q=B.toString,la=B.hasOwnProperty,E=!("undefined"===typeof window||"undefined"===typeof navigator||!window.document),ja=!E&&"undefined"!==typeof importScripts,oa=E&&"PLAYSTATION 3"===navigator.platform?/^complete$/:/^(complete|loaded)$/,ca="undefined"!==typeof opera&&"[object Opera]"===opera.toString(),J={},w={},V=[],S=!1;if("undefined"===typeof define){if("undefined"!==typeof requirejs){if(K(requirejs))return;w=requirejs;requirejs=void 0}"undefined"===typeof require||
K(require)||(w=require,require=void 0);g=requirejs=function(b,c,d,m){var r,q="_";L(b)||"string"===typeof b||(r=b,L(c)?(b=c,c=d,d=m):b=[]);r&&r.context&&(q=r.context);(m=e(J,q))||(m=J[q]=g.s.newContext(q));r&&m.configure(r);return m.require(b,c,d)};g.config=function(b){return g(b)};g.nextTick="undefined"!==typeof setTimeout?function(b){setTimeout(b,4)}:function(b){b()};require||(require=g);g.version="2.2.0";g.jsExtRegExp=/^\/|:|\?|\.js$/;g.isBrowser=E;B=g.s={contexts:J,newContext:ma};g({});y(["toUrl",
"undef","defined","specified"],function(b){g[b]=function(){var c=J._;return c.require[b].apply(c,arguments)}});E&&(C=B.head=document.getElementsByTagName("head")[0],H=document.getElementsByTagName("base")[0])&&(C=B.head=H.parentNode);g.onError=ha;g.createNode=function(b,c,d){c=b.xhtml?document.createElementNS("http://www.w3.org/1999/xhtml","html:script"):document.createElement("script");c.type=b.scriptType||"text/javascript";c.charset="utf-8";c.async=!0;return c};g.load=function(b,c,d){var m=b&&b.config||
{},e;if(E){e=g.createNode(m,c,d);e.setAttribute("data-requirecontext",b.contextName);e.setAttribute("data-requiremodule",c);!e.attachEvent||e.attachEvent.toString&&0>e.attachEvent.toString().indexOf("[native code")||ca?(e.addEventListener("load",b.onScriptLoad,!1),e.addEventListener("error",b.onScriptError,!1)):(S=!0,e.attachEvent("onreadystatechange",b.onScriptLoad));e.src=d;if(m.onNodeCreated)m.onNodeCreated(e,m,c,d);P=e;H?C.insertBefore(e,H):C.appendChild(e);P=null;return e}if(ja)try{setTimeout(function(){},
0),importScripts(d),b.completeLoad(c)}catch(q){b.onError(F("importscripts","importScripts failed for "+c+" at "+d,q,[c]))}};E&&!w.skipDataMain&&X(document.getElementsByTagName("script"),function(b){C||(C=b.parentNode);if(O=b.getAttribute("data-main"))return u=O,w.baseUrl||-1!==u.indexOf("!")||(I=u.split("/"),u=I.pop(),T=I.length?I.join("/")+"/":"./",w.baseUrl=T),u=u.replace(U,""),g.jsExtRegExp.test(u)&&(u=O),w.deps=w.deps?w.deps.concat(u):[u],!0});define=function(b,c,d){var e,g;"string"!==typeof b&&
(d=c,c=b,b=null);L(c)||(d=c,c=null);!c&&K(d)&&(c=[],d.length&&(d.toString().replace(qa,ka).replace(ra,function(b,d){c.push(d)}),c=(1===d.length?["require"]:["require","exports","module"]).concat(c)));S&&(e=P||pa())&&(b||(b=e.getAttribute("data-requiremodule")),g=J[e.getAttribute("data-requirecontext")]);g?(g.defQueue.push([b,c,d]),g.defQueueMap[b]=!0):V.push([b,c,d])};define.amd={jQuery:!0};g.exec=function(b){return eval(b)};g(w)}})(this);

window.whatInput = (function() {

  'use strict';

  /*
    ---------------
    variables
    ---------------
  */

  // array of actively pressed keys
  var activeKeys = [];

  // cache document.body
  var body;

  // boolean: true if touch buffer timer is running
  var buffer = false;

  // the last used input type
  var currentInput = null;

  // `input` types that don't accept text
  var nonTypingInputs = [
    'button',
    'checkbox',
    'file',
    'image',
    'radio',
    'reset',
    'submit'
  ];

  // detect version of mouse wheel event to use
  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
  var mouseWheel = detectWheel();

  // list of modifier keys commonly used with the mouse and
  // can be safely ignored to prevent false keyboard detection
  var ignoreMap = [
    16, // shift
    17, // control
    18, // alt
    91, // Windows key / left Apple cmd
    93  // Windows menu / right Apple cmd
  ];

  // mapping of events to input types
  var inputMap = {
    'keydown': 'keyboard',
    'keyup': 'keyboard',
    'mousedown': 'mouse',
    'mousemove': 'mouse',
    'MSPointerDown': 'pointer',
    'MSPointerMove': 'pointer',
    'pointerdown': 'pointer',
    'pointermove': 'pointer',
    'touchstart': 'touch'
  };

  // add correct mouse wheel event mapping to `inputMap`
  inputMap[detectWheel()] = 'mouse';

  // array of all used input types
  var inputTypes = [];

  // mapping of key codes to a common name
  var keyMap = {
    9: 'tab',
    13: 'enter',
    16: 'shift',
    27: 'esc',
    32: 'space',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down'
  };

  // map of IE 10 pointer events
  var pointerMap = {
    2: 'touch',
    3: 'touch', // treat pen like touch
    4: 'mouse'
  };

  // touch buffer timer
  var timer;


  /*
    ---------------
    functions
    ---------------
  */

  // allows events that are also triggered to be filtered out for `touchstart`
  function eventBuffer() {
    clearTimer();
    setInput(event);

    buffer = true;
    timer = window.setTimeout(function() {
      buffer = false;
    }, 650);
  }

  function bufferedEvent(event) {
    if (!buffer) setInput(event);
  }

  function unBufferedEvent(event) {
    clearTimer();
    setInput(event);
  }

  function clearTimer() {
    window.clearTimeout(timer);
  }

  function setInput(event) {
    var eventKey = key(event);
    var value = inputMap[event.type];
    if (value === 'pointer') value = pointerType(event);

    // don't do anything if the value matches the input type already set
    if (currentInput !== value) {
      var eventTarget = target(event);
      var eventTargetNode = eventTarget.nodeName.toLowerCase();
      var eventTargetType = (eventTargetNode === 'input') ? eventTarget.getAttribute('type') : null;

      if (
        (// only if the user flag to allow typing in form fields isn't set
        !body.hasAttribute('data-whatinput-formtyping') &&

        // only if currentInput has a value
        currentInput &&

        // only if the input is `keyboard`
        value === 'keyboard' &&

        // not if the key is `TAB`
        keyMap[eventKey] !== 'tab' &&

        // only if the target is a form input that accepts text
        (
           eventTargetNode === 'textarea' ||
           eventTargetNode === 'select' ||
           (eventTargetNode === 'input' && nonTypingInputs.indexOf(eventTargetType) < 0)
        )) || (
          // ignore modifier keys
          ignoreMap.indexOf(eventKey) > -1
        )
      ) {
        // ignore keyboard typing
      } else {
        switchInput(value);
      }
    }

    if (value === 'keyboard') logKeys(eventKey);
  }

  function switchInput(string) {
    currentInput = string;
    body.setAttribute('data-whatinput', currentInput);

    if (inputTypes.indexOf(currentInput) === -1) inputTypes.push(currentInput);
  }

  function key(event) {
    return (event.keyCode) ? event.keyCode : event.which;
  }

  function target(event) {
    return event.target || event.srcElement;
  }

  function pointerType(event) {
    if (typeof event.pointerType === 'number') {
      return pointerMap[event.pointerType];
    } else {
      return (event.pointerType === 'pen') ? 'touch' : event.pointerType; // treat pen like touch
    }
  }

  // keyboard logging
  function logKeys(eventKey) {
    if (activeKeys.indexOf(keyMap[eventKey]) === -1 && keyMap[eventKey]) activeKeys.push(keyMap[eventKey]);
  }

  function unLogKeys(event) {
    var eventKey = key(event);
    var arrayPos = activeKeys.indexOf(keyMap[eventKey]);

    if (arrayPos !== -1) activeKeys.splice(arrayPos, 1);
  }

  function bindEvents() {
    body = document.body;

    // pointer events (mouse, pen, touch)
    if (window.PointerEvent) {
      body.addEventListener('pointerdown', bufferedEvent);
      body.addEventListener('pointermove', bufferedEvent);
    } else if (window.MSPointerEvent) {
      body.addEventListener('MSPointerDown', bufferedEvent);
      body.addEventListener('MSPointerMove', bufferedEvent);
    } else {

      // mouse events
      body.addEventListener('mousedown', bufferedEvent);
      body.addEventListener('mousemove', bufferedEvent);

      // touch events
      if ('ontouchstart' in window) {
        body.addEventListener('touchstart', eventBuffer);
      }
    }

    // mouse wheel
    body.addEventListener(mouseWheel, bufferedEvent);

    // keyboard events
    body.addEventListener('keydown', unBufferedEvent);
    body.addEventListener('keyup', unBufferedEvent);
    document.addEventListener('keyup', unLogKeys);
  }


  /*
    ---------------
    utilities
    ---------------
  */

  // detect version of mouse wheel event to use
  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
  function detectWheel() {
    return mouseWheel = 'onwheel' in document.createElement('div') ?
      'wheel' : // Modern browsers support "wheel"

      document.onmousewheel !== undefined ?
        'mousewheel' : // Webkit and IE support at least "mousewheel"
        'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
  }


  /*
    ---------------
    init
    don't start script unless browser cuts the mustard,
    also passes if polyfills are used
    ---------------
  */

  if (
    'addEventListener' in window &&
    Array.prototype.indexOf
  ) {

    // if the dom is already ready already (script was placed at bottom of <body>)
    if (document.body) {
      bindEvents();

    // otherwise wait for the dom to load (script was placed in the <head>)
    } else {
      document.addEventListener('DOMContentLoaded', bindEvents);
    }
  }


  /*
    ---------------
    api
    ---------------
  */

  return {

    // returns string: the current input type
    ask: function() { return currentInput; },

    // returns array: currently pressed keys
    keys: function() { return activeKeys; },

    // returns array: all the detected input types
    types: function() { return inputTypes; },

    // accepts string: manually set the input type
    set: switchInput
  };

}());

/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
/*! Gecko-Picture - v1.0
 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
 * Firefox's early picture implementation (prior to FF41) is static and does
 * not react to viewport changes. This tiny module fixes this.
 */
(function(window) {
	/*jshint eqnull:true */
	var ua = navigator.userAgent;

	if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
		addEventListener("resize", (function() {
			var timer;

			var dummySrc = document.createElement("source");

			var fixRespimg = function(img) {
				var source, sizes;
				var picture = img.parentNode;

				if (picture.nodeName.toUpperCase() === "PICTURE") {
					source = dummySrc.cloneNode();

					picture.insertBefore(source, picture.firstElementChild);
					setTimeout(function() {
						picture.removeChild(source);
					});
				} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
					img._pfLastSize = img.offsetWidth;
					sizes = img.sizes;
					img.sizes += ",100vw";
					setTimeout(function() {
						img.sizes = sizes;
					});
				}
			};

			var findPictureImgs = function() {
				var i;
				var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
				for (i = 0; i < imgs.length; i++) {
					fixRespimg(imgs[i]);
				}
			};
			var onResize = function() {
				clearTimeout(timer);
				timer = setTimeout(findPictureImgs, 99);
			};
			var mq = window.matchMedia && matchMedia("(orientation: landscape)");
			var init = function() {
				onResize();

				if (mq && mq.addListener) {
					mq.addListener(onResize);
				}
			};

			dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

			if (/^[c|i]|d$/.test(document.readyState || "")) {
				init();
			} else {
				document.addEventListener("DOMContentLoaded", init);
			}

			return onResize;
		})());
	}
})(window);

/*! Picturefill - v3.0.2
 * http://scottjehl.github.io/picturefill
 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
 *  License: MIT
 */

(function( window, document, undefined ) {
	// Enable strict mode
	"use strict";

	// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
	document.createElement( "picture" );

	var warn, eminpx, alwaysCheckWDescriptor, evalId;
	// local object for method references and testing exposure
	var pf = {};
	var isSupportTestReady = false;
	var noop = function() {};
	var image = document.createElement( "img" );
	var getImgAttr = image.getAttribute;
	var setImgAttr = image.setAttribute;
	var removeImgAttr = image.removeAttribute;
	var docElem = document.documentElement;
	var types = {};
	var cfg = {
		//resource selection:
		algorithm: ""
	};
	var srcAttr = "data-pfsrc";
	var srcsetAttr = srcAttr + "set";
	// ua sniffing is done for undetectable img loading features,
	// to do some non crucial perf optimizations
	var ua = navigator.userAgent;
	var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
	var curSrcProp = "currentSrc";
	var regWDesc = /\s+\+?\d+(e\d+)?w/;
	var regSize = /(\([^)]+\))?\s*(.+)/;
	var setOptions = window.picturefillCFG;
	/**
	 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
	 */
	// baseStyle also used by getEmValue (i.e.: width: 1em is important)
	var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
	var fsCss = "font-size:100%!important;";
	var isVwDirty = true;

	var cssCache = {};
	var sizeLengthCache = {};
	var DPR = window.devicePixelRatio;
	var units = {
		px: 1,
		"in": 96
	};
	var anchor = document.createElement( "a" );
	/**
	 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
	 * @type {boolean}
	 */
	var alreadyRun = false;

	// Reusable, non-"g" Regexes

	// (Don't use \s, to avoid matching non-breaking space.)
	var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
	    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
	    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
	    regexTrailingCommas = /[,]+$/,
	    regexNonNegativeInteger = /^\d+$/,

	    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
	    // Must include at least one digit.
	    // According to spec tests any decimal point must be followed by a digit.
	    // No leading plus sign is allowed.)
	    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
	    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;

	var on = function(obj, evt, fn, capture) {
		if ( obj.addEventListener ) {
			obj.addEventListener(evt, fn, capture || false);
		} else if ( obj.attachEvent ) {
			obj.attachEvent( "on" + evt, fn);
		}
	};

	/**
	 * simple memoize function:
	 */

	var memoize = function(fn) {
		var cache = {};
		return function(input) {
			if ( !(input in cache) ) {
				cache[ input ] = fn(input);
			}
			return cache[ input ];
		};
	};

	// UTILITY FUNCTIONS

	// Manual is faster than RegEx
	// http://jsperf.com/whitespace-character/5
	function isSpace(c) {
		return (c === "\u0020" || // space
		        c === "\u0009" || // horizontal tab
		        c === "\u000A" || // new line
		        c === "\u000C" || // form feed
		        c === "\u000D");  // carriage return
	}

	/**
	 * gets a mediaquery and returns a boolean or gets a css length and returns a number
	 * @param css mediaqueries or css length
	 * @returns {boolean|number}
	 *
	 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
	 */
	var evalCSS = (function() {

		var regLength = /^([\d\.]+)(em|vw|px)$/;
		var replace = function() {
			var args = arguments, index = 0, string = args[0];
			while (++index in args) {
				string = string.replace(args[index], args[++index]);
			}
			return string;
		};

		var buildStr = memoize(function(css) {

			return "return " + replace((css || "").toLowerCase(),
				// interpret `and`
				/\band\b/g, "&&",

				// interpret `,`
				/,/g, "||",

				// interpret `min-` as >=
				/min-([a-z-\s]+):/g, "e.$1>=",

				// interpret `max-` as <=
				/max-([a-z-\s]+):/g, "e.$1<=",

				//calc value
				/calc([^)]+)/g, "($1)",

				// interpret css values
				/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
				//make eval less evil
				/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
			) + ";";
		});

		return function(css, length) {
			var parsedLength;
			if (!(css in cssCache)) {
				cssCache[css] = false;
				if (length && (parsedLength = css.match( regLength ))) {
					cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
				} else {
					/*jshint evil:true */
					try{
						cssCache[css] = new Function("e", buildStr(css))(units);
					} catch(e) {}
					/*jshint evil:false */
				}
			}
			return cssCache[css];
		};
	})();

	var setResolution = function( candidate, sizesattr ) {
		if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
			candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
			candidate.res = candidate.w / candidate.cWidth ;
		} else {
			candidate.res = candidate.d;
		}
		return candidate;
	};

	/**
	 *
	 * @param opt
	 */
	var picturefill = function( opt ) {

		if (!isSupportTestReady) {return;}

		var elements, i, plen;

		var options = opt || {};

		if ( options.elements && options.elements.nodeType === 1 ) {
			if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
				options.elements =  [ options.elements ];
			} else {
				options.context = options.elements;
				options.elements =  null;
			}
		}

		elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );

		if ( (plen = elements.length) ) {

			pf.setupRun( options );
			alreadyRun = true;

			// Loop through all elements
			for ( i = 0; i < plen; i++ ) {
				pf.fillImg(elements[ i ], options);
			}

			pf.teardownRun( options );
		}
	};

	/**
	 * outputs a warning for the developer
	 * @param {message}
	 * @type {Function}
	 */
	warn = ( window.console && console.warn ) ?
		function( message ) {
			console.warn( message );
		} :
		noop
	;

	if ( !(curSrcProp in image) ) {
		curSrcProp = "src";
	}

	// Add support for standard mime types.
	types[ "image/jpeg" ] = true;
	types[ "image/gif" ] = true;
	types[ "image/png" ] = true;

	function detectTypeSupport( type, typeUri ) {
		// based on Modernizr's lossless img-webp test
		// note: asynchronous
		var image = new window.Image();
		image.onerror = function() {
			types[ type ] = false;
			picturefill();
		};
		image.onload = function() {
			types[ type ] = image.width === 1;
			picturefill();
		};
		image.src = typeUri;
		return "pending";
	}

	// test svg support
	types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );

	/**
	 * updates the internal vW property with the current viewport width in px
	 */
	function updateMetrics() {

		isVwDirty = false;
		DPR = window.devicePixelRatio;
		cssCache = {};
		sizeLengthCache = {};

		pf.DPR = DPR || 1;

		units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
		units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);

		units.vw = units.width / 100;
		units.vh = units.height / 100;

		evalId = [ units.height, units.width, DPR ].join("-");

		units.em = pf.getEmValue();
		units.rem = units.em;
	}

	function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
		var bonusFactor, tooMuch, bonus, meanDensity;

		//experimental
		if (cfg.algorithm === "saveData" ){
			if ( lowerValue > 2.7 ) {
				meanDensity = dprValue + 1;
			} else {
				tooMuch = higherValue - dprValue;
				bonusFactor = Math.pow(lowerValue - 0.6, 1.5);

				bonus = tooMuch * bonusFactor;

				if (isCached) {
					bonus += 0.1 * bonusFactor;
				}

				meanDensity = lowerValue + bonus;
			}
		} else {
			meanDensity = (dprValue > 1) ?
				Math.sqrt(lowerValue * higherValue) :
				lowerValue;
		}

		return meanDensity > dprValue;
	}

	function applyBestCandidate( img ) {
		var srcSetCandidates;
		var matchingSet = pf.getSet( img );
		var evaluated = false;
		if ( matchingSet !== "pending" ) {
			evaluated = evalId;
			if ( matchingSet ) {
				srcSetCandidates = pf.setRes( matchingSet );
				pf.applySetCandidate( srcSetCandidates, img );
			}
		}
		img[ pf.ns ].evaled = evaluated;
	}

	function ascendingSort( a, b ) {
		return a.res - b.res;
	}

	function setSrcToCur( img, src, set ) {
		var candidate;
		if ( !set && src ) {
			set = img[ pf.ns ].sets;
			set = set && set[set.length - 1];
		}

		candidate = getCandidateForSrc(src, set);

		if ( candidate ) {
			src = pf.makeUrl(src);
			img[ pf.ns ].curSrc = src;
			img[ pf.ns ].curCan = candidate;

			if ( !candidate.res ) {
				setResolution( candidate, candidate.set.sizes );
			}
		}
		return candidate;
	}

	function getCandidateForSrc( src, set ) {
		var i, candidate, candidates;
		if ( src && set ) {
			candidates = pf.parseSet( set );
			src = pf.makeUrl(src);
			for ( i = 0; i < candidates.length; i++ ) {
				if ( src === pf.makeUrl(candidates[ i ].url) ) {
					candidate = candidates[ i ];
					break;
				}
			}
		}
		return candidate;
	}

	function getAllSourceElements( picture, candidates ) {
		var i, len, source, srcset;

		// SPEC mismatch intended for size and perf:
		// actually only source elements preceding the img should be used
		// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
		var sources = picture.getElementsByTagName( "source" );

		for ( i = 0, len = sources.length; i < len; i++ ) {
			source = sources[ i ];
			source[ pf.ns ] = true;
			srcset = source.getAttribute( "srcset" );

			// if source does not have a srcset attribute, skip
			if ( srcset ) {
				candidates.push( {
					srcset: srcset,
					media: source.getAttribute( "media" ),
					type: source.getAttribute( "type" ),
					sizes: source.getAttribute( "sizes" )
				} );
			}
		}
	}

	/**
	 * Srcset Parser
	 * By Alex Bell |  MIT License
	 *
	 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
	 *
	 * Based super duper closely on the reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
	 */

	// 1. Let input be the value passed to this algorithm.
	// (TO-DO : Explain what "set" argument is here. Maybe choose a more
	// descriptive & more searchable name.  Since passing the "set" in really has
	// nothing to do with parsing proper, I would prefer this assignment eventually
	// go in an external fn.)
	function parseSrcset(input, set) {

		function collectCharacters(regEx) {
			var chars,
			    match = regEx.exec(input.substring(pos));
			if (match) {
				chars = match[ 0 ];
				pos += chars.length;
				return chars;
			}
		}

		var inputLength = input.length,
		    url,
		    descriptors,
		    currentDescriptor,
		    state,
		    c,

		    // 2. Let position be a pointer into input, initially pointing at the start
		    //    of the string.
		    pos = 0,

		    // 3. Let candidates be an initially empty source set.
		    candidates = [];

		/**
		* Adds descriptor properties to a candidate, pushes to the candidates array
		* @return undefined
		*/
		// (Declared outside of the while loop so that it's only created once.
		// (This fn is defined before it is used, in order to pass JSHINT.
		// Unfortunately this breaks the sequencing of the spec comments. :/ )
		function parseDescriptors() {

			// 9. Descriptor parser: Let error be no.
			var pError = false,

			// 10. Let width be absent.
			// 11. Let density be absent.
			// 12. Let future-compat-h be absent. (We're implementing it now as h)
			    w, d, h, i,
			    candidate = {},
			    desc, lastChar, value, intVal, floatVal;

			// 13. For each descriptor in descriptors, run the appropriate set of steps
			// from the following list:
			for (i = 0 ; i < descriptors.length; i++) {
				desc = descriptors[ i ];

				lastChar = desc[ desc.length - 1 ];
				value = desc.substring(0, desc.length - 1);
				intVal = parseInt(value, 10);
				floatVal = parseFloat(value);

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0077 LATIN SMALL LETTER W character
				if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

					// If width and density are not both absent, then let error be yes.
					if (w || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes.
					// Otherwise, let width be the result.
					if (intVal === 0) {pError = true;} else {w = intVal;}

				// If the descriptor consists of a valid floating-point number followed by
				// a U+0078 LATIN SMALL LETTER X character
				} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

					// If width, density and future-compat-h are not all absent, then let error
					// be yes.
					if (w || d || h) {pError = true;}

					// Apply the rules for parsing floating-point number values to the descriptor.
					// If the result is less than zero, let error be yes. Otherwise, let density
					// be the result.
					if (floatVal < 0) {pError = true;} else {d = floatVal;}

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0068 LATIN SMALL LETTER H character
				} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

					// If height and density are not both absent, then let error be yes.
					if (h || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes. Otherwise, let future-compat-h
					// be the result.
					if (intVal === 0) {pError = true;} else {h = intVal;}

				// Anything else, Let error be yes.
				} else {pError = true;}
			} // (close step 13 for loop)

			// 15. If error is still no, then append a new image source to candidates whose
			// URL is url, associated with a width width if not absent and a pixel
			// density density if not absent. Otherwise, there is a parse error.
			if (!pError) {
				candidate.url = url;

				if (w) { candidate.w = w;}
				if (d) { candidate.d = d;}
				if (h) { candidate.h = h;}
				if (!h && !d && !w) {candidate.d = 1;}
				if (candidate.d === 1) {set.has1x = true;}
				candidate.set = set;

				candidates.push(candidate);
			}
		} // (close parseDescriptors fn)

		/**
		* Tokenizes descriptor properties prior to parsing
		* Returns undefined.
		* (Again, this fn is defined before it is used, in order to pass JSHINT.
		* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
		*/
		function tokenize() {

			// 8.1. Descriptor tokeniser: Skip whitespace
			collectCharacters(regexLeadingSpaces);

			// 8.2. Let current descriptor be the empty string.
			currentDescriptor = "";

			// 8.3. Let state be in descriptor.
			state = "in descriptor";

			while (true) {

				// 8.4. Let c be the character at position.
				c = input.charAt(pos);

				//  Do the following depending on the value of state.
				//  For the purpose of this step, "EOF" is a special character representing
				//  that position is past the end of input.

				// In descriptor
				if (state === "in descriptor") {
					// Do the following, depending on the value of c:

				  // Space character
				  // If current descriptor is not empty, append current descriptor to
				  // descriptors and let current descriptor be the empty string.
				  // Set state to after descriptor.
					if (isSpace(c)) {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
							currentDescriptor = "";
							state = "after descriptor";
						}

					// U+002C COMMA (,)
					// Advance position to the next character in input. If current descriptor
					// is not empty, append current descriptor to descriptors. Jump to the step
					// labeled descriptor parser.
					} else if (c === ",") {
						pos += 1;
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// U+0028 LEFT PARENTHESIS (()
					// Append c to current descriptor. Set state to in parens.
					} else if (c === "\u0028") {
						currentDescriptor = currentDescriptor + c;
						state = "in parens";

					// EOF
					// If current descriptor is not empty, append current descriptor to
					// descriptors. Jump to the step labeled descriptor parser.
					} else if (c === "") {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}
				// (end "in descriptor"

				// In parens
				} else if (state === "in parens") {

					// U+0029 RIGHT PARENTHESIS ())
					// Append c to current descriptor. Set state to in descriptor.
					if (c === ")") {
						currentDescriptor = currentDescriptor + c;
						state = "in descriptor";

					// EOF
					// Append current descriptor to descriptors. Jump to the step labeled
					// descriptor parser.
					} else if (c === "") {
						descriptors.push(currentDescriptor);
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}

				// After descriptor
				} else if (state === "after descriptor") {

					// Do the following, depending on the value of c:
					// Space character: Stay in this state.
					if (isSpace(c)) {

					// EOF: Jump to the step labeled descriptor parser.
					} else if (c === "") {
						parseDescriptors();
						return;

					// Anything else
					// Set state to in descriptor. Set position to the previous character in input.
					} else {
						state = "in descriptor";
						pos -= 1;

					}
				}

				// Advance position to the next character in input.
				pos += 1;

			// Repeat this step.
			} // (close while true loop)
		}

		// 4. Splitting loop: Collect a sequence of characters that are space
		//    characters or U+002C COMMA characters. If any U+002C COMMA characters
		//    were collected, that is a parse error.
		while (true) {
			collectCharacters(regexLeadingCommasOrSpaces);

			// 5. If position is past the end of input, return candidates and abort these steps.
			if (pos >= inputLength) {
				return candidates; // (we're done, this is the sole return path)
			}

			// 6. Collect a sequence of characters that are not space characters,
			//    and let that be url.
			url = collectCharacters(regexLeadingNotSpaces);

			// 7. Let descriptors be a new empty list.
			descriptors = [];

			// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
			//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
			//         more than one character, that is a parse error.
			if (url.slice(-1) === ",") {
				url = url.replace(regexTrailingCommas, "");
				// (Jump ahead to step 9 to skip tokenization and just push the candidate).
				parseDescriptors();

			//	Otherwise, follow these substeps:
			} else {
				tokenize();
			} // (close else of step 8)

		// 16. Return to the step labeled splitting loop.
		} // (Close of big while loop.)
	}

	/*
	 * Sizes Parser
	 *
	 * By Alex Bell |  MIT License
	 *
	 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
	 *
	 * Reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
	 *
	 * Most comments are copied in directly from the spec
	 * (except for comments in parens).
	 *
	 * Grammar is:
	 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
	 * <source-size> = <media-condition> <source-size-value>
	 * <source-size-value> = <length>
	 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
	 *
	 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
	 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
	 *
	 * Returns the first valid <css-length> with a media condition that evaluates to true,
	 * or "100vw" if all valid media conditions evaluate to false.
	 *
	 */

	function parseSizes(strValue) {

		// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
		// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
		// CSS allows a single optional plus or minus sign:
		// http://www.w3.org/TR/CSS2/syndata.html#numbers
		// CSS is ASCII case-insensitive:
		// http://www.w3.org/TR/CSS2/syndata.html#characters )
		// Spec allows exponential notation for <number> type:
		// http://dev.w3.org/csswg/css-values/#numbers
		var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;

		// (This is a quick and lenient test. Because of optional unlimited-depth internal
		// grouping parens and strict spacing rules, this could get very complicated.)
		var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;

		var i;
		var unparsedSizesList;
		var unparsedSizesListLength;
		var unparsedSize;
		var lastComponentValue;
		var size;

		// UTILITY FUNCTIONS

		//  (Toy CSS parser. The goals here are:
		//  1) expansive test coverage without the weight of a full CSS parser.
		//  2) Avoiding regex wherever convenient.
		//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
		//  Returns an array of arrays.)
		function parseComponentValues(str) {
			var chrctr;
			var component = "";
			var componentArray = [];
			var listArray = [];
			var parenDepth = 0;
			var pos = 0;
			var inComment = false;

			function pushComponent() {
				if (component) {
					componentArray.push(component);
					component = "";
				}
			}

			function pushComponentArray() {
				if (componentArray[0]) {
					listArray.push(componentArray);
					componentArray = [];
				}
			}

			// (Loop forwards from the beginning of the string.)
			while (true) {
				chrctr = str.charAt(pos);

				if (chrctr === "") { // ( End of string reached.)
					pushComponent();
					pushComponentArray();
					return listArray;
				} else if (inComment) {
					if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
						inComment = false;
						pos += 2;
						pushComponent();
						continue;
					} else {
						pos += 1; // (Skip all characters inside comments.)
						continue;
					}
				} else if (isSpace(chrctr)) {
					// (If previous character in loop was also a space, or if
					// at the beginning of the string, do not add space char to
					// component.)
					if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
						pos += 1;
						continue;
					} else if (parenDepth === 0) {
						pushComponent();
						pos +=1;
						continue;
					} else {
						// (Replace any space character with a plain space for legibility.)
						chrctr = " ";
					}
				} else if (chrctr === "(") {
					parenDepth += 1;
				} else if (chrctr === ")") {
					parenDepth -= 1;
				} else if (chrctr === ",") {
					pushComponent();
					pushComponentArray();
					pos += 1;
					continue;
				} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
					inComment = true;
					pos += 2;
					continue;
				}

				component = component + chrctr;
				pos += 1;
			}
		}

		function isValidNonNegativeSourceSizeValue(s) {
			if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
			if (regexCssCalc.test(s)) {return true;}
			// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
			// "-0 is equivalent to 0 and is not a negative number." which means that
			// unitless zero and unitless negative zero must be accepted as special cases.)
			if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
			return false;
		}

		// When asked to parse a sizes attribute from an element, parse a
		// comma-separated list of component values from the value of the element's
		// sizes attribute (or the empty string, if the attribute is absent), and let
		// unparsed sizes list be the result.
		// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values

		unparsedSizesList = parseComponentValues(strValue);
		unparsedSizesListLength = unparsedSizesList.length;

		// For each unparsed size in unparsed sizes list:
		for (i = 0; i < unparsedSizesListLength; i++) {
			unparsedSize = unparsedSizesList[i];

			// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
			// ( parseComponentValues() already omits spaces outside of parens. )

			// If unparsed size is now empty, that is a parse error; continue to the next
			// iteration of this algorithm.
			// ( parseComponentValues() won't push an empty array. )

			// 2. If the last component value in unparsed size is a valid non-negative
			// <source-size-value>, let size be its value and remove the component value
			// from unparsed size. Any CSS function other than the calc() function is
			// invalid. Otherwise, there is a parse error; continue to the next iteration
			// of this algorithm.
			// http://dev.w3.org/csswg/css-syntax/#parse-component-value
			lastComponentValue = unparsedSize[unparsedSize.length - 1];

			if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
				size = lastComponentValue;
				unparsedSize.pop();
			} else {
				continue;
			}

			// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
			// size. If unparsed size is now empty, return size and exit this algorithm.
			// If this was not the last item in unparsed sizes list, that is a parse error.
			if (unparsedSize.length === 0) {
				return size;
			}

			// 4. Parse the remaining component values in unparsed size as a
			// <media-condition>. If it does not parse correctly, or it does parse
			// correctly but the <media-condition> evaluates to false, continue to the
			// next iteration of this algorithm.
			// (Parsing all possible compound media conditions in JS is heavy, complicated,
			// and the payoff is unclear. Is there ever an situation where the
			// media condition parses incorrectly but still somehow evaluates to true?
			// Can we just rely on the browser/polyfill to do it?)
			unparsedSize = unparsedSize.join(" ");
			if (!(pf.matchesMedia( unparsedSize ) ) ) {
				continue;
			}

			// 5. Return size and exit this algorithm.
			return size;
		}

		// If the above algorithm exhausts unparsed sizes list without returning a
		// size value, return 100vw.
		return "100vw";
	}

	// namespace
	pf.ns = ("pf" + new Date().getTime()).substr(0, 9);

	// srcset support test
	pf.supSrcset = "srcset" in image;
	pf.supSizes = "sizes" in image;
	pf.supPicture = !!window.HTMLPictureElement;

	// UC browser does claim to support srcset and picture, but not sizes,
	// this extended test reveals the browser does support nothing
	if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
		(function(image2) {
			image.srcset = "data:,a";
			image2.src = "data:,a";
			pf.supSrcset = image.complete === image2.complete;
			pf.supPicture = pf.supSrcset && pf.supPicture;
		})(document.createElement("img"));
	}

	// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
	if (pf.supSrcset && !pf.supSizes) {

		(function() {
			var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
			var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
			var img = document.createElement("img");
			var test = function() {
				var width = img.width;

				if (width === 2) {
					pf.supSizes = true;
				}

				alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;

				isSupportTestReady = true;
				// force async
				setTimeout(picturefill);
			};

			img.onload = test;
			img.onerror = test;
			img.setAttribute("sizes", "9px");

			img.srcset = width1 + " 1w," + width2 + " 9w";
			img.src = width1;
		})();

	} else {
		isSupportTestReady = true;
	}

	// using pf.qsa instead of dom traversing does scale much better,
	// especially on sites mixing responsive and non-responsive images
	pf.selShort = "picture>img,img[srcset]";
	pf.sel = pf.selShort;
	pf.cfg = cfg;

	/**
	 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
	 */
	pf.DPR = (DPR  || 1 );
	pf.u = units;

	// container of supported mime types that one might need to qualify before using
	pf.types =  types;

	pf.setSize = noop;

	/**
	 * Gets a string and returns the absolute URL
	 * @param src
	 * @returns {String} absolute URL
	 */

	pf.makeUrl = memoize(function(src) {
		anchor.href = src;
		return anchor.href;
	});

	/**
	 * Gets a DOM element or document and a selctor and returns the found matches
	 * Can be extended with jQuery/Sizzle for IE7 support
	 * @param context
	 * @param sel
	 * @returns {NodeList|Array}
	 */
	pf.qsa = function(context, sel) {
		return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
	};

	/**
	 * Shortcut method for matchMedia ( for easy overriding in tests )
	 * wether native or pf.mMQ is used will be decided lazy on first call
	 * @returns {boolean}
	 */
	pf.matchesMedia = function() {
		if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
			pf.matchesMedia = function( media ) {
				return !media || ( matchMedia( media ).matches );
			};
		} else {
			pf.matchesMedia = pf.mMQ;
		}

		return pf.matchesMedia.apply( this, arguments );
	};

	/**
	 * A simplified matchMedia implementation for IE8 and IE9
	 * handles only min-width/max-width with px or em values
	 * @param media
	 * @returns {boolean}
	 */
	pf.mMQ = function( media ) {
		return media ? evalCSS(media) : true;
	};

	/**
	 * Returns the calculated length in css pixel from the given sourceSizeValue
	 * http://dev.w3.org/csswg/css-values-3/#length-value
	 * intended Spec mismatches:
	 * * Does not check for invalid use of CSS functions
	 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
	 * @param sourceSizeValue
	 * @returns {Number}
	 */
	pf.calcLength = function( sourceSizeValue ) {

		var value = evalCSS(sourceSizeValue, true) || false;
		if (value < 0) {
			value = false;
		}

		return value;
	};

	/**
	 * Takes a type string and checks if its supported
	 */

	pf.supportsType = function( type ) {
		return ( type ) ? types[ type ] : true;
	};

	/**
	 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
	 * @param sourceSizeStr
	 * @returns {*}
	 */
	pf.parseSize = memoize(function( sourceSizeStr ) {
		var match = ( sourceSizeStr || "" ).match(regSize);
		return {
			media: match && match[1],
			length: match && match[2]
		};
	});

	pf.parseSet = function( set ) {
		if ( !set.cands ) {
			set.cands = parseSrcset(set.srcset, set);
		}
		return set.cands;
	};

	/**
	 * returns 1em in css px for html/body default size
	 * function taken from respondjs
	 * @returns {*|number}
	 */
	pf.getEmValue = function() {
		var body;
		if ( !eminpx && (body = document.body) ) {
			var div = document.createElement( "div" ),
				originalHTMLCSS = docElem.style.cssText,
				originalBodyCSS = body.style.cssText;

			div.style.cssText = baseStyle;

			// 1em in a media query is the value of the default font size of the browser
			// reset docElem and body to ensure the correct value is returned
			docElem.style.cssText = fsCss;
			body.style.cssText = fsCss;

			body.appendChild( div );
			eminpx = div.offsetWidth;
			body.removeChild( div );

			//also update eminpx before returning
			eminpx = parseFloat( eminpx, 10 );

			// restore the original values
			docElem.style.cssText = originalHTMLCSS;
			body.style.cssText = originalBodyCSS;

		}
		return eminpx || 16;
	};

	/**
	 * Takes a string of sizes and returns the width in pixels as a number
	 */
	pf.calcListLength = function( sourceSizeListStr ) {
		// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
		//
		//                           or (min-width:30em) calc(30% - 15px)
		if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
			var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );

			sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
		}

		return sizeLengthCache[ sourceSizeListStr ];
	};

	/**
	 * Takes a candidate object with a srcset property in the form of url/
	 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
	 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
	 *     "images/pic-small.png"
	 * Get an array of image candidates in the form of
	 *      {url: "/foo/bar.png", resolution: 1}
	 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
	 * If sizes is specified, res is calculated
	 */
	pf.setRes = function( set ) {
		var candidates;
		if ( set ) {

			candidates = pf.parseSet( set );

			for ( var i = 0, len = candidates.length; i < len; i++ ) {
				setResolution( candidates[ i ], set.sizes );
			}
		}
		return candidates;
	};

	pf.setRes.res = setResolution;

	pf.applySetCandidate = function( candidates, img ) {
		if ( !candidates.length ) {return;}
		var candidate,
			i,
			j,
			length,
			bestCandidate,
			curSrc,
			curCan,
			candidateSrc,
			abortCurSrc;

		var imageData = img[ pf.ns ];
		var dpr = pf.DPR;

		curSrc = imageData.curSrc || img[curSrcProp];

		curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);

		// if we have a current source, we might either become lazy or give this source some advantage
		if ( curCan && curCan.set === candidates[ 0 ].set ) {

			// if browser can abort image request and the image has a higher pixel density than needed
			// and this image isn't downloaded yet, we skip next part and try to save bandwidth
			abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);

			if ( !abortCurSrc ) {
				curCan.cached = true;

				// if current candidate is "best", "better" or "okay",
				// set it to bestCandidate
				if ( curCan.res >= dpr ) {
					bestCandidate = curCan;
				}
			}
		}

		if ( !bestCandidate ) {

			candidates.sort( ascendingSort );

			length = candidates.length;
			bestCandidate = candidates[ length - 1 ];

			for ( i = 0; i < length; i++ ) {
				candidate = candidates[ i ];
				if ( candidate.res >= dpr ) {
					j = i - 1;

					// we have found the perfect candidate,
					// but let's improve this a little bit with some assumptions ;-)
					if (candidates[ j ] &&
						(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
						chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {

						bestCandidate = candidates[ j ];

					} else {
						bestCandidate = candidate;
					}
					break;
				}
			}
		}

		if ( bestCandidate ) {

			candidateSrc = pf.makeUrl( bestCandidate.url );

			imageData.curSrc = candidateSrc;
			imageData.curCan = bestCandidate;

			if ( candidateSrc !== curSrc ) {
				pf.setSrc( img, bestCandidate );
			}
			pf.setSize( img );
		}
	};

	pf.setSrc = function( img, bestCandidate ) {
		var origWidth;
		img.src = bestCandidate.url;

		// although this is a specific Safari issue, we don't want to take too much different code paths
		if ( bestCandidate.set.type === "image/svg+xml" ) {
			origWidth = img.style.width;
			img.style.width = (img.offsetWidth + 1) + "px";

			// next line only should trigger a repaint
			// if... is only done to trick dead code removal
			if ( img.offsetWidth + 1 ) {
				img.style.width = origWidth;
			}
		}
	};

	pf.getSet = function( img ) {
		var i, set, supportsType;
		var match = false;
		var sets = img [ pf.ns ].sets;

		for ( i = 0; i < sets.length && !match; i++ ) {
			set = sets[i];

			if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
				continue;
			}

			if ( supportsType === "pending" ) {
				set = supportsType;
			}

			match = set;
			break;
		}

		return match;
	};

	pf.parseSets = function( element, parent, options ) {
		var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;

		var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
		var imageData = element[ pf.ns ];

		if ( imageData.src === undefined || options.src ) {
			imageData.src = getImgAttr.call( element, "src" );
			if ( imageData.src ) {
				setImgAttr.call( element, srcAttr, imageData.src );
			} else {
				removeImgAttr.call( element, srcAttr );
			}
		}

		if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
			srcsetAttribute = getImgAttr.call( element, "srcset" );
			imageData.srcset = srcsetAttribute;
			srcsetParsed = true;
		}

		imageData.sets = [];

		if ( hasPicture ) {
			imageData.pic = true;
			getAllSourceElements( parent, imageData.sets );
		}

		if ( imageData.srcset ) {
			imageSet = {
				srcset: imageData.srcset,
				sizes: getImgAttr.call( element, "sizes" )
			};

			imageData.sets.push( imageSet );

			isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");

			// add normal src as candidate, if source has no w descriptor
			if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
				imageSet.srcset += ", " + imageData.src;
				imageSet.cands.push({
					url: imageData.src,
					d: 1,
					set: imageSet
				});
			}

		} else if ( imageData.src ) {
			imageData.sets.push( {
				srcset: imageData.src,
				sizes: null
			} );
		}

		imageData.curCan = null;
		imageData.curSrc = undefined;

		// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
		// or has a w descriptor (and does not support sizes) set support to false to evaluate
		imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );

		if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
			if ( srcsetAttribute ) {
				setImgAttr.call( element, srcsetAttr, srcsetAttribute );
				element.srcset = "";
			} else {
				removeImgAttr.call( element, srcsetAttr );
			}
		}

		if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
			if (imageData.src === null) {
				element.removeAttribute("src");
			} else {
				element.src = imageData.src;
			}
		}

		imageData.parsed = true;
	};

	pf.fillImg = function(element, options) {
		var imageData;
		var extreme = options.reselect || options.reevaluate;

		// expando for caching data on the img
		if ( !element[ pf.ns ] ) {
			element[ pf.ns ] = {};
		}

		imageData = element[ pf.ns ];

		// if the element has already been evaluated, skip it
		// unless `options.reevaluate` is set to true ( this, for example,
		// is set to true when running `picturefill` on `resize` ).
		if ( !extreme && imageData.evaled === evalId ) {
			return;
		}

		if ( !imageData.parsed || options.reevaluate ) {
			pf.parseSets( element, element.parentNode, options );
		}

		if ( !imageData.supported ) {
			applyBestCandidate( element );
		} else {
			imageData.evaled = evalId;
		}
	};

	pf.setupRun = function() {
		if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
			updateMetrics();
		}
	};

	// If picture is supported, well, that's awesome.
	if ( pf.supPicture ) {
		picturefill = noop;
		pf.fillImg = noop;
	} else {

		 // Set up picture polyfill by polling the document
		(function() {
			var isDomReady;
			var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;

			var run = function() {
				var readyState = document.readyState || "";

				timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
				if ( document.body ) {
					pf.fillImgs();
					isDomReady = isDomReady || regReady.test(readyState);
					if ( isDomReady ) {
						clearTimeout( timerId );
					}

				}
			};

			var timerId = setTimeout(run, document.body ? 9 : 99);

			// Also attach picturefill on resize and readystatechange
			// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
			var debounce = function(func, wait) {
				var timeout, timestamp;
				var later = function() {
					var last = (new Date()) - timestamp;

					if (last < wait) {
						timeout = setTimeout(later, wait - last);
					} else {
						timeout = null;
						func();
					}
				};

				return function() {
					timestamp = new Date();

					if (!timeout) {
						timeout = setTimeout(later, wait);
					}
				};
			};
			var lastClientWidth = docElem.clientHeight;
			var onResize = function() {
				isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
				lastClientWidth = docElem.clientHeight;
				if ( isVwDirty ) {
					pf.fillImgs();
				}
			};

			on( window, "resize", debounce(onResize, 99 ) );
			on( document, "readystatechange", run );
		})();
	}

	pf.picturefill = picturefill;
	//use this internally for easy monkey patching/performance testing
	pf.fillImgs = picturefill;
	pf.teardownRun = noop;

	/* expose methods for testing */
	picturefill._ = pf;

	window.picturefillCFG = {
		pf: pf,
		push: function(args) {
			var name = args.shift();
			if (typeof pf[name] === "function") {
				pf[name].apply(pf, args);
			} else {
				cfg[name] = args[0];
				if (alreadyRun) {
					pf.fillImgs( { reselect: true } );
				}
			}
		}
	};

	while (setOptions && setOptions.length) {
		window.picturefillCFG.push(setOptions.shift());
	}

	/* expose picturefill */
	window.picturefill = picturefill;

	/* expose picturefill */
	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// CommonJS, just export
		module.exports = picturefill;
	} else if ( typeof define === "function" && define.amd ) {
		// AMD support
		define( "picturefill", function() { return picturefill; } );
	}

	// IE8 evals this sync, so it must be the last thing we do
	if ( !pf.supPicture ) {
		types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
	}

} )( window, document );
window.lazySizesConfig = window.lazySizesConfig || {};

function sdgRemoveLazy(el) {
	var cls = 'is-loading',
		elm = _.parents(el,'.' + cls);

	if (elm) {
		_.removeClass(elm[0],cls);
	}
}

document.addEventListener('lazybeforeunveil', function(e){
	sdgRemoveLazy(e.target);
});
(function(window, factory) {
	var lazySizes = factory(window, window.document);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(window, function l(window, document) {
	'use strict';
	/*jshint eqnull:true */
	if(!document.getElementsByClassName){return;}

	var lazysizes, lazySizesConfig;

	var docElem = document.documentElement;

	var Date = window.Date;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	var addEventListener = window[_addEventListener];

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('CustomEvent');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initCustomEvent(name, !noBubbles, !noCancelable, detail);

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesConfig.pf) ) ){
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = 125;
		var RIC_DEFAULT_TIMEOUT = 666;
		var rICTimeout = RIC_DEFAULT_TIMEOUT;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});
				if(rICTimeout !== RIC_DEFAULT_TIMEOUT){
					rICTimeout = RIC_DEFAULT_TIMEOUT;
				}
			}:
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;
			if((isPriority = isPriority === true)){
				rICTimeout = 44;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || (delay < 9 && requestIdleCallback)){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};


	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom;

		var defaultExpand, preloadExpand, hFac;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/glebot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(e && e.target){
				addRemoveLoadEvents(e.target, resetPreloading);
			}

			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = getCSS(document.body, 'visibility') == 'hidden' || getCSS(elem, 'visibility') != 'hidden';

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal;

			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				if(preloadExpand == null){
					if(!('expand' in lazySizesConfig)){
						lazySizesConfig.expand = docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370;
					}

					defaultExpand = lazySizesConfig.expand;
					preloadExpand = defaultExpand * lazySizesConfig.expFactor;
				}

				if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
					currentExpand = preloadExpand;
					lowRuns = 0;
				} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
					currentExpand = defaultExpand;
				} else {
					currentExpand = shrinkExpand;
				}

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesConfig.loadHidden || getCSS(lazyloadElems[i], 'visibility') != 'hidden') &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesConfig.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			addClass(e.target, lazySizesConfig.loadedClass);
			removeClass(e.target, lazySizesConfig.loadingClass);
			addRemoveLoadEvents(e.target, rafSwitchLoadingClass);
			triggerEvent(e.target, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

			if( (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesConfig.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
				src = elem[_getAttribute](lazySizesConfig.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				if(firesLoad){
					addRemoveLoadEvents(elem, resetPreloading, true);
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);

					addClass(elem, lazySizesConfig.loadingClass);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesConfig.lazyClass);

			rAF(function(){
				if( !firesLoad || (elem.complete && elem.naturalWidth > 1)){
					if(firesLoad){
						resetPreloading(event);
					} else {
						isLoading--;
					}
					switchLoadingClass(event);
				}
			}, true);
		});

		var unveilElement = function (elem){
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}
			var afterScroll = debounce(function(){
				lazySizesConfig.loadMode = 3;
				throttledCheckElements();
			});

			isCompleted = true;

			lazySizesConfig.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', function(){
				if(lazySizesConfig.loadMode == 3){
					lazySizesConfig.loadMode = 2;
				}
				afterScroll();
			}, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);
				hFac = lazySizesConfig.hFac;

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
		};

		lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesConfig)){
				lazySizesConfig[prop] = lazySizesDefaults[prop];
			}
		}

		window.lazySizesConfig = lazySizesConfig;

		setTimeout(function(){
			if(lazySizesConfig.init){
				init();
			}
		});
	})();

	lazysizes = {
		cfg: lazySizesConfig,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));
/**
 * global SDG object
 */
window.SDG = window.SDG || {};

/**
 * global util object
 */
window._ = window._ || {};

/**
 * auto load page specific js
 */
if (page_handle in path) {
	require([path[page_handle]]);
}

/**
 * Custom non-modal objects
 */
window.nonBagNodes = [];
window.nonModalNodes = [];

// foreach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
/**
 * utilities
 *
 * remove polyfill for ie
 * custom event polyfill for ie
 * extend
 * namespace
 * ready
 * dom event
 * add event
 * remove event
 * get url parameter
 * debounce
 * media query
 * ajax
 * replace
 * is visible
 * has class
 * add class
 * remove class
 * transition
 * get hidden height
 * window resize
 * hide
 * show
 * get hidden height
 * slide up
 * slide down
 * get sized image url
 * remove protocol
 * format price
 * format price display
 * serialize
 * object to query string
 * is object
 * is object empty
 * get query string
 * encode
 * scroll to
 * index
 * waypoint
 * remap size values
 * array to lower
 */

/**
 * remove polyfill for ie
 */
(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('remove')) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function remove() {
				this.parentNode.removeChild(this);
			}
		});
	});
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

/**
 * custom event polyfill for ie
 */
(function () {
	if ( typeof window.CustomEvent === 'function' ) return false;
	function CustomEvent ( event, params ) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent( 'CustomEvent' );
		evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
		return evt;
	}
	CustomEvent.prototype = window.Event.prototype;
	window.CustomEvent = CustomEvent;
})();

/**
 * ready
 * equivalent of jQuery's $(document).ready();
 * @param  {Function} fn function to run when the document is ready
 * @return {Function} Rturns passed function when document is ready.
 */
_.ready = function(fn) {
	if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading'){
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
};

/**
 * extend
 * extends a js object
 * @param  {Object} config
 * @param  {Object} obj
 * @return {Object}
 */
_.extend = function(config, obj) {
	obj = obj || {};

	Object.keys(config).forEach(function(key) {
		if (obj[key] === undefined) {
			obj[key] = config[key];
		} else {
			if (obj[key] && _.isObject(obj[key])) {
				Object.keys(config[key]).forEach(function(childKey) {
					if (obj[key][childKey] === undefined) {
						obj[key][childKey] = config[key][childKey];
					}
				});
			}
		}
	});

	return obj;
};

/**
 * namespace
 * @param  {Object} obj
 * @param  {String} Name
 * @return {Object}
 */
_.namespace = function(obj,name) {
	obj = obj || {};

	obj = JSON.parse(JSON.stringify(obj));

	var	objNode,
		namedVar;

	if (obj) {
		if (obj && _.isObject(obj)) {
			Object.keys(obj).forEach(function(key) {
				if (obj[key]) {
					if (typeof(obj[key]) !== 'object') {
						objNode = obj[key].toString();
						namedVar = name + objNode.charAt(0).toUpperCase() + objNode.slice(1);
						obj[key] = namedVar;
					} else if (Array.isArray(obj[key])) {
						obj[key].forEach(function(id, idx, arr) {
							objNode = name + id.charAt(0).toUpperCase() + id.slice(1);
							arr[idx] = objNode;
						});
					}
				}
			});
		} else {
			console.warn('obj is not defined, or is not an object');
		}
	}

	return obj;
};

/**
 * Dom Event
 * @type {function}
 * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
 * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
 * @param {object | string} object.event - Event which triggers the function.
 * @param {object.function} object.fn - Function to bind to each element.
 * @param {boolean} - applyEvent - Dictates whether to addEventListener or removeEventListener
 */
_.domEvent = function(opts,applyE) {
	var c = opts,
		eApply = applyE !== undefined ? applyE : true,
		$id,
		$class,
		isString,
		hasIds,
		hasEvents,
		$trigger,
		i,
		idArr,
		eventArr;

	/**
	 * init
	 * @return {function} Checks if c.id, c.fn, and c.event are defined. If not add event is skipped. This also maps the variables for $id and domClass
	 */
	function init() {
		if (c.id) { // Is c.id set?

			if (c.fn  || c.event) { // If c.fn and c.event are set then execute functions.

				checkForArray();

				if (hasIds) {
					idArr = c.id.split(',');

					for (i=0;i<idArr.length;i++) {
						c.id = idArr[i];
						bindEvents();
					}

				} else {
					bindEvents();
				}

			} else {
				if (c.fn === null) { // Check if c.fn is set, if not warn the developer.
					console.warn('No function defined.');
				}
				if (c.event === null) { // Check if c.event is set, if not warn the developer.
					console.warn('No event defined.');
				}
			}
		} else { // if c.id is not set, then warn the developer.
			console.warn('No ID defined.');
		}
	}

	/**
	 * check for array
	 */
	function checkForArray() {
		isString = typeof(c.id) === 'string' ? true : false;

		if (isString) {
			hasIds = _.isDelimitedArray(c.id);
		}

		hasEvents = _.isDelimitedArray(c.event);
	}

	/**
	 * bind events
	 * @type {Function}
	 */
	function bindEvents() {

		mapVars(); // Map vas called inside c.fn and c.event check to avoid unnecessary DOM search.

		if (c.className) {
			bindLoop(); // If a class value was set, bind the event to dom elements within a parent id.
		} else {
			bindSingle(); // If only an id was set and no className, then bind the event to a single id.
		}
	}

	/**
	 * map vars
	 * @return {function} Sets domId variable and if c.className exists, sets domClass value.
	 */
	function mapVars() {

		if (isString) {
			$id = document.getElementById(c.id);
		} else {
			$id = c.id;
		}

		if ($id) {
			if (c.className === null) {
				$class = null;
			} else {
				$class = $id.querySelectorAll('.' + c.className);
			}
		} else {
			if (isString) {
				console.warn('Could not find id '+ c.id);
			} else {
				console.warn('Could not find element.');
			}
		}
	}

	/**
	 * bind loop
	 * @return {function} Bind events to dom elements within the defined c.id dom element.
	 */
	function bindLoop() {
		if ($class) {
			for (i=0;i<$class.length;i++) {
				$trigger = $class[i];

				if ($trigger) {

					if (eApply) {
						if (hasEvents) {

							eventArr = c.event.split(',');

							for (i=0;i<eventArr.length;i++) {
								$trigger.addEventListener(eventArr[i],c.fn,null);
							}

						} else {
							$trigger.addEventListener(c.event,c.fn,null);
						}
					} else {
						$trigger.removeEventListener(c.event,c.fn,null);
					}
				}
			}
		}
	}

	/**
	 * bind single
	 * @return {function} Add event listener to a single dom element based on id.
	 */
	function bindSingle() {
		if ($id) {

			if (eApply) {
				if (hasEvents) {
					eventArr = c.event.split(',');

					for (i=0;i<eventArr.length;i++) {
						$id.addEventListener(eventArr[i],c.fn,null);
					}
				} else {
					$id.addEventListener(c.event,c.fn,null);
				}

			} else {
				$id.removeEventListener(c.event,c.fn,null);
			}
		}
	}

	return init();
};

/**
 * Add Event
 * @type {function}
 * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
 * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
 * @param {object | string} object.event - Event which triggers the function.
 * @param {object.function} object.fn - Function to bind to each element.
 */
_.addEvent = function(opts) {
	if (opts === undefined) {
		console.warn('_.addEvent requires a config object.');
	} else {
		_.domEvent(opts,true);
	}
};

 /**
  * Remove Event
  * @type {function}
  * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
  * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
  * @param {object | string} object.event - Event which triggers the function.
  * @param {object.function} object.fn - Function to bind to each element.
  */
_.removeEvent = function(opts) {
	if (opts === undefined) {
		console.warn('_.removeEvent requires a config object.');
	} else {
		_.domEvent(opts,false);
	}
};

/**
 * trigger event
 * @param  {object} el - Element that event is being triggered on. Must pass selected dom element, not just a string.
 * @param  {string} eventName - Name of custom event that needs to be trigger.
 * @param  {boolean} bubbles - A Boolean indicating whether the event bubbles up through the DOM or not. Default: true
 * @param  {boolean} cancelable - A Boolean indicating whether the event is cancelable. Default: true
 * @return {function} - Dispatches the custom event that's bound to the element.
 */
_.trigger = function(el,eventName,bubbles,cancelable) {
	if (el === undefined || eventName === undefined) return false;
	if (bubbles === undefined) bubbles = true;
	if (cancelable === undefined) cancelable = true;
	var event = new CustomEvent(eventName,{
		detail: {
			message: el,
			time: new Date()
		},
		bubbles: bubbles,
		cancelable: cancelable
	});
	el.dispatchEvent(event);
};

/**
 * get url parameter
 * @param {string} sParam - parameter name
 */
_.getUrlParameter = function(sParam) {
	var sPageURL = decodeURIComponent(window.location.search.substring(1)),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : sParameterName[1];
		}
	}
};

/**
 * debounce
 * @param {fn} The function that needs to be debounce
 * @param {int} Miliseconds for how often to execute the function
 * @param {boolean} Execute immediately or after function is complete
 */
_.debounce = function(func, threshold, execAsap) {
	var timeout;
	return function debounced () {
		var obj = this, args = arguments;

		function delayed () {
			if (!execAsap)
				func.apply(obj, args);
			timeout = null;
		}

		if (timeout)
			clearTimeout(timeout);
		else if (execAsap)
			func.apply(obj, args);

		timeout = setTimeout(delayed, threshold || 100);
	};
};

/**
 * media query
 * @param {object} argument object
 * @param {string} object.view - the targetted screen size to execute the function
 * @param {fn} oject.callback - function to execute
 * @param {object} oject.views - array of available views that can be targetted
 */
_.mq = function(opts) {
	var config = {
		callback : null,
		view	: null,
		views : {
			smallest_phone			: '(max-width:374px)',
			small_phone 			: '(max-width:640px)',
			phone 					: '(max-width:767px)',
			mobile					: '(max-width:1024px)',
			phone_to_desktop		: '(min-width:563px)',
			tablet					: '(min-width:768px)',
			tablet_only 			: '(min-width:768px) and (max-width:1024px)',
			tablet_portrait 		: '(min-width:768px) and (max-width:979px)',
			tablet_landscape 		: '(min-width:980px) and (max-width:1024px)',
			desktop					: '(min-width:1025px)',
			desktop_to_large    	: '(min-width:1025px) and (max-width:1280px)',
			desktop_large			: '(min-width:1281px)',
			desktop_large_to_huge 	: '(min-width:1281px) and (max-width:1400px)',
			desktop_huge			: '(min-width:1401px)'
		}
	},

	c = _.extend(config,opts),

	currentView = null,

	mq = {
		init : function() {

			if (c.view) {

				Object.keys(c.views).forEach(function(key) {
					if (key === c.view) {
						currentView = c.views[key];
					}
				});

				var query = window.matchMedia(currentView);

				if (query.matches === true) {
					if (typeof c.callback === 'function') {
						c.callback();
					}
				}

			}

		}
	};

	return mq.init();
};

/**
 * ajax
 * @param  {Object} opts
 * @return {_.ajax~init}
 */
_.ajax = function(opts) {
	var config = {
		contentType: null,
		data: '',
		dataObject: {},
		headers: {},
		type: null,
		url: '',
		success: function(resp){
			console.log(resp);
		},
		error: function(resp) {
			console.warn(resp);
		}
	},

	c = _.extend(config,opts),
	xhr;

	/**
	 * init
	 */
	function init() {
		xhr = new XMLHttpRequest();
		xhr.open(c.type,c.url,true);
		setHeaders(xhr);
		xhr.onload = onLoadHandler;
		xhr.onError = errorHandler;

		if (c.data) {
			xhr.send(_.objectToQueryString(c.data));
		} else {
			if (c.dataObject) {
				xhr.send(_.objectToQueryString(c.dataObject));
			} else {
				console.warn('data is not defined.');
			}
		}
	}

	/**
	 * set headers
	 * @param {Object} xhr
	 */
	function setHeaders(xhr) {
		var defaultContentType = 'application/x-www-form-urlencoded; charset=UTF-8',
			contentType = c.contentType ? c.contentType : defaultContentType,
			headers = c.headers;

		if (! _.isObjectEmpty(headers)) {
			if (! hasContentType(headers)) {
				headers['Content-Type'] = defaultContentType;
			}
			Object.keys(headers).forEach(function(name) {
				xhr.setRequestHeader(name, headers[name]);
			});
		} else {
			xhr.setRequestHeader('Content-Type', contentType);
		}
	}

	/**
	 * has content type
	 * @param  {Object}  headers
	 * @return {Boolean}
	 */
	function hasContentType(headers) {

		return Object.keys(headers).some(function(name) {
			return name.toLowerCase() === 'content-type';
		});
	}

	/**
	 * on load handler
	 * @callback
	 */
	function onLoadHandler() {
		var resp = xhr.responseText;

		// check if response text is an object.
		if (typeof resp !== 'object') {
			try {
				resp = JSON.parse(resp);
			} catch(e) {
			}
		}

		// check xhr status
		if (xhr.status >= 200 && xhr.status < 400) {

			// check if response has a status code
			if (resp.status) {
				// check status code for success
				if (resp.status >= 200 && resp.status < 400) {
					c.success(resp);
				} else {
					c.error(resp);
				}
			} else {
				c.success(resp);
			}

		} else {
			c.error(resp);
		}
	}

	/**
	 * on load handler
	 * @callback
	 */
	function errorHandler() {
		c.error(xhr.responseText);
	}

	return init();
};

/**
 * replace
 * @param  {string} string
 * @param  {string} needle   searched value
 * @param  {string} newValue new value you wish to replace the needle with
 * @return {string}
 */
_.replace = function(string, needle, newValue) {
	var newString;

	// if string contains needle, return new value
	if (string.indexOf(needle) !== -1) {
		newString = string.replace(needle, newValue);
	}

	// else return string as-is if needle could not be found
	else {
		newString = string;
	}

	return newString;
};

/**
 * is visible
 * @param  {element} el
 * @return {boolean}
 */
_.isVisible = function(el) {
	return el.offsetParent !== null;
};

/**
 * has class
 * @param  {element}  el
 * @param  {string}  className
 * @return {boolean}
 */
_.hasClass = function(el, className) {
	if (el.classList) {
		return el.classList.contains(className);
	}
	else {
		return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
	}
};

/**
 * add class
 * @param {string} el
 * @param {string} className
 */
_.addClass = function(el, className) {

	if (!_.hasClass(el, className)) {
		if (el.classList) {
			el.classList.add(className);
		}
		else {
			el.className += ' ' + className;
		}
	}
};

/**
 * remove class
 * @param {element} el
 * @param {string} className
 */
_.removeClass = function(el, className) {
	if (_.hasClass(el, className)) {
		if (el.classList) {
			el.classList.remove(className);
		}
		else {
			el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	}
};

/**
 * transition
 * fires a function before and after a timeout
 * @param {object} opts
 */
_.transition = function(opts) {
	if (opts.before === undefined) opts.before = null;
	if (opts.after === undefined) opts.before = null;
	if (opts.time === undefined) opts.time = 400;

	if (typeof opts.before === 'function') {
		opts.before();
	}

	if (typeof opts.after === 'function') {
		setTimeout(opts.after, opts.time);
	}
};

/**
 * get hidden height
 * @param {element}
 * @return {int}
 */
_.getHiddenStyles = function(el) {

	var $clone = el.cloneNode(true),
		$parent = el.parentNode,
		posVal = window.getComputedStyle($parent).position,
		body = document.body,
		docEl = document.documentElement,
		scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop,
		clientTop = docEl.clientTop || body.clientTop || 0,
		$cloneInDom = null,
		cloneHeight = null,
		cloneOffsetTop,
		clonePaddingTop = null,
		clonePaddingBottom = null,
		cloneRect;

	if (posVal === 'static') {
		$parent.style.position = 'relative';
	}

	// Add attribute to track element for deletion;
	$clone.setAttribute('data-clone','true');

	// Append the new cloen to to the parent.
	$parent.appendChild($clone);

	// Select that new clone
	$cloneInDom = $parent.querySelector('[data-clone="true"]');

	// Display the clone with visibility hidden so that size can be retrieved.
	$cloneInDom.style.height = 'auto';
	$cloneInDom.style.display = 'block';
	$cloneInDom.style.visibility = 'hidden';
	$cloneInDom.style.position = 'absolute';

	// Get Height
	cloneHeight = $cloneInDom.offsetHeight;

	// Get Padding Top
	clonePaddingTop = window.getComputedStyle($cloneInDom).paddingTop;

	// Get Padding Bottom;
	clonePaddingBottom = window.getComputedStyle($cloneInDom).paddingBottom;

	// Get Rectangle
	cloneRect = $cloneInDom.getBoundingClientRect();

	// Get OffsetTop
	cloneOffsetTop = Math.round(cloneRect.top + scrollTop - clientTop);

	// Delete the clone
	$cloneInDom.remove();

	// Remove the position value added to the parent when its static.
	if (posVal === 'static') {
		$parent.style.position = '';
	}

	// Return values
	return {
		elHeight: cloneHeight,
		elOffsetTop: cloneOffsetTop,
		elPaddingTop: clonePaddingTop,
		elPaddingBottom: clonePaddingBottom
	};
};

/**
 * window resize
 * Run functions on window resize.
 * @param {function} function to call on window resize
 * @param {int} how often in miliseconds to fire the debounced function
 * @param {boolean} sets whether to execute the function as soon as possible or not.
 */
_.windowResize = function(fn,threshold,execAsap) {
	if (fn === undefined) fn = null;
	if (threshold === undefined) threshold = 100;
	if (execAsap === undefined) execAsap = false;

	if (fn) {
		window.addEventListener('resize',_.debounce(fn,threshold,execAsap));
	} else {
		console.warn('No function defined.');
	}
};

/**
 * hide
 * @param {Object} obj - dom element to hide
 */
_.hide = function(obj) {
	if (obj && obj.style.display !== 'none') {
		obj.style.display = 'none';
	}
};

/**
 * show
 */
_.show = function(obj) {
	if (obj && obj.style.display === 'none') {
		obj.style.display = 'block';
	}
};

/**
 * slide up
 * @param {element} DOM Element
 * @param {int} Animation timer
 */
_.slideUp = function(el) {
	if (el === undefined) el = null;

	if (el) {
		el.style.height = el.offsetHeight + 'px';

		el.style.height = 0;
		el.style.paddingTop = 0;
		el.style.paddingBottom = 0;
	}
};

/**
 * slide down
 * @param {element} DOM Element
 * @param {int} Animation timer
 */
_.slideDown = function(el) {
	if (el === undefined) el = null;

	if (el) {
		var hiddenStyles = _.getHiddenStyles(el);
		var menuHeight = hiddenStyles.elHeight;
		var padTop = hiddenStyles.elPaddingTop;
		var padBottom = hiddenStyles.elPaddingBottom;

		el.style.display = 'block';
		el.style.paddingTop = 0;
		el.style.paddingBottom = 0;
        el.style.height = 0;


		setTimeout(function() {
	        el.style.height = menuHeight + 'px';
			el.style.paddingTop = padTop;
			el.style.paddingBottom = padBottom;
		},1);
	}
};

/**
 * get sized image url
 * @param  {string} imgUrl
 * @param  {string} size   image width, e.x. '250x'
 * @return {string}        resized image url
 */
_.getSizedImageUrl = function(imgUrl, size) {
	var i,
		n,
		r;

	if (! imgUrl) return '//cdn.searchspring.net/ajax_search/img/missing-image-75x75.gif';
	if (! size) return imgUrl;
	if (size === 'master') return _.removeProtocol(imgUrl);

	n = imgUrl.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

	if (n !== null) {
		r = imgUrl.split(n[0]);
		i = n[0];
		return _.removeProtocol(r[0] + '_' + size + i);
	}
};

/**
 * remove protocol
 * @param  {string} url
 * @return {string}
 */
_.removeProtocol = function(url) {
	return url.replace(/http(s)?:/, '');
};

/**
 * format price
 * @param  {number} price e.x. "1200"
 * @return {string}       e.x. "12.00"
 */
_.formatPrice = function(price) {
	return (price / 100).toFixed(2);
};

/**
 * format price display
 * @param  {number} price e.x. "1200"
 * @return {string}       e.x. "$12"
 */
_.formatPriceDisplay = function(price) {
	var cartCurrency = currency;
	var cartCountry = country;
	return cartCountry + ' ' + cartCurrency + _.formatPrice(price).replace(/\.00$/, '');
};

/**
 * serialize
 * @param form object
 */
_.serialize = function(form,type) {
 	if (!form || form.nodeName !== 'FORM') {
 		return;
 	}

	var isDataObject = (type ? true : false);

 	var i, j, q = [], o = {};
 	for (i = form.elements.length - 1; i >= 0; i = i - 1) {
 		if (form.elements[i].name === '') {
 			continue;
 		}
 		switch (form.elements[i].nodeName) {
 		case 'INPUT':
 			switch (form.elements[i].type) {
 			case 'text':
 			case 'hidden':
 			case 'password':
 			case 'button':
 			case 'reset':
 			case 'submit':
 			case 'color':
 			case 'date':
 			case 'datetime-local':
 			case 'email':
 			case 'month':
 			case 'number':
 			case 'range':
 			case 'search':
 			case 'tel':
 			case 'time':
 			case 'url':
 			case 'week':
 				q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
				o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
 				break;
 			case 'checkbox':
 			case 'radio':
 				if (form.elements[i].checked) {
 					q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
					o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
 				}
 				break;
 			case 'file':
 				break;
 			}
 			break;
 		case 'TEXTAREA':
 			q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
			o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
 			break;
 		case 'SELECT':
 			switch (form.elements[i].type) {
 			case 'select-one':
 				q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
				o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
 				break;
 			case 'select-multiple':
 				for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
 					if (form.elements[i].options[j].selected) {
 						q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].options[j].value));

						o[form.elements[i].name] = encodeURIComponent(form.elements[i].options[j].value);
 					}
 				}
 				break;
 			}
 			break;
 		case 'BUTTON':
 			switch (form.elements[i].type) {
 			case 'reset':
 			case 'submit':
 			case 'button':
 				q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
				o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
 				break;
 			}
 			break;
 		}
 	}

	if (isDataObject) {
		return o;
	} else {
	 	return q.join('&');
	}
};

/**
 * object to query string
 * if no object is provided, function will return original data
 * @param  {Object} data
 * @return {string}
 */
_.objectToQueryString = function(data) {
	return _.isObject(data) ? _.getQueryString(data) : data;
};

/**
 * is object
 * @param  {*}       data any type
 * @return {boolean}
 */
_.isObject = function(data) {
	return Object.prototype.toString.call(data) === '[object Object]';
};

/**
 * is delineated array
 * @param  {*}       data any type
 * @return {boolean}
 */
_.isDelimitedArray = function(str,delimiter) {
	if (!str) {
		console.warn('No string defined');
		return false;
	}

	if (!delimiter) {
		delimiter = ',';
	}

	return str.indexOf(delimiter) !== -1 ? true : false;
};

/**
 * is object empty
 * @param  {Object}  obj
 * @return {boolean}
 */
_.isObjectEmpty = function(obj) {
	return _.isObject(obj) && Object.keys(obj).length === 0;
};

/**
 * get query string
 * @param  {Object} object
 * @return {string}
 */
_.getQueryString = function(object) {
	return Object.keys(object).reduce(function(acc, item) {
		var prefix = ! acc ? '' : acc + '&';
		return prefix + _.encode(item) + '=' + _.encode(object[item]);
	}, '');
};

/**
 * encode
 * @param  {string} value
 * @return {string}
 */
_.encode = function(value) {
	return encodeURIComponent(value);
};

/**
 * Smooth scroll
 * @param  options [target: where you want the link to scroll to, link: the link you want to target with an ID ]
 */
 _.scrollTo = function(opts) {
 	var config = {
		callback: null,
		className: null,
		exec_now: false,
		id: null,
		offset: 0,
		target: null,
		timer: 500
 	},

 	c = _.extend(config, opts);

 	function init () {

		if (c.exec_now) {
			scroll();
		} else {
			if (c.id) {
				addEvents();
			} else {
				console.warn('no id defined');
			}
		}
 	}

 	function addEvents () {
		_.addEvent({
			id: c.id,
			className: c.className,
			event: 'click',
			fn: scroll
		});
 	}

    function scroll(e) {

		var start = window.pageYOffset,
			target = c.target ? c.target : this.getAttribute('href').replace('#',''),
			distance,
			duration,
			timeStart,
			timeElapsed;

		target = typeof target === 'string' ? document.getElementById(target) : target;

		if (target) {
			if (e) {
				e.preventDefault();
			}
		} else {
			return false;
		}

		distance = c.offset + target.getBoundingClientRect().top;

		duration = typeof c.timer === 'function' ? c.timer(distance) : c.timer;

		requestAnimationFrame(function(time) { timeStart = time; loop(time); });

		function loop(time) {
			timeElapsed = time - timeStart;

			window.scrollTo(0, easeInOutQuad(timeElapsed, start, distance, duration));

			if (timeElapsed < duration){
				requestAnimationFrame(loop);
			} else {
				end();
			}
		}

		function end() {
			window.scrollTo(0, start + distance);

			if (typeof c.callback === 'function'){
				c.callback();
			}

		}

 	}

	// Robert Penner's easeInOutQuad - http://robertpenner.com/easing/
	function easeInOutQuad(t, b, c, d)  {
		t /= d / 2;
		if(t < 1) return c / 2 * t * t + b;
		t--;
		return -c / 2 * (t * (t - 2) - 1) + b;
	}

 	return init();

 };

 /**
  * is parent
  * @param  {Node} elem
  * @param  {String} selector
  * @return {Node}
  */
_.parents = function(elem, selector) {

    var parents = [];
    var firstChar;
    if ( selector ) {
        firstChar = selector.charAt(0);
    }

    // Get matches
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if ( selector ) {

            // If selector is a class
            if ( firstChar === '.' ) {
                if ( elem.classList.contains( selector.substr(1) ) ) {
                    parents.push( elem );
                }
            }

            // If selector is an ID
            if ( firstChar === '#' ) {
                if ( elem.id === selector.substr(1) ) {
                    parents.push( elem );
                }
            }

            // If selector is a data attribute
            if ( firstChar === '[' ) {
                if ( elem.hasAttribute( selector.substr(1, selector.length - 1) ) ) {
                    parents.push( elem );
                }
            }

            // If selector is a tag
            if ( elem.tagName.toLowerCase() === selector ) {
                parents.push( elem );
            }

        } else {
            parents.push( elem );
        }

    }

    // Return parents if any exist
    if ( parents.length === 0 ) {
        return null;
    } else {
        return parents;
    }

};

/**
 * index
 * @param  {Element} node
 * @return {Number}
 */
 _.index = function(node) {
	var c = node.parentNode.children, i = 0;
    for(; i < c.length; i++ )
        if( c[i] === node ) return i;
};

/**
 * waypoint
 * @param  {Object} opts
 * @return {_.waypoint~init}
 */
_.waypoint = function(opts) {
	var config = {
			el: null,
			in: null,
			out: null,
			offset: null
		},
		c = _.extend(config, opts);

	/**
	 * init
	 */
	function init() {
		addEvents();
		checkWindowPosition();
	}

	/**
	 * add events
	 */
	function addEvents() {

		// scroll
		window.addEventListener('scroll', checkWindowPosition, false);

		// resize
		_.windowResize(checkWindowPosition, 400);
	}

	/**
	 * check window position
	 */
	function checkWindowPosition() {
		var windowPos = window.pageYOffset || document.documentElement.scrollTop,
			elOffset = c.el.offsetTop,
			isPastEl;

			// offset
			if (c.offset) {
				elOffset -= c.offset;
			}

			isPastEl = windowPos > elOffset;

		if (isPastEl) {
			if (typeof c.in === 'function') c.in();
		} else {
			if (typeof c.out === 'function') c.out();
		}
	}

	return init();
};

/**
 * remap size values
 * @type {Function}
 * @return {String}
 * @desc This is used to remap short hand size values to full words
 */
_.remapSizeValues = function(val) {
	var label;

	if (val) {
		val = val.toLowerCase();
	}

	switch(val) {
		case 'xs':
			label = 'extra small';
			break;
		case 's':
			label = 'small';
			break;
		case 'm':
			label = 'medium';
			break;
		case 'l':
			label = 'large';
			break;
		case 'xl':
			label = 'extra large';
			break;
		case 'xxl':
			label = '2x Large';
			break;
		case '2xl':
			label = '2x Large';
			break;
		case 'xxxl':
			label = '3x Large';
			break;
		case '3xl':
			label = '3x Large';
			break;
		default:
			label = val;
			break;
	}

	return label;
};

/**
 * array to lower
 */
_.arrayToLower = function(r) {
	var c,
		i;
	if (Array.isArray(r)) {
		c = r.length;
		for (i=0;i<c;i++) {
			r[i] = r[i].toLowerCase();
		}
	} else {
		console.warn('argument not an array.');
		console.warn(r);
		return false;
	}

	return r;
};

/**
 * reduce array
 */
 _.reduceArray = function(r) {
 	var c,
 		i,
 		n = [],
 		o;
 	if (Array.isArray(r)) {
 		c = r.length;
 		for (i=0;i<c;i++) {
 			o = r[i];
 			if (n.indexOf(o) === -1) {
 				n.push(o);
 			}
 		}
 	} else {
 		console.warn('argument not an array.');
 		console.warn(r);
 		return false;
 	}

 	return n;
 };

 /**
  * format money
  */
_.formatMoney = function(cents, format, currency) {
	if (typeof cents === 'string') {
		cents = cents.replace('.', '');
	}
	var value = '';
	currency = currency || '$';

	function defaultOption(opt, def) {
		return (typeof opt === 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal   = defaultOption(decimal, '.');

		if (isNaN(number) || number === null) { return 0; }

		number = (number/100.0).toFixed(precision);

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents   = parts[1] ? (decimal + parts[1]) : '';

		return dollars + cents;
	}

	switch (format) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_with_currency':
			value = currency + formatWithDelimiters(cents, 2);
			break;
		case 'amount_with_currency_without_trailing_zeros':
			value = currency + formatWithDelimiters(cents, 2);
			if (value.indexOf('.00') !== -1) {
				value = value.replace('.00', '');
			}
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
		}

	return value;
};

/**
 * loadJSONP( url, hollaback [, context] ) -> Null
 * - url (String): URL to data resource.
 * - hollaback (Function): Function to call when data is successfully loaded,
 *   it receives one argument: the data.
 * - context (Object): Context to invoke the hollaback function in.
**/

_.loadJSONP = (function loadJSONP( window, document, undefined ) {
  	var uuid = 0,
		head = document.head || document.getElementsByTagName( 'head' )[0],
		main_script = document.createElement( 'script' );

  	main_script.type = 'text/javascript';

	return function( url, callback, context ) { var name, script;
	    // INIT
	    name = '__jsonp_' + uuid++;
	    if ( url.match(/\?/) ) {
	      url += '&callback=' + name;
	  	} else {
	      url += '?callback=' + name;
	  	}

	    // Create script
	    script = main_script.cloneNode();
	    script.src = url;

	    // Setup handler
	    window[name] = function( data ) {
	      callback.call( ( context || window ), data );
	      head.removeChild( script );
	      script = null;
	      delete window[name];
	  	};

	    // Load JSON
	    head.appendChild( script );
	};
})( window, document );

/**
 * click outside
 * @param  {Object} opts
 * @return {_.clickOutside~init}
 */
_.clickOutside = function (opts) {
	var config = {
			callback: null,
			condition: null,
			exclude_selectors: '',
			selector: ''
		},
		c = _.extend(config, opts),

		// cached globals
		excludedElements = [];

	/**
	 * init
	 */
	function init() {
		addEvents();
	}

	/**
	 * setup excluded
	 */
	function setupExcluded() {

		excludedElements = [];

		var excludedSelectors = [];

		// if there are no excluded selectors, exit function
		if (!c.exclude_selectors) return;

		// if there's a comma, i.e. multiple selectors, create array from list
		// else push the single item to the array
		if (c.exclude_selectors.indexOf(',') !== -1) {
			excludedSelectors = c.exclude_selectors.split(',');
		} else {
			excludedSelectors.push(c.exclude_selectors);
		}

		// query selectors and push them to array
		excludedSelectors.forEach(addElementToExcludedArray);
	}

	/**
	 * add element to excluded array
	 * @callback
	 * @param {String} selector
	 * @param {Number} i
	 * @param {Array}  arr
	 */
	function addElementToExcludedArray(selector, i, arr) {
		var el = document.querySelectorAll(selector),
			elCount = el.length,
			children,
			childCount,
			itr,
			childItr;

		if (el) {
			for (itr = 0; itr < elCount; itr++) {
				excludedElements.push(el[itr]);

				children = el.children;
				childCount = children ? children.length : null;

				if (childCount) {
					for (childItr = 0; childItr < childCount; childItr++) {
						excludedElements.push(children[childItr]);
					}
				}
			}
		}
	}

	/**
	 * is excluded element
	 * @callback
	 * @param  {Element} el
	 * @param  {Number}  i
	 * @param  {Array}   arr
	 * @return {Boolean}
	 */
	function isExcludedElement(el, i, arr) {
		return el === this;
	}

	/**
	 * add events
	 */
	function addEvents() {

		// document click
		_.addEvent({
			id: document,
			event: 'click',
			fn: onDocumentClick
		});
	}

	/**
	 * on document click
	 * @param {Object} e event
	 */
	function onDocumentClick(e) {

		setupExcluded();

		var isExElement = excludedElements.some(isExcludedElement, e.target);

		var isConditionFn = typeof c.condition === 'function',
			hasMetConditions = isExElement ? isConditionFn && !isExElement : isConditionFn && c.condition(),
			hasClickedOutside;

		// if conditions have not been met, exit function
		if (!hasMetConditions) return;

		// traverse up dom to see if user clicked within selector
		hasClickedOutside = !_.parents(e.target, c.selector);

		// if clicked outside, fire callback
		if (typeof c.callback === 'function' && hasClickedOutside) c.callback();
	}

	/**
	 * return
	 * @type {Object}
	 */
	return {
		init: init()
	};
};
/**
 * set cookie
 * @param  {String} c_name name of the cookie
 * @param  {String} value  value of the cookie
 * @param  {Number} exdays number of days to set the cookie
 * @return {Function}      sets cookie
 */
SDG.setCookie = function(c_name,value,exdays) {
	var exdate=new Date();
	exdate.setDate(exdate.getDate() + exdays);
	var c_value=encodeURI(value) +
	((exdays===null) ? '' : ('; expires='+exdate.toUTCString()));
	document.cookie=c_name + '=' + c_value +'; path=/';
};

/**
 * get cookie
 * @param  {String} c_name name of the cookie
 * @return {String}        value of the cookie
 */
SDG.getCookie = function(c_name) {
	var i,x,y,ARRcookies=document.cookie.split(';');
	for (i=0;i<ARRcookies.length;i++) {
		x=ARRcookies[i].substr(0,ARRcookies[i].indexOf('='));
		y=ARRcookies[i].substr(ARRcookies[i].indexOf('=')+1);
		x=x.replace(/^\s+|\s+$/g,'');
		if (x===c_name) {
			return decodeURI(y);
		}
	}
};

/**
 * delete cookie
 * @param {string} c_name name of the cookie
 */
SDG.deleteCookie = function(c_name) {
	document.cookie = c_name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};
/**
 * input placeholder
 * @requires [lib/util.js]
 */

SDG.placeholder = function(opts) {
	/**
	 * config
	 * @type {Object}
	 */
	var config = {
		id: 'main',
		sel: 'input-placeholder',
		cls: 'has-value'
	},

	c = _.extend(config,opts),

	domId = document.getElementById(c.id),
	domInputWraps = domId.querySelectorAll('.' + c.sel),
	domInputWrap,
	domInput;

	/**
	 * init
	 * @return {Function}
	 */
	function init() {
		addEvents();
		checkForExistingValues();
	}

	/**
	 * add events
	 * @return {Function}
	 */
	function addEvents() {

		// keyup event for inputs
		_.addEvent({
			id: c.id,
			className: c.sel + ' input',
			event: 'keyup',
			fn: checkValue
		});

		// change event for inputs
		_.addEvent({
			id: c.id,
			className: c.sel + ' input',
			event: 'change',
			fn: checkValue
		});

		// keyup event for textarea
		_.addEvent({
			id: c.id,
			className: c.sel + ' textarea',
			event: 'keyup',
			fn: checkValue
		});

		// change event for textarea
		_.addEvent({
			id: c.id,
			className: c.sel + ' textarea',
			event: 'change',
			fn: checkValue
		});
	}

	/**
	 * check for existing values
	 * @type {Function}
	 */
	function checkForExistingValues() {
		Object.keys(domInputWraps).forEach(function(key) {
			domInputWrap = domInputWraps[key];
			domInput = domInputWrap.querySelector('input') ? domInputWrap.querySelector('input') : domInputWrap.querySelector('textarea');

			if (domInput) {
				checkValue(domInput);
			}
		});
	}

	/**
	 * check value
	 * @type {Function}
	 */
	function checkValue(el) {
		var field = el.target ? el.target : el;

		if (field.value && field.value !== '') {
			_.addClass(field.parentNode,c.cls);
		} else {
			_.removeClass(field.parentNode,c.cls);
		}
	}


	return {
		init: init
	};
};
/**
 * Accordion
 * @param  {obj}  Config object
 * @requires [lib/util.js]
 */
SDG.accordion = function(opts) {
	/**
	 * config
	 * @type {Object}
	 */
	var config = {

		/**
		 * classes
		 * @type {Object}
		 * @desc used for element states
		 */
		cls: {
			active: 'is-active', // Button active class
			open: 'is-open'
		},

		/**
		 * dom
		 * @type {Object}
		 */
		dom: {
			btn: 'js-acc-btn', // toggle trigger
			id: 'acc', // id of the accordion
			menu: 'js-acc-menu' // class to target the menu
		},

		/**
		 * callback
		 * @type {Object}
		 */
		cb: {
			open: null, // Callback on Open
			close: null // Call back on Close
		},

		/**
		 * responsive
		 * @type {Boolean}
		 */
		responsive : false, // Use responsive?

		/**
		 * scroll
		 * @type {Object}
		 */
		scroll: {
			use: false, // Use scroll
		 	scope: 'html,body', // Scroll scope
			offset_by: 60 // Integer
		},


		/**
		 * type
		 * @type {String}
		 */
		type : 'accordion', // 'accordin' or 'toggle'

		/**
		 * views
		 * @type {Object}
		 */
		views: {
			active : null, // {array}
			inactive : null, // {array}
			current : null // {string}
		}
	},

	c = _.extend(config,opts), // Extend defaults with passed options

	$accordion = document.getElementById(c.dom.id), // Object that all functions are bound to.

	isSub;

	/**
	 * Init
	 * @type {Function}
	 */
	function init() {
		if (c.responsive) {
			responsive();
			_.windowResize(responsive);

		} else {
			bindEvents();
		}

		callbacks();
	}

	/**
	 * bindEvents
	 * @type {Function}
	 * @param {el} Element to bind events to
	 */
	function bindEvents() {
		if ($accordion) {
			_.addEvent({
				id: c.dom.id,
				className: c.dom.btn,
				event: 'click',
				fn: checkState
			});

			_.windowResize(resetActive);
		}
	}

	/**
	 * unbindEvents
	 * @type {Function}
	 * @param {el} Element to bind events to
	 */
	function unbindEvents() {
		_.removeEvent({
			id: c.dom.id,
			className: c.dom.btn,
			event: 'click',
			fn: checkState
		});
	}

	/**
	 * checkActive
	 * @type {Function}
	 */
	function checkState() {


		var is_active = _.hasClass(this,c.cls.active) ? true : false,
			$menu = this.nextElementSibling,
			$parentMenu = _.parents(this,'.' + c.dom.menu);

		if ($parentMenu) {
			isSub = true;
		} else {
			isSub = false;
		}

		if (is_active) {
			closeMenu($menu);
			_.removeClass(this,c.cls.active);
		} else {
			openMenu($menu);
			_.addClass(this,c.cls.active);
		}
	}

	/**
	 * closeMenu
	 * @type {Function}
	 * @param {el} - Menu to close
	 */
	function closeMenu(el) {
		var currentHeight = el.offsetHeight,
			$activeBtns = el.querySelectorAll('.' + c.cls.active),
			$activeBtn,
			$activeMenu;

		el.style.height = currentHeight + 'px';
		el.style.visibility = 'hidden';

		var parent = el.parentNode;
		var button = parent.querySelector('button');
		button.setAttribute('aria-expanded', 'false');

		_.slideUp(el);

		if ($activeBtns.length > 0) {
			Object.keys($activeBtns).forEach(function(key) {
				$activeBtn = $activeBtns[key];
				$activeMenu = $activeBtn.nextElementSibling;
				_.removeClass($activeBtn,c.cls.active);
				_.removeClass($activeMenu,c.cls.open);
				_.slideUp($activeMenu);
			});
		}

		_.trigger($accordion,'closeCb');
	}

	/**
	 * openMenu
	 * @param {el} - Menu to open
	 */
	function openMenu(el) {
		var $activeBtn,
			$activeBtns,
			$activeMenu,
			$parentMenu;

		if (c.type === 'accordion') {

			if (isSub) {
				$parentMenu = _.parents(el,'.' + c.cls.open);
				Object.keys($parentMenu).forEach(function(key) {
					if ($parentMenu[key] && $parentMenu[key] !== el) {
						$parentMenu = $parentMenu[key];
					}
				});
				$activeBtns = $parentMenu.querySelectorAll('.'+ c.dom.btn + '.' + c.cls.active);
			} else {
				$activeBtns = $accordion.querySelectorAll('.' + c.cls.active);
			}

			if ($activeBtns.length > 0) {
				Object.keys($activeBtns).forEach(function(key) {
					$activeBtn = $activeBtns[key];
					$activeMenu = $activeBtn.nextElementSibling;
					closeMenu($activeMenu);
					_.removeClass($activeBtn,c.cls.active);
					_.removeClass($activeMenu,c.cls.open);
				});
			}


		}

		_.slideDown(el);
		el.style.visibility = 'visible';
		_.addClass(el,c.cls.open);

		var parent = el.parentNode;
		var button = parent.querySelector('button');
		button.setAttribute('aria-expanded', 'true');

		if (isSub) {
			$parentMenu = _.parents(el,'.' + c.cls.open);
			Object.keys($parentMenu).forEach(function(key) {
				if ($parentMenu[key] && $parentMenu[key] !== el) {
					$parentMenu = $parentMenu[key];
					$parentMenu.style.height = '';
				}
			});
		}

		_.trigger($accordion,'openCb');
	}

	/**
	 * closeAllMenus
	 * @type {Function}
	 */
	function closeAllMenus() {
		var $activeTriggers = $accordion.querySelectorAll('.'+ c.dom.btn + '.' + c.cls.active),
			$trigger,
			$menu,
			i;

		if ($activeTriggers.length > 0) {
			for (i=0; i<$activeTriggers.length;i++) {
				$trigger = $activeTriggers[i];
				$menu = $trigger.nextElementSibling;

				_.removeClass($trigger,c.cls.active);
				closeMenu($menu);
			}
		}
	}

	/**
	 * responsive
	 * @type {Function}
	 */
	function responsive() {
		var active_views = c.views.active,
			inactive_views = c.views.inactive,
			view,
			i;

		for (i=0;i<active_views.length;i++) {
			view = active_views[i];

			if (c.views.current !== view) {
				_.mq({
					view: view,
					callback: activeCb
				});
			}
		}

		for (i=0;i<inactive_views.length;i++) {
			view = inactive_views[i];

			if (c.views.current !== view) {
				_.mq({
					view: view,
					callback: inactiveCb
				});
			}
		}
	}

	/**
	 * active callback
	 * @return {Function}
	 */
	function activeCb() {
		var view = this.view;
		c.views.current = view;
		bindEvents();
	}

	/**
	 * inactive callback
	 * @return {Function}
	 */
	function inactiveCb() {
		var view = this.view;
		c.views.current = view;
		unbindEvents();
		resetActive(true);
	}

	/**
	 * active callback
	 * @return {Function}
	 */
	function resetActive(full_reset) {
		var $activeTriggers = $accordion.querySelectorAll('.'+ c.dom.btn + '.' + c.cls.active),
			$trigger,
			$menu,
			i,
			height;

		full_reset = full_reset === true ? true : false;

		if ($activeTriggers.length > 0) {
			for (i=0; i<$activeTriggers.length;i++) {
				$trigger = $activeTriggers[i];
				$menu = $trigger.nextElementSibling;

				if (full_reset) {
					_.removeClass($trigger,c.cls.active);
					_.removeClass($menu,c.cls.open);
					$menu.style.height = '';
					$menu.style.paddingTop = '';
					$menu.style.paddingBottom = '';
				} else {
					height = _.getHiddenStyles($menu).elHeight;
					$menu.style.height = height + 'px';
				}
			}
		}
	}

	/**
	 * callbacks
	 * @return {Function}
	 */
	function callbacks() {
		_.addEvent({
			id: $accordion,
			event: 'openCb',
			fn: function() {
				if (c.cb.open !== null) {
					c.cb.open();
				} else {
					return null;
				}
			}
		});

		_.addEvent({
			id: $accordion,
			event: 'closeCb',
			fn: function() {
				if (c.cb.close !== null) {
					c.cb.close();
				} else {
					return null;
				}
			}
		});
	}

	/**
	 * Public functions
	 * @return init
	 * @return closeAll
	 */
	return {
		init : init,
		closeAll: closeAllMenus,
		closeMenu: closeMenu,
		unbindEvents: unbindEvents
	};

};

/**
 * modal
 * @requires [lib/util.js]
 *
 * namespace
 * config
 * init
 */

/**
 * namespace
 * @type {Object}
 */
SDG.Modal = SDG.Modal || {};

/**
 * config
 * @type {Object}
 */
SDG.Modal.config = {
	/**
	 * autoshow
	 */
	autoshow: false, // Auto show modal on page load.
	autoshow_delay: 250, // Delay before executing auto show

	/**
	 * callback
	 */
	cb: {
		after_close: null, // Callback to be initialized after close is complete
		after_open: null, // Callback to be initialized after open is complete
		before_close: null, // Callback to be initialized before close is complete
		before_open: null // Callback to be initialized before open is complete
	},

	cls: {
		close_btn: 'js-modal-close',
		modal_class: 'js-modal', // Class of the modal
		overflow: 'overflow-hidden',
		visible: 'is-visible',
	},

	/**
	 * dom vars
	 */
	dom: {
		modal_id: 'modal', // Id of modal
		trigger: 'modalTrigger', // Id of the trigger to show the modal.
	},

	/**
	 * Timer
	 */
	timer: {
		close: null, // Delay for close animation
		default: 250, // Default delay
		open: null // Delay for open animation
	}
};

/**
 * init
 * @param  {Object} opts Can be used to overwrite default config object
 * @return {Object}
 */
SDG.Modal.init = function(opts) {

	/**
	 * config object
	 * @type {Object}
	 */
	var c = _.extend(SDG.Modal.config,opts);

	/**
	 * cached elements
	 */
	var modal = document.getElementById(c.dom.modal_id),
		overlay = modal ? modal.nextElementSibling : null;

	/**
	 * init
	 * @return {function} add events and check for autoshow
	 */
	function init() {

		if (modal) {
			addEvents();
			mapTimers();

			if (c.autoshow) {
				setTimeout(function() {
					openModal(modal);
				},c.autoshow_delay);
			}
		}
	}

	/**
	 * add events
	 * @description executes all event functions
	 */
	function addEvents() {
		openEvent();
		closeEvent();
		kbEvent();
		callbacks();
	}

	/**
	 * map timers
	 * @description setting close timer and open timer if they are not set
	 */
	function mapTimers() {
		if (c.timer.close === null) c.timer.close = c.timer.default;
		if (c.timer.open === null) c.timer.open = c.timer.default;
	}

	/**
	 * open event
	 * @description add event listener top open modal
	 */
	function openEvent() {
		if (c.dom.trigger) {
			_.addEvent({
				id: c.dom.trigger,
				event: 'click',
				fn: openModal
			});
		}
	}

	/**
	 * close event
	 * @description add event listener to close modal
	 */
	function closeEvent() {
		_.addEvent({
			id: c.dom.modal_id,
			className: c.cls.close_btn,
			event: 'click',
			fn: closeModal
		});
	}

	/**
	 * keyboard event
	 * @description add key board event on keyup
	 */
	function kbEvent() {
		document.addEventListener('keyup',getKey);
	}

	/**
	 * get key pressed
	 * @description function that's executed on keypress. checks the keycode value, if it matches with the escape key close all modals.
	 */
	function getKey(e) {
		if (e.keyCode === 27) {
			closeModal();
		}
	}

	/**
	 * open modal
	 * @param {string | domElement} - Can be the id string of the element, or the selected element in the dom. If neither is set the modal associated with the bound trigger event will display.
	 */
	function openModal(el) {

		var toOpen,
			toOpenOverlay;

		if (el && typeof el === 'string') {
			toOpen = document.getElementById(el);
			toOpenOverlay = toOpen.nextElementSibling;
		} else {
			toOpen = modal;
			toOpenOverlay = overlay;
		}



		if (toOpen) {
			_.addClass(document.body,c.cls.overflow);
			_.addClass(toOpen,c.cls.visible);
			_.addClass(toOpenOverlay,c.cls.visible);

			// Trigger Callbacks before the modal opens
			_.trigger(modal,'beforeOpenCb');

			setTimeout(function() {
				_.trigger(modal,'afterOpenCb');
				trapFocus(toOpen);
			},c.timer.open);
		}
	}

	/**
	 * close modal
	 * @param {string | domElement} - Can be the id string of the element, or the selected element in the dom. If neither is set all registered modals on the page will close
	 */

	// With Callback
	function closeModal(el) {
		var toClose,
			toCloseOverlay;

		if (el && typeof el === 'string') {
			toClose = document.getElementById(el);
			toCloseOverlay = toClose.nextElementSibling;
		} else {
			toClose = modal;
			toCloseOverlay = overlay;
		}

		if (toClose) {

			_.removeClass(document.body,c.cls.overflow);
			_.removeClass(modal,c.cls.visible);
			_.removeClass(toCloseOverlay,c.cls.visible);

			// Trigger callbacks before modal closes
			_.trigger(modal,'beforeCloseCb');

			setTimeout(function() {
				_.trigger(modal,'afterCloseCb');
				 if (c.dom.trigger) {
                    document.getElementById(c.dom.trigger).focus();
                }
			},c.timer.close);
		}
		for (var i = 0; i < window.nonModalNodes.length; i++) {
	      var node = window.nonModalNodes[i];
	      if (node._prevTabindex) {
	        node.setAttribute('tabindex', node._prevTabindex);
	        node._prevTabindex = null;
	      }
	      else {
	        node.removeAttribute('tabindex');
	      }
	    }
	}

	// Without callback
	function closeModalNoCb(el) {
		var toClose,
			toCloseOverlay;

		if (el && typeof el === 'string') {
			toClose = document.getElementById(el);
			toCloseOverlay = toClose.nextElementSibling;
		} else {
			toClose = modal;
			toCloseOverlay = overlay;
		}

		if (toClose) {
			_.removeClass(document.body,c.cls.overflow);
			_.removeClass(modal,c.cls.visible);
			_.removeClass(toCloseOverlay,c.cls.visible);
		}

		for (var i = 0; i < window.nonModalNodes.length; i++) {
	      var node = window.nonModalNodes[i];
	      if (node._prevTabindex) {
	        node.setAttribute('tabindex', node._prevTabindex);
	        node._prevTabindex = null;
	      }
	      else {
	        node.removeAttribute('tabindex');
	      }
	    }
	}

	/**
	 * callbacks
	 * @type {function}
	 */
	function callbacks() {
		_.addEvent({
			id: c.dom.modal_id,
			event: 'afterOpenCb',
			fn: function() {
				if (c.cb.after_open !== null) {
					c.cb.after_open();
				} else {
					return null;
				}
			}
		});

		_.addEvent({
			id: c.dom.modal_id,
			event: 'afterCloseCb',
			fn: function() {
				if (c.cb.after_close !== null) {
					c.cb.after_close();
				} else {
					return null;
				}
			}
		});

		_.addEvent({
			id: c.dom.modal_id,
			event: 'beforeOpenCb',
			fn: function() {
				if (c.cb.before_open !== null) {
					c.cb.before_open();
				} else {
					return null;
				}
			}
		});

		_.addEvent({
			id: c.dom.modal_id,
			event: 'beforeCloseCb',
			fn: function() {
				if (c.cb.before_close !== null) {
					c.cb.before_close();
				} else {
					return null;
				}
			}
		});
	}

	/**
	* Function Trap Focus to Modal
	* @type {function}
	* @param {domElement} - modal element in the dom.
	*/

	function trapFocus(element)
	{
	    var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="submit"]:not([disabled]), input[type="email"]:not([disabled]), select:not([disabled])'),
	        firstFocusableEl = focusableEls[0],
	        lastFocusableEl = focusableEls[focusableEls.length - 1],
	        KEYCODE_TAB = 9;

	    firstFocusableEl.focus(); // Focus to first focusable element in the modal

	    element.addEventListener('keydown', function(e) {
	        var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

	        if (!isTabPressed) { 
	            return; 
	        }

	        if ( e.shiftKey ) /* shift + tab */ {
	            if (document.activeElement === firstFocusableEl) {
	                lastFocusableEl.focus();
	                e.preventDefault();
	            }
	        } else /* tab */ {
	            if (document.activeElement === lastFocusableEl) {
	                firstFocusableEl.focus();
	                e.preventDefault();
	            }
	        }
	    });
	}

	/**
	 * return
	 * @type {Object}
	 */
	return {
		init: init,
		open: openModal,
		close: closeModal,
		close_no_callback: closeModalNoCb
	};
};

/**
 * namespace
 * @type {Object}
 */
SDG.Modal = SDG.Modal || {};

/**
 * get modal html
 * @type {Function}
 */
SDG.Modal.getHtml = function(opts) {
	/**
	 * config
	 * @type {Object}
	 */
	var config = {
		html : null,
		modal : null,
		modifier : null,
		overlay : null
	},

	// Extended config
	c = _.extend(config,opts);

	/**
	 * get html
	 * @type {Function}
	 * @return {String}
	 */
	function getHtml() {
		var html = '<aside id="'+ c.modal +'" class="modal'+ (c.modifier ? ' modal--'+c.modifier +' '+ c.modifier : '') +'">'+
			'<div class="modal__inner'+ (c.modifier ? ' modal__inner--'+c.modifier : '') +'">'+
				'<button type="button" class="btn-icon modal__close js-modal-close">'+
					'<i class="icon icon--close"></i>'+
					'<span class="screenreader">Close</span>'+
				'</button>'+
				'<div id="'+ (c.modifier ? c.modifier + 'ModalContent' : 'genModalContent') +'" class="modal__loaded-content">'+
					(c.html ? c.html : '')+
				'</div>'+
			'</div>'+
		'</aside>'+
		'<div id="'+ c.overlay +'" class="modal-overlay">';

		return html;
	}

	/**
	 * return object
	 */
	return getHtml();
};
/**
 * namespace
 * @type {Object}
 */
SDG.Modal = SDG.Modal || {};

/**
 * clear modal html
 * @type {Function}
 */
SDG.Modal.clear = function(opts) {
	var config = {
		modal: null,
		overlay: null,
		remove_parent: false
	},

	c = _.extend(config,opts),

	modal = document.getElementById(c.modal),
	overlay = document.getElementById(c.overlay),
	parent = modal.parentNode;

	var init = function() {

		if (opts !== undefined) {
			modal.remove();
			overlay.remove();

			if (c.remove_parent) {
				parent.remove();
			}
		}
	};

	return init();
};
/**
 * header namespace
 * @requires [lib/util.js, lib/modal.js]
 *
 * config
 * nav
 * search
 * init
 */
/**
 * header namespace
 * @return  {Object}
 */
SDG.Header = SDG.Header || {};

/**
 * config
 * @type {Object}
 */
SDG.Header.config = {
	// Header Id
	id : 'hdr',
	main: 'main',

	// Nav Config
	nav: {
		active: 'is-active',
		btn: 'js-navm-btn',
		desktop_btn: '.js-nav-btn',
		id: 'navm',
		menu: 'navmMenu',
		menu_btn: 'js-navm-menu-btn',
		menu_the_rest: 'navmTheRest',
		overlay: 'navmMenuOverlay',
		visible: 'is-visible'
	},

	// Search config
	search: {
		btn: 'modalSearchBtn',
		input: 'searchInputMobile',
		modal: 'modalSearch',
		modal_overlay: 'modalSearchOverlay'
	}
};


/**
 * nav
 * @type {Function}
 */
SDG.Header.nav = function(opts) {
	var c = _.extend(SDG.Header.config, opts);
	var modal = SDG.Modal.init({
		cb: {
			before_close: closeCb
		},
		dom: {
			modal_id: c.nav.menu,
			overlay: c.nav.overlay,
			trigger: null
		}
	});
	var domNav = document.getElementById(c.nav.id);
	var desktopNavs = document.querySelectorAll(c.nav.desktop_btn);
	var modalOpen = false;
	var activeMenu = null;

	/**
	 * init
	 * @return {Function}
	 */
	function init() {
		modal.init();


		desktopNavs.forEach(function(nav){
			nav.addEventListener('keydown', function(event) {

				if(event.keyCode === 32 || event.keyCode === 13) {
					event.preventDefault();

					var parent = event.target.parentNode;
					var aria = event.target.getAttribute('aria-expanded');
					var getSiblings = function (elem) {
						var siblings = [];
						var sibling = elem.parentNode.firstChild;
						while (sibling) {
							if (sibling.nodeType === 1 && sibling !== elem) {
								siblings.push(sibling);
							}
							sibling = sibling.nextSibling;
						}
						return siblings;
					};

					var siblings = getSiblings(parent);

					siblings.forEach(function(sibling){
						sibling.classList.remove('hovered');
					});

					if(aria === false) {
						aria = true;

					} else {
						aria = false;
					}

					event.target.setAttribute('aria-expanded', aria);
					parent.classList.toggle('hovered');

				}

			  });

		});

		_.addEvent({
			id: c.nav.id,
			className: c.nav.btn,
			event: 'click',
			fn: showMenu
		});

		// the rest menu button click
		_.addEvent({
			id: c.nav.menu_the_rest,
			className: c.nav.menu_btn,
			event: 'click',
			fn: onTheRestMenuButtonClick
		});
	}

	/**
	 * show menu
	 * @return {Function}
	 */
	function showMenu() {
		var isActive = _.hasClass(this,c.nav.active),
			menu = this.getAttribute('data-menu');

		if (isActive) {
			modal.close();
		} else {
			// clear all current active menus
			clearActiveMenus();

			// set active menu
			activeMenu = document.getElementById(menu);

			// if the modal is not open, then open the modal
			if (!modalOpen) {
				modal.open();
				modalOpen = true;
			}

			// set clicked element to active
			_.addClass(this,c.nav.active);

			// set active menu to visible
			_.addClass(activeMenu,c.nav.visible);
		}
	}

	/**
	 * clear active menu
	 * @type {Function}
	 */
	function clearActiveMenus() {
		var activeBtns = domNav.querySelectorAll('.' + c.nav.active),
			activeBtn,
			i;

		// check if there were any active buttons
		if (activeBtns.length > 0) {

			// loop through active buttons array
			for (i=0;i<activeBtns.length;i++) {
				activeBtn = activeBtns[i];

				// remove active nav button
				_.removeClass(activeBtn,c.nav.active);
			}

			// hide active nav menu
			_.removeClass(activeMenu,c.nav.visible);
		}
		activeMenu = null;
	}

	/**
	 * close all menus
	 */
	function closeAllMenus() {
		clearActiveMenus();
		modal.close();
	}

	/**
	 * on the rest menu button click
	 */
	function onTheRestMenuButtonClick() {
		var url = this.getAttribute('href'),
			urlContainsHash = url.indexOf('#') !== -1;

		// if url contains hash, close menu
		if (urlContainsHash) {
			closeAllMenus();
		}
	}

	/**
	 * close callback
	 * @type {Function}
	 */
	function closeCb() {
		clearActiveMenus();
		modalOpen = false;
	}

	return {
		init: init
	};
};

/**
 * search
 * @type {Function}
 */
SDG.Header.search = function() {
	var c = SDG.Header.config,

	/**
	 * register modal
	 * @type {Function}
	 */
	modal = SDG.Modal.init({
		cb: {
			before_close: closeCb,
			after_open: openCb
		},
		dom: {
			modal_id: c.search.modal,
			overlay: c.search.modal_overlay,
			trigger: c.search.btn
		}
	}),

	searchInput = document.getElementById(c.search.input);

	/**
	 * init
	 * @type {Function}
	 */
	function init() {
		modal.init();
	}

	/**
	 * close callback
	 * @type {Function}
	 */
	function closeCb() {
		searchInput.blur();
	}

	/**
	 * open callback
	 * @type {Function}
	 */
	function openCb() {
		searchInput.focus();
	}

	/**
	 * public functions
	 */
	return init();
};

SDG.Header.promo = function(Flickity) {
	var c = SDG.Header.config,
	 	mainSlide,
		hdrPromo = '#promo-carousel';
	var $promoCarousel = document.querySelector('#promo-carousel');


	mainSlide = new Flickity(hdrPromo, {
		// options
		contain: false,
		autoPlay: 10000,
		prevNextButtons: false,
		adaptiveHeight: true,
		pageDots: false
	});


	$promoCarousel.addEventListener('focusin', function(event) {
		mainSlide.pausePlayer();
	});

	$promoCarousel.addEventListener('focusout', function (event) {
		mainSlide.unpausePlayer();
	});

	responsive();
	_.windowResize(responsive);

	function responsive() {
		_.mq({
			view: 'mobile',
			callback: observePromoChanges
		});
	}

	function observePromoChanges() {
		adjustPaddingTop();

		mainSlide.on('select', function() {
			adjustPaddingTop();
		});
	}

	function adjustPaddingTop() {
		var $header = document.getElementById(c.id),
			$headerHeight = $header.clientHeight,
			$main = document.getElementById(c.main);

		$main.style.paddingTop = $headerHeight+'px';
	}
};

/**
 * init
 * @type {Function}
 */
SDG.Header.init = function() {
	// store nav
	function headerNavStore() {
		var path = window.location.pathname;
		var $baby = document.getElementById('baby-nav');
		var $kids = document.getElementById('kids-nav');
		var $furBaby = document.getElementById('fur-baby-nav');

		if (path.includes('kids')) {
			_.addClass($kids, 'is-active');
		} else if (path.includes('fur-baby')) {
			_.addClass($furBaby, 'is-active');
		} else {
			_.addClass($baby, 'is-active');
		}
	}
	headerNavStore();

	// nav
	SDG.Header.nav().init();

	// Search
	SDG.Header.search();

	require([path.flickity], function(Flickity){
		SDG.Header.promo(Flickity);
	});
};

/**
 * messages
 * @requires [lib/util.js]
 */
/**
 * namespace
 * @type {Object}
 */
SDG.Messages = SDG.Messages || {};

/**
 * config
 * @type {Object}
 */
SDG.Messages.config = {
	animation: {
		type: 'slideDown'
	}, // slideDown or fadeIn
	cls: {
		show: 'is-visible'
	},
	id: null,
	dom: {
		error: 'message--error',
		msg: 'message',
		success: 'message--success'
	},
	msgs: {
		error: '<p>Failed.</p>',
		success: '<p>Success!</p>'
	},
	timer: {
		hide: 200,
		show: 200
	}
};

/**
 * @param  {Object} opts extend config option
 * @return {Function}
 */
SDG.Messages.init = function(opts) {
	/**
	 * extend config object
	 */
	var c = JSON.parse(JSON.stringify(SDG.Messages.config));
	c = _.extend(c,opts);

	/**
	 * cached dom elements
	 */
	var domMsgs;
	if (typeof(c.id) === 'string') {
		domMsgs = document.getElementById(c.id);
	} else {
		domMsgs = c.id;
	}

	/**
	 * show success
	 * @param  {String} val custom message value
	 */
	function showSuccess(val) {
		if (domMsgs) {
			var msg = c.msgs.success,
				html;

			if (val) {
				msg = val;
			}

			html = '<div class="'+ c.dom.msg +' '+ c.dom.success +'">'+ msg +'</div>';

			domMsgs.innerHTML = html;

			if (c.animation.type === 'slideDown') {
				_.slideDown(domMsgs,c.timer.show);
			} else {
				_.show(domMsgs);
				setTimeout(function() {
					_.addClass(domMsgs,c.cls.show);
				},1);
			}

		} else {
			console.log('No message block was found.');
		}
	}

	/**
	 * show error
	 * @param  {String} val custom message value
	 */
	function showError(val) {

		if (domMsgs) {
			var msg = c.msgs.error,
				html;

			if (val) {
				msg = val;
			}

			html = '<div class="'+ c.dom.msg +' '+ c.dom.error +'">'+ msg +'</div>';

			domMsgs.innerHTML = html;

			_.slideDown(domMsgs,c.timer.show);

		} else {
			console.log('No message block was found.');
		}
	}

	function clearMessages() {
		_.slideUp(domMsgs,c.timer.hide);

		_.transition({
			after: domMsgs.empty,
			time: c.timer.hide
		});
	}

	return {
		clear: clearMessages,
		error: showError,
		success: showSuccess
	};

};
/**
* incrementer
* @requires [lib/util.js]
*/
SDG.incrementer = function(opts) {
	/**
	 * config
	 * @type {Object}
	 */
	var config = {
		action: {
			remove: 'remove',
			add: 'add'
		},
		cb: null,
		cls: {
			loading: 'is-loading'
		},
		dom: {
			btn: 'js-increment-btn',
			id: 'bag',
			increment: '.js-increment',
			input: '.js-increment-input',
			item: '.js-bag-item'
		},
		timer: 500
	};

	/**
	 * extend config with passed options
	 */
	var c = _.extend(config,opts);

	/**
	 * cached globals
	 */
	var $id = document.getElementById(c.dom.id),
		delay;

	/**
	 * init
	 * @return {Function}
	 */
	function init() {
		bindEvents();
	}

	/**
	 * bind events
	 * @return {Function}
	 */
	function bindEvents() {
		_.addEvent({
			id: $id,
			className: c.dom.btn,
			event: 'click',
			fn: increment
		});
	}

	/**
	 * increment
	 */
	function increment(e) {
		/**
		 * vars
		 */
		var item = {},
			newQty;

		/**
		 * item attributes
		 */
		item.increment = _.parents(this,c.dom.increment)[0];
		item.input = item.increment.querySelector(c.dom.input);
		item.el = _.parents(this,c.dom.item)[0];
		item.action = this.getAttribute('data-action');
		item.id = item.el.getAttribute('data-variant-id');

		var qty = parseInt(item.input.value);

		/**
		 * clear timeout
		 */
		clearTimeout(delay);

		/**
		 * get newQty
		 */
		if (item.action === c.action.add) {
			newQty = qty + 1;
		} else {
			if (qty > 0) {
				newQty = qty - 1;
			} else {
				newQty = 0;
			}
		}

		item.input.value = newQty;

		/**
		 * callback
		 */
		if (c.cb) {
			delay = setTimeout(function() {
				c.cb(item,newQty);
			},c.timer);
		}

	}

	return init();
};
/**
 * calculate discount based on cart items (for cart page)
 */

SDG.Discount = SDG.Discount || {};

SDG.Discount.calculate = function(cartItems) {
	var subsPrice = 0;

	function init() {
		checkCart();
	}

	function checkCart() {

		cartItems.forEach(function(item, i) {

			// if the item is a subscription product
			if (item.properties && item.properties.shipping_interval_frequency) {
				var priceToAdd = (item.price * item.quantity)/100;
				subsPrice += priceToAdd;
			}

			// on last loop, apply discount to final price
			if (i === cartItems.length - 1) {
				applyDiscount(subsPrice);
				// SDG.Bag.subtotal = subsPrice;
			}
		});
	}

	function applyDiscount(subtotal) {
		if (subtotal < 40) {
			SDG.deleteCookie('subscription_discount');
		} else if (subtotal >= 40 && subtotal < 141) {
			SDG.setCookie('subscription_discount', '10_OFF');
		} else if (subtotal >= 141 && subtotal < 200) {
			SDG.setCookie('subscription_discount', '15_OFF');
		} else if (subtotal >= 200) {
			SDG.setCookie('subscription_discount', '20_OFF');
		}
	}

	return init();

};
/**
* namespace
* @type {Object}
*/
SDG.Bag = SDG.Bag || {};

/**
* data
* @type {Object}
*/
SDG.Bag.data = SDG.Bag.data || {};

/**
* config
* @type {Object}s
*/
SDG.Bag.config = {
	cls: {
		active: 'is-active',
		empty: 'is-empty',
		expose: 'is-bag-exposed',
		loading: 'is-loading'
	},
	dom: {
		bag: 'bag',
		bag_btn: 'bagBtn,cartBtnMobile',
		bag_close: 'bagClose,bagContinue,bagOverlay',
		bag_empty: 'bagEmpty',
		item: '.js-bag-item',
		items: 'bagItems',
		remove: 'js-bag-item-remove',
		subtotal: 'bagSubtotal'
	},
	icon: {
		remove: 'icon--trash',
		add: 'icon--plus-white',
		substract: 'icon--minus-white'
	},
	img: {
		std: '123x',
		rtn: '246x'
	},
	show_event: 'click', // click, mouseenter
	timer: {
		hover: 1500,
		slide_up: 400 // This should match the animation speed of your slideup animation. Typically this is set to $normal-timer in _timers.scss file.
	},
	url: {
		cart: '/cart.js',
		update: '/cart/change.js',
		update_entire: '/cart/update.js'
	},
	use_swatch: false // sets whether to use a swatch in the bag item for color display instead of the label. Set to false to show label instead.
};
/**
* refresh
* @requires [lib/util.js,lib/incrementer,lib/bag-config.js,lib/bag-empty.js,lib/bag-update.js,lib/bag-init.js]
* @type {Function}
*/
SDG.Bag.refresh = function() {
	/**
	 * shorthand config object
	 */
	var c = SDG.Bag.config;

	/**
	 * cached globals
	 */
	var $bag = document.getElementById(c.dom.bag),
		$list = document.getElementById(c.dom.items);

	function init() {
		_.ajax({
			error: onError,
			success: onSuccess,
			type: 'GET',
			url: c.url.cart + '?ts='+ Date.now().toString()
		});
	}

	function onError() {
		console.log('Bag refresh error with ajax request.');
	}

	function onSuccess(e) {
		if (e) {
			if (e.items.length > 0) {
				getItems(e);
				SDG.Bag.empty(false);
			} else {
				SDG.Bag.empty(true);
			}

			SDG.Bag.Cart = e;

			// Free give away item
			if (typeof giveawayProduct !== 'undefined') {
				SDG.giveaway();
			}

			SDG.removePastGiveawayItem();

			// gift wrapping
			SDG.Bag.GiftWrap();

			// gift message
			SDG.Bag.giftMessage();
			
			SDG.hideIncrementOnSamples();

			SDG.Bag.Count.set(e.item_count);
		}
	}

	function getItems(data) {
		var html = '',
			item,
			items = data.items;

		_.removeClass($bag,c.cls.empty);

		Object.keys(items).forEach(function(k) {
			item = getItemHtml(items[k]);
			html += (item);
		});

		$list.innerHTML = html;

		SDG.incrementer({
			cb: SDG.Bag.updateItemQty
		});
		bindEvents();

		SDG.Bag.recalc(data.total_price, data.items, data.original_total_price);
	}

	function bindEvents() {
		_.addEvent({
			id: $list,
			className: c.dom.remove,
			event: 'click',
			fn: beforeRemoveItem
		});
	}

	function beforeRemoveItem(e) {
		e.preventDefault();
		var item = getItem(this);
		SDG.Bag.updateItemQty(item,0);
	}

	function getItemHtml(obj) {

		var title = (obj.product_title.indexOf('™') === -1 ? obj.product_title : '<span class="bag__item-tm">'+ obj.product_title.split('™')[0] + '™</span>' + obj.product_title.split('™')[1]),
			img = obj.image,
			img_alt = 'Photo - '+ obj.product_title,
			url = obj.url,
			original_price = obj.original_line_price,
			sale_price = obj.total_discount,
			variantId = obj.variant_id,
			giveawayProduct = obj.properties ? obj.properties._giveaway : false,
			currentQty = obj.quantity,
			originalPriceDisplay = _.formatPriceDisplay(original_price),
			img_std,
			img_rtn,
			item = '',
			salePriceDisplay;

		// set img
		img = img ? img : assetUrl + 'no-image.gif';
		img_std = _.getSizedImageUrl(img, '105x');
		img_rtn = _.getSizedImageUrl(img, '210x');

		// set sale price
		if (sale_price !== 0) {
			salePriceDisplay = _.formatPriceDisplay(obj.line_price);
		}

		// Item Start
		item += '<div class="bag-item js-bag-item '+ (giveawayProduct ? 'giveaway-item' : '') +'" id="bagItem'+ variantId +'" data-variant-id="'+ variantId +'" data-qty="'+ currentQty +'">';

		// Image
		item += '<figure class="bag-item__photo">'+
						'<img class="lazyload" data-srcset="'+ img_std +' 1x, '+ img_rtn +' 2x" alt="'+ img_alt  +'" />'+
				'</figure>';

		// Start description
		item += '<div class="bag-item__info">';

		// Desc
		item +=	'<div class="bag-item__desc">'+
					'<header class="bag-item__header">'+
						'<h4 class="bag-item__title">'+
							'<a href="'+ url +'">'+
								title +
							'</a>'+
						'</h4>'+
					'</header>'+
					'<p class="bag-item__variants">'+
						getItemVariants(obj) +
					'</p>'+
					'<p class="bag-item__price hide-phone">'+
						'<span id="po'+ variantId +'" class="bag-item__price-orginal' + (sale_price !==  0 ? ' bag-item__price-compare':'') + '">' + originalPriceDisplay + '</span>'+
						(sale_price !==  0 ? '<span id="ps'+ variantId +'" class="bag-item__price-sale">'+ salePriceDisplay +'</span>':'') +
					'</p>'+
				'</div>';

		// Actions
		item += '<div class="bag-item__actions">'+
					'<p class="bag-item__price phone-only">'+
						'<span id="mpo'+ variantId +'" class="bag-item__price-orginal' + (sale_price !==  0 ? ' bag-item__price-compare':'') + '">' + originalPriceDisplay + '</span>'+
						(sale_price !==  0 ? '<span id="mps'+ variantId +'" class="bag-item__price-sale">'+ salePriceDisplay +'</span>':'') +
					'</p>'+
					'<div class="bag-item__qty">'+
						'<p class="bag-item__qty-label">qty:</p>'+
						'<div class="bag-item__increment increment js-increment">'+
							'<input type="number" name="quantity" value="'+ currentQty +'" size="3" class="increment__input js-increment-input" tabindex="-1" />'+
							'<button type="button" class="increment__btn increment__add js-increment-btn" data-action="add">'+
								'<i class="increment__icon increment__icon--add"></i>'+
								'<span class="screenreader">Add</span>'+
							'</button>'+
							'<button type="button" class="increment__btn increment__subtr js-increment-btn" data-action="remove">'+
								'<i class="increment__icon increment__icon--subtr"></i>'+
								'<span class="screenreader">Subtract</span>'+
							'</button>'+
						'</div>'+
					'</div>'+
					'<a href="/cart/change/'+ variantId +'?quantity=0" title="Remove item" class="bag-item__remove js-bag-item-remove btn-icon" role="button" data-variant-id="'+ variantId +'">'+
					 	'<i class="bag-item__remove-icon icon '+ c.icon.remove +'"></i>'+
						'<span class="bag-item__remove-label">Remove</span>'+
					'</a>'+
				'</div>';

		// End Description, Item
		item += '</div></div>';

		return item;

	}

	function getItemVariants(obj) {
		/**
		 * shorthand config
		 */
		var c = SDG.Bag.config;

		/**
		 * vars
		 */
		var count,
			handle = obj.handle,
			i,
			isColor = false,
			label,
			variant,
			variants = obj.variant_options,
			html = '',
			swatch,
			swatchRetina;

		if (variants) {
			count = variants.length;

			for (i=0;i<count;i++) {
				variant = variants[i].toLowerCase();

				label = _.remapSizeValues(variant);

				isColor = handle.indexOf(label) !== -1 ? true : false;

				if (label && label !== 'default title') {
					if (isColor && c.use_swatch) {
						swatch = assetUrl + _.getSizedImageUrl('swatch-'+ label +'.jpg');
						swatchRetina = assetUrl + _.getSizedImageUrl('swatch-'+ label +'.jpg');

						html += '<span class="bag-item__variant bag-item__variant-color">'+
								'<img data-srcset="'+ swatch +' 1x, '+ swatchRetina +' 2x" class="lazyload" alt="'+ label +'" />'+
							'</span>';
					} else {
						html += '<span class="bag-item__variant">'+ label +'</span>';
					}
				}
			}
		}

		return html;
	}

	function getItem($el) {
		var item = {};

		item.el = _.parents($el,c.dom.item)[0];

		item.id = item.el.getAttribute('data-variant-id');

		return item;
	}

	return init();
};
SDG.Bag.subtotal = 0;

/**
 * recalculate totals
 */
SDG.Bag.recalc = function(price, items, comparePrice) {
	var c = SDG.Bag.config,
		$sub = document.getElementById(c.dom.subtotal),
		priceWithCompare,
		nt;


	if (typeof(price) !== 'undefined') {
		SDG.Bag.subtotal = price/100;

		// recalculate subscription discount
		SDG.Discount.calculate(items);

		// free shipping message
		SDG.Bag.freeShippingMessage();

		nt = _.formatPriceDisplay(price);
		$sub.innerHTML = nt;

		if (comparePrice > price) {
			comparePrice = _.formatPriceDisplay(comparePrice);
			priceWithCompare = '<span class="bag__total-value--compare">' + comparePrice + '</span>' + 
							   '<span class="bag__total-value--sale">' + nt + '</span>';
			$sub.innerHTML = priceWithCompare;
		} else {
			$sub.innerHTML = nt;
		}
	}
};
/**
 * recalculate single item price based on its qty
 */
SDG.Bag.recalcItemPrice = function(itemId){
    var bagItems = SDG.Bag.Cart.items,
        originalPriceLine = document.getElementById('po' + itemId),
        originalPriceLineMob = document.getElementById('mpo' + itemId),
        salePriceLine = document.getElementById('ps' + itemId),
        salePriceLineMob = document.getElementById('mps' + itemId);
 
   
    bagItems.forEach(function(item){
        var id = item.id.toString();
        if(id === itemId){
            var itemPrice = item.original_line_price,
                itemSalePrice = item.line_price;
             
            if(originalPriceLine){
                originalPriceLine.textContent = _.formatPriceDisplay(itemPrice);
            }
            if(originalPriceLineMob){
                originalPriceLineMob.textContent = _.formatPriceDisplay(itemPrice);
            }
            if(salePriceLine){
                salePriceLine.textContent = _.formatPriceDisplay(itemSalePrice);
            }
            if(salePriceLineMob){
                salePriceLineMob.textContent = _.formatPriceDisplay(itemSalePrice);
            }

            /*console.log(originalPriceLine);
            console.log('id: ' + id);
            console.log('Original price: ' + itemPrice);
            console.log('Sale price: ' + itemSalePrice);*/
        }          
    });        
};
/**
 * bag empty
 */
SDG.Bag.empty = function(empty) {
	var c = SDG.Bag.config,
		$bag = document.getElementById(c.dom.bag);

	if (empty) {
		_.addClass($bag,c.cls.empty);
	} else {
		_.removeClass($bag,c.cls.empty);
	}
};
/**
 * bag count
 * @requires [lib/util.js,lib/bag-config.js]
 * namespace
 * bag config
 * count config
 * extend bag config
 * count
 */

/**
 * namespace
 * @type {Object}
 */
 SDG.Bag = SDG.Bag || {};

/**
 * bag config
 * @type {Object}
 */
SDG.Bag.config = SDG.Bag.config || {};

/**
* count config
* @type {Object}
*/
SDG.Bag.config_count = {
	dom: {
		count: 'bagCount',
		count_page: 'bagCount',
		page: 'your-shopping-cart'
	},
	use: {
		hide_empty_count: false
	},
	suffix: {
		text: 'item'
	}
};

/**
 * extend bag config
 * @type {Object}
 */
SDG.Bag.config = _.extend(SDG.Bag.config,SDG.Bag.config_count);

SDG.Bag.Count = {

	count: null,

	/**
	 * get
	 * @return {number} bag count (number of items in bag)
	 */
	get: function() {
		return this.count;
	},

	/**
	 * set
	 * @param {number|string} n number
	 */
	set: function(n) {
		/**
		 * shorthand config
		 */
		var c = SDG.Bag.config;

		/**
		 * vars
		 */
		var $page = document.getElementById(c.dom.page);

		/**
		 * ensure n is a number
		 */
		n = typeof n !== 'string' ? n : parseInt(n);

		this.count = n;

		if (n === 0 || n > 1 ) {
			n = n + ' ' + '<span class="bag__count-text">'+ c.suffix.text + 's' + '</span>';
		} else {
			n = n + ' ' + '<span class="bag__count-text">'+ c.suffix.text + '</span>';
		}

		if ($page) {
			this.updateCount(c.dom.count_page,n);

		} else {
			this.updateCount(c.dom.count,n);
		}
	},
	updateCount: function(el,n) {
		var $count,
			arr,
			i;

		if (_.isDelimitedArray(el)) {
			arr = el.split(',');

			for (i=0;i<arr.length;i++) {
				$count = document.getElementById(arr[i]);

				this.setCountVisibility($count,n);
			}
		} else {
			$count = document.getElementById(el);

			this.setCountVisibility($count,n);

		}
	},
	setCountVisibility: function(el,n) {
		el.innerHTML = n;

		if (n === 0) {
			if (SDG.Bag.config.use.hide_empty_count) {
				_.hide(el);
			}
		} else {
			_.show(el);
		}
	}
};
/**
 * close bag
 * @return {Function} removes expose class from the body
 */
SDG.Bag.updateItemQty = function(item,qty) {
	/**
	 * shorthand config
	 */
	var c = SDG.Bag.config,
		data = {
			quantity: qty,
			id: item.id
		};

	function init() {
		_.addClass(item.el,c.cls.loading);

		_.ajax({
	 		dataObject: data,
	 		error: onError,
	 		success: updateItem,
	 		type: 'POST',
	 		url: c.url.update
	 	});
	}

	function updateItem(data) {
		if (qty === 0) {
			_.slideUp(item.el);
			_.transition({
				after: removeItemEl(item.el),
				timer: c.timer.slide_up
			});
		} else {
			_.removeClass(item.el,c.cls.loading);
		}

		if (data.item_count === 0) {
			SDG.Bag.empty(true);
		}

		// Refresh cart object
		SDG.Bag.Cart = data;

		// Add Free Item
		if (typeof giveawayProduct !== 'undefined') {
			SDG.giveaway();
		}

		SDG.Bag.Count.set(data.item_count);

		SDG.Bag.recalcItemPrice(item.id);

		SDG.Bag.recalc(data.total_price, data.items, data.original_total_price);
	}

	function removeItemEl(item) {
		item.remove();
	}

	function onError(e) {
		console.warn('Error updating item ' + item.id);
		console.warn(e);
	}

	return init();

};
/**
 * gift message
 * @requires [lib/util.js,lib/bag-config.js]
 * namespace
 * bag config
 */

/**
 * namespace
 * @type {Object}
 */
 SDG.Bag = SDG.Bag || {};
 /**
  * bag config
  * @type {Object}
  */
 SDG.Bag.config = SDG.Bag.config || {};

 /**
 * Gift Message config
 * @type {Object}
 */
 SDG.Bag.gift_message = {
	 dom: {
		giftMessage: 'giftMessage',
		giftMessageLabel: 'giftMessageLabel',
 		giftMessageCheckbox: 'giftMessageCheckbox',
 		giftMessageTextarea: 'giftMessageTextarea',
		giftMessageTextWrapper: 'giftMessageTextWrapper'
 	},
	blur: 'keyup'
 };


 /**
  * extend bag config
  * @type {Object}
  */
 SDG.Bag.config = _.extend(SDG.Bag.config,SDG.Bag.gift_message);

/**
 * gift message
 */
SDG.Bag.giftMessage = function(opts) {

	var	c = _.extend(SDG.Bag.config,opts),
		$giftMessage = document.getElementById(c.dom.giftMessage),
		$textarea = document.getElementById(c.dom.giftMessageTextarea),
		$textWrapper = document.getElementById(c.dom.giftMessageTextWrapper),
		$bag = document.getElementById(c.dom.bag);

	function init() {
		if (_.hasClass($bag,c.cls.empty)) {
			_.removeClass($giftMessage,c.cls.active);
		} else {
			_.addClass($giftMessage,c.cls.active);
			addEvent();
		}

	}

	function addEvent() {
		_.addEvent({
			id: c.dom.giftMessageLabel,
			event: c.show_event,
			fn: giftMessageOpen
		});

		_.addEvent({
			id: c.dom.giftMessageTextarea,
			event: c.blur,
			fn: countWords
		});
	}

	function giftMessageOpen() {
		if (_.hasClass($textWrapper,c.cls.active)) {
			_.removeClass($textWrapper,c.cls.active);
		} else {
			_.addClass($textWrapper,c.cls.active);
		}
	}

	function countWords(e) {
		var word_limit = 25,
			text = $textarea.value,
			text_array = text.split(/\s+/),
			new_text;

		if (text_array.length > word_limit) {
			new_text = text_array.slice(0,word_limit);
			$textarea.value = new_text.join(' ');
		}
	}

	return {
		init: init()
	};
};

/**
 * Add Gift Wrapping to Cart
 */

/**
 * namespace
 * @type {Object}
 */
SDG.Bag = SDG.Bag || {};

/**
  * bag config
  * @type {Object}
  */
SDG.Bag.config = SDG.Bag.config || {};

/**
 * Gift Wrapping config
 * @type {Object}
 */
SDG.Bag.GiftWrap = {
    dom: {
        giftWrappingWrapper: 'giftWrappingWrapper'
    }
};

/**
  * extend bag config
  * @type {Object}
  */
SDG.Bag.config = _.extend(SDG.Bag.config,SDG.Bag.GiftWrap);

/**
 * Gift Wrapping
 */

SDG.Bag.GiftWrap = function(opts) {
    var	c = _.extend(SDG.Bag.config,opts),
		$giftWrappingWrapper = document.getElementById(c.dom.giftWrappingWrapper),
        gift_wrap_id = giftWrapId,
		$bag = document.getElementById(c.dom.bag);

	function init() {
		if (_.hasClass($bag,c.cls.empty)) {
            $giftWrappingWrapper.style.display = 'none';
            console.log('Bag is Empty');
		} else {
            $giftWrappingWrapper.style.display = 'inline-flex';
			addEvent();
            console.log('Bag not Empty');
		}

	}
    
    function addGiftWrappingToCart(){
        var properties = {
            '_gift-wrapping': true,
        };

        var data = {
            quantity: 1,
            id: gift_wrap_id,
            properties: properties,
        };
        var params = {
            url: '/cart/add.js',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: function(data) {
              SDG.Bag.refresh();
            },
        };

        // init ajax
    _   .ajax(params);
    console.log(gift_wrap_id);
    }

    function addEvent() {
        _.addEvent({
            id: c.dom.giftWrappingWrapper,
            event: 'click',
            fn: addGiftWrappingToCart
        });
    }

    return {
		init: init()
	};
};
/**
 * free shipping message
 * @requires [lib/util.js,lib/bag-config.js]
 * namespace
 * bag config
 */

/**
 * namespace
 * @type {Object}
 */
 SDG.Bag = SDG.Bag || {};
 /**
  * bag config
  * @type {Object}
  */
 SDG.Bag.config = SDG.Bag.config || {};

 /**
 * Gift Message config
 * @type {Object}
 */
 SDG.Bag.fs_data = {
	cls: {
		freeShip: '.js-free-shipping-message',
		toSpend: '.cart_left_to_spend',
        freeShipMsg: '.cart_free_shipping_msg',
		freeShippingAmount: '.free-shipping-amount',
		hide: 'hide'
	}
 };


 /**
  * extend bag config
  * @type {Object}
  */
 SDG.Bag.config = _.extend(SDG.Bag.config,SDG.Bag.fs_data);

/**
 * free shipping message
 */
SDG.Bag.freeShippingMessage = function(opts) {

	var	c = _.extend(SDG.Bag.config,opts),
		$freeShip = document.querySelector(c.cls.freeShip),
		$toSpend = document.querySelector(c.cls.toSpend),
        $freeShipMsg = document.querySelector(c.cls.freeShipMsg),
		$freeShippingAmount = document.querySelector(c.cls.freeShippingAmount),
		subtotal = SDG.Bag.subtotal,
		spend;

	function init() {
		if ($freeShip) {
			spend = parseInt($freeShip.getAttribute('data-amount'));

			if (subtotal < spend) {
				_.removeClass($toSpend, c.cls.hide);
                _.addClass($freeShipMsg, c.cls.hide);
				$freeShippingAmount.innerHTML = '$'+Math.ceil(spend-subtotal);
			} else {
				_.addClass($toSpend, c.cls.hide);
              	_.removeClass($freeShipMsg, c.cls.hide);
			}
		}
	}

	return {
		init: init()
	};
};

/**
 * bag timeout
 */
SDG.Bag.timeout = null;

SDG.Bag.clearTimeout = function() {
	clearTimeout(SDG.Bag.timeout);
};

/**
 * is open
 * @return {Function} Checks if bag is open
 */
SDG.Bag.isOpen = false;

/**
 * open bag
 * @return {Function} adds expose class from the body
 */
SDG.Bag.open = function(e) {
	/**
	 * shorthand config
	 */
	var c = SDG.Bag.config;

	/**
	 * cached global
	 */
	var $body = document.body;

	if (e) {
		e.preventDefault();

		if (e.type === 'mouseenter') {
			SDG.Bag.clearTimeout();
			_.addClass($body,c.cls.expose);
			SDG.Bag.setFocus();
		}

		if (e.type === 'click') {
			if (SDG.Bag.isOpen) {
				SDG.Bag.close();
			} else {
				SDG.Bag.isOpen = true;
				_.addClass($body,c.cls.expose);
				SDG.Bag.setFocus();
			}
		}

	} else {
		_.addClass($body,c.cls.expose);
		SDG.Bag.setFocus();
	}
};


/**
 * focus bag modal
 * @return {Function} focus only the bag modal when it is opened.
 */
SDG.Bag.setFocus = function(e) {

	setTimeout(function() {
		trapFocus(document.getElementById('bag'));
	},350);

};

/**
* Function Trap Focus to Modal
* @type {function}
* @param {domElement} - modal element in the dom.
*/

function trapFocus(element)
{
	var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="submit"]:not([disabled]), input[type="email"]:not([disabled]), select:not([disabled])'),
			firstFocusableEl = focusableEls[0],
			lastFocusableEl = focusableEls[focusableEls.length - 1],
			KEYCODE_TAB = 9;

	firstFocusableEl.focus(); // Focus to first focusable element in the modal

	element.addEventListener('keydown', function(e) {
			var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

			if (!isTabPressed) {
					return;
			}

			if ( e.shiftKey ) /* shift + tab */ {
					if (document.activeElement === firstFocusableEl) {
							lastFocusableEl.focus();
							e.preventDefault();
					}
			} else /* tab */ {
					if (document.activeElement === lastFocusableEl) {
							firstFocusableEl.focus();
							e.preventDefault();
					}
			}
	});
}



/**
 * wait to close bag
 * @return {Function} removes expose class from the body
 */
SDG.Bag.waitToClose = function(e) {
	/**
	 * shorthand config
	 */
	var c = SDG.Bag.config;

	SDG.Bag.timeout = setTimeout(SDG.Bag.close,c.timer.hover);
};


/**
 * close bag
 * @return {Function} removes expose class from the body
 */
SDG.Bag.close = function(e) {
	/**
	 * shorthand config
	 */
	var c = SDG.Bag.config;

	/**
	 * cached global
	 */
	var $body = document.body;

	if (e) {
		e.preventDefault();
	}

	_.removeClass($body,c.cls.expose);

	SDG.Bag.isOpen = false;

	document.getElementById('bagBtn').focus();

};

/**
* init
* @type {Function}
*/
SDG.Bag.init = function() {
	/**
	 * shorthand config
	 */
	var c = SDG.Bag.config;

	function init() {

		// Refresh Bag
		SDG.Bag.refresh();

		// Add Events
		addEvents();
	}

	function addEvents() {
		// bag toggle
		if (c.show_event === 'mouseenter') {
			responsive();
			_.windowResize(responsive);
		} else {
			_.addEvent({
				id: c.dom.bag_btn,
				event: c.show_event,
				fn: SDG.Bag.open
			});
		}

		// clear timeout on bag hover
		_.addEvent({
			id: c.dom.bag,
			event: 'mouseenter',
			fn: SDG.Bag.clearTimeout
		});

		// bag close
		_.addEvent({
			id: c.dom.bag_close,
			event: 'click',
			fn: SDG.Bag.close
		});

		// close on escape get
		document.addEventListener('keyup',getKeyCode);
	}

	/**
	 * get keycode
	 * @return {Function} close modal on escape key
	 */
	function getKeyCode(e) {
		if (e.keyCode === 27 && SDG.Bag.isOpen) {
			SDG.Bag.close();
		}
	}

	/**
	 * bind click
	 * @type {Function}
	 */
	function bindClick() {
		_.addEvent({
			id: c.dom.bag_btn,
			event: 'click',
			fn: SDG.Bag.open
		});

		unbindHover();
	}

	/**
	 * bind click
	 * @type {Function}
	 */
	function unbindClick() {
		_.removeEvent({
			id: c.dom.bag_btn,
			event: 'click',
			fn: SDG.Bag.open
		});
	}

	/**
	 * bind hover
	 * @type {Function}
	 */
	function bindHover() {
		_.addEvent({
			id: c.dom.bag_btn + ',' + c.dom.bag,
			event: 'mouseenter',
			fn: SDG.Bag.open
		});
		_.addEvent({
			id: c.dom.bag_btn +','+ c.dom.bag,
			event: 'mouseleave',
			fn: SDG.Bag.waitToClose
		});
		unbindClick();
	}

	/**
	 * unbind hover
	 * @type {Function}
	 */
	function unbindHover() {
		_.removeEvent({
			id: c.dom.bag_btn + ',' + c.dom.bag,
			event: 'mouseenter',
			fn: SDG.Bag.open
		});
		_.removeEvent({
			id: c.dom.bag_btn +','+ c.dom.bag,
			event: 'mouseleave',
			fn: SDG.Bag.waitToClose
		});
	}

	/**
	 * responsive
	 * @type {Function}
	 */
	function responsive() {
		_.mq({
			view: 'desktop',
			callback: bindHover
		});
		_.mq({
			view: 'mobile',
			callback: bindClick
		});
	}

	return init();
};

/**
 * newsletter
 * @requires [lib/util.js,lib/messages.js,lib/modal.js,lib/cookie.js]
 */
/**
 * namespace
 * @type {Object}
 */
SDG.Newsletter = SDG.Newsletter || {};

/**
 * config
 * @type {Object}
 */
SDG.Newsletter.config = {
	cb: {
		form_success: null
	},
	cls: { // Toggle classes
		loading: 'is-loading',
	},
	dom: {
		btn: 'newsletterSubmit', // id of the form submit button
		form: 'newsletterForm', // id of the form
		id: 'newsletter', // id of the  container
		input: 'newsletterInput', // id of the input
		footerInput: 'footNewsletterInput,'
	},
	hide_form_on_success: false,
	hide_messages_on_focus: false,
	hide_messages_on_success: true,
	message_opts: {
		id: 'newsletterMessages',
		dom: {
			msg: 'message message--nobg newsletter__message'
		},
		msgs: {
			already_member: '<p>You\'re already a member.</p>',
			success: '<p>Thanks for subscribing!</p>'
		}
	},
	namespace: null, // Name space all dom and message id values
	timer: {
		slide_up_delay: '3000'
	}
};

/**
 * init
 * @param  {Object} opts extend config option
 * @return {Function}
 */
SDG.Newsletter.form = function(opts) {
	/**
	 * Extend Newsletter Config
	 */
 	var c = _.extend(SDG.Newsletter.config,opts);

	/**
	 * name space variables if set in config
	 */
	c.dom = _.namespace(c.dom,c.namespace);
	c.message_opts = _.namespace(c.message_opts,c.namespace);

	/**
	 * cached dom;
	 */
	var domId = document.getElementById(c.dom.id),
		domForm = document.getElementById(c.dom.form),
		domEmail = document.getElementById(c.dom.input),
		domSubmit = document.getElementById(c.dom.btn);


	/**
	 * Messages
	 */
	var msgs;

	/**
	 * init
	 * @type {Function}
	 */
	function init() {
		msgs = SDG.Messages.init(c.message_opts);
		addEvents();
		callbacks();
	}

	/**
	 * add events
	 * @type {Function}
	 */
	function addEvents() {
		_.addEvent({
			id: c.dom.form,
			event: 'submit',
			fn: onSubmit
		});

		if (c.hide_messages_on_focus) {
			_.addEvent({
				id: c.dom.form,
				event: 'focus',
				fn: msgs.clear
			});
		}

		var domFooterInput =  document.getElementById('footNewsletterInput');
		var domFooterNewsletter =  document.getElementById('footNewsletterForm');

		if (domFooterInput) {
			domFooterInput.addEventListener('input', function(event) {
				var label = domFooterNewsletter.querySelector('.screenreader');
				if(domFooterInput.value.length > 0) {
					label.classList.add('visible');
				} else {
					label.classList.remove('visible');
				}
			});
		}

	}

	/**
	 * callbacks
	 * @type {Function}
	 */
	 /**
 	 * callbacks
 	 * @type {function}
 	 */
 	function callbacks() {
 		_.addEvent({
 			id: c.dom.id,
 			event: 'formSuccess',
 			fn: function() {
 				if (typeof(c.cb.form_success) === 'function') {
 					c.cb.form_success();
 				}

				// hide form
				if (c.hide_form_on_success) {
					_.hide(domForm);
				}
 			}
 		});
	}

	/**
	 * on submit
	 */
	function onSubmit(e) {
		e.preventDefault();

		var ajaxUrl = this.getAttribute('data-ajax-submit'),
			data = _.serialize(domForm,true);

		// disable button
		disableButton();

		// reset messages to their default (hidden) state
		msgs.clear();

		// blur email
		domEmail.blur();

		_.ajax({
			contentType: 'application/json',
			dataObject: JSON.stringify(data),
			error: onError,
			success: onSuccess,
			type: 'POST',
			url: ajaxUrl
		});
	}

	/**
	 * form success
	 * @type {Function}
	 */
	function onSuccess(response) {

		// enable button
		enableButton();

		// set cookie
		setCookie();

		// clear Inputs
		clearInputs();

		domEmail.focus();

		// show messages
		if (response.already_member) {
			msgs.success(c.message_opts.msgs.already_member);
		} else {
			msgs.success();
		}

		// trigger success callbacks
		if (domId) {
			_.trigger(domId,'formSuccess');
		}

		// hide messages
		if (c.hide_messages_on_success) {
			setTimeout(msgs.clear, c.timer.slide_up_delay);
		}

		// custom success callback
		if (typeof c.cb.form_success === 'function') {
			c.cb.form_success();
		}
	}

	function onError(response) {
		enableButton();

		domEmail.focus();

		var errorMsg = response.message ? response.message.split(/\x2a/g) : null;

		document.getElementById(c.dom.input).focus();

		if (errorMsg) {
			errorMsg = '<p>'+ errorMsg[errorMsg.length - 1] +'</p>';
			msgs.error(errorMsg);
		} else {
			msgs.error();
		}
	}

	/**
	 * enable buttons
	 */
	function enableButton() {
		_.removeClass(domSubmit,c.cls.loading); // remove loading class
		domSubmit.disabled = false; // enable submit button
	}

	/**
	 * disable buttons
	 */
	function disableButton() {
		_.addClass(domSubmit,c.cls.loading); // add loading class
		domSubmit.disabled = true; // disable submit button
	}

	/**
	 * enable buttons
	 */
	function setCookie() {
		if (SDG.getCookie(c.cookie.name) !== c.cookie.state) {
			SDG.setCookie(c.cookie.name, c.cookie.state, c.cookie.exdays);
		}
	}

	/**
	 * clear inputs
	 */
	function clearInputs() {
		domEmail.value = '';
	}

	return init();

};
/**
 * newsletter inline
 * @requires [lib/util.js,lib/modal.js,lib/cookie.js,lib/newsletter.js]
 */
/**
 * config
 * @type {Object}
 */
SDG.Newsletter.config = SDG.Newsletter.config || {};
SDG.Newsletter.banner_config = SDG.Newsletter.modal_config || {};
SDG.Newsletter.banner_config = {
	cls: {
		banner_partial: 'newsletter-show',
		banner_full: 'newsletter-show-full'
	},
	cookie: {
		viewed: 'viewed'
	},
	dom: {
		banner: 'newsletterParent',
		banner_close: 'newsletterClose',
		banner_expand: 'newsletterExpand'
	},
	hide_form_on_success: true,
	message_opts: {
		animation: {
			type: 'fadeIn'
		}
	},
	timer: {
		banner_delay: '1000',
		close_banner: '3000'
	}
};

// Extend config object defined in lib/newsletter.js
SDG.Newsletter.config = _.extend(SDG.Newsletter.config,SDG.Newsletter.banner_config);

/**
 * banner
 * @param {Object} - Extend options object
 */
SDG.Newsletter.banner = function(opts) {
	/**
	 * extended config
	 */
	var c = _.extend(SDG.Newsletter.config,opts),
		formBound = false;

	/**
	 * cached dom elements
	 */
	var body = document.body;

	/**
	 * init
	 * @desc initiates module, returned with .banner call
	 * @return {Function}
	 */
	function init() {
		if (c.timer.banner_delay) {
			setTimeout(function() {
				responsive();
				_.windowResize(responsive);
			},c.timer.banner_delay);
		} else {
			responsive();
			_.windowResize(responsive);
		}
	}

	/**
	 * responsive
	 * @return {Function} [description]
	 */
	function responsive() {
		_.mq({
			view: 'desktop',
			callback: hideBanner
		});

		_.mq({
			view: 'mobile',
			callback: checkCookie
		});
	}

	/**
	 * check cookie
	 * @desc checks cookie, based on results either add full banner or partial banner class
	 */
	function checkCookie() {
		if (SDG.getCookie(c.cookie.name) !== c.cookie.state) {

			// Add show classes
			if (SDG.getCookie(c.cookie.name) === c.cookie.viewed) {
				_.addClass(body,c.cls.banner_partial);
			} else {
				_.addClass(body,c.cls.banner_full);
			}

			bindEvents();
		}
	}

	function bindEvents() {
		// Bind Form
		if (!formBound) {

			formBound = true;

			c.cb.form_success = bannerSuccess;

			// Bind Form
			SDG.Newsletter.form(c);

			// Bind Expand Banner Event
			_.addEvent({
				id: c.dom.banner_expand,
				event: 'click',
				fn: expandBanner
			});

			// Bind Close
			_.addEvent({
				id: c.dom.banner_close,
				event: 'click',
				fn: updateBanner
			});
		}
	}

	function updateBanner() {
		if (_.hasClass(body,c.cls.banner_full)) {
			collapseBanner();
		} else {
			closeBanner();
		}
	}

	function expandBanner() {
		if (_.hasClass(body,c.cls.banner_partial)) {
			_.removeClass(body,c.cls.banner_partial);
			_.addClass(body,c.cls.banner_full);
			SDG.deleteCookie(c.cookie.name);
		}
	}

	function closeBanner() {
		SDG.setCookie(c.cookie.name, c.cookie.state, c.cookie.exdays);

		if (_.hasClass(body,c.cls.banner_partial)) {
			_.removeClass(body,c.cls.banner_partial);
		}

		if (_.hasClass(body,c.cls.banner_full)) {
			_.removeClass(body,c.cls.banner_full);
		}
	}

	function collapseBanner() {
		SDG.setCookie(c.cookie.name, c.cookie.viewed, c.cookie.exdays);

		if (_.hasClass(body,c.cls.banner_full)) {
			_.removeClass(body,c.cls.banner_full);
		}

		_.addClass(body,c.cls.banner_partial);
	}

	function hideBanner() {
		if (_.hasClass(body,c.cls.banner_partial)) {
			_.removeClass(body,c.cls.banner_partial);
		}

		if (_.hasClass(body,c.cls.banner_full)) {
			_.removeClass(body,c.cls.banner_full);
		}
	}

	function bannerSuccess() {
		setTimeout(function() {
			closeBanner();
		},c.timer.close_banner);
	}

	return init();
};
/**
 * video embed
 * @param  {Object}  Config object
 * @requires [lib/util.js,lib/modal.js,lib/modal-get.js,lib/modal-clear.js]
 */
SDG.videoEmbed = function(opts) {
	/**
	 * config
	 * @type {Object}
	 */
	var config = {
		id: 'vid',
		image: '.js-vid-image',
		class: {
			embed: 'vid__embed',
			fade_out: 'is-fading-out',
			has_embed: 'has-embed',
			ir: 'ir ir--vid'
		},
		video_url: {
			youtube : 'https://www.youtube.com/embed/',
			vimeo: 'https://player.vimeo.com/video/'
		},
		show_in_modal : false,
		// modal : null  keys: id, modifier, overlay
	};

	// Extended config
	var c = _.extend(config, opts),

	// globals
	video = document.getElementById(c.id);

	/**
	 * init
	 * @return {Function}
	 */
	function init() {
		bindEvents();
	}

	/**
	 * bind events
	 * @return {Function}
	 */
	function bindEvents() {
		if (video) {
			if (c.show_in_modal) {
				video.addEventListener('click', generateModal, false);
			} else {
				video.addEventListener('click', insertVideo, false);
			}
		}
	}

	/**
	 * unbind events
	 * @return {Function}
	 */
	function unbindEvents() {
		if (c.show_in_modal) {
			video.removeEventListener('click', generateModal, false);
		} else {
			video.removeEventListener('click', insertVideo, false);
		}
	}

	/**
	 * insert video
	 * @return {Function}
	 */
	function insertVideo() {
		var videoId = this.getAttribute('data-video-id'),
			videoPlayer = this.getAttribute('data-video-player'),
			videoTitle = this.getAttribute('data-video-title'),
			videoImage = video.querySelector(c.image),
			videoEmbed = buildEmbed(videoId, videoPlayer, videoTitle);

		// unbind events
		unbindEvents();

		// transition image-to-video
		_.transition({
			before: function() {

				// add fade-out class to image
				_.addClass(videoImage, c.class.fade_out);
			},
			after: function() {

				// hide image
				videoImage.style.display = 'none';

				// remove fade-out class from image
				_.removeClass(videoImage, c.class.fade_out);

				// prepend video embed to video container
				video.insertBefore(videoEmbed, videoImage);

				videoEmbed.parentNode.focus();
			}
		});
	}

	/**
	 * video player chocie
	 * @param {String} videoPlayer
	 * @return {Function}
	 */
	function videoPlayerChoice(videoPlayer) {
		var videoUrlPlayer;

		switch(videoPlayer) {
			case 'vimeo':
				videoUrlPlayer = c.video_url.vimeo;
			break;
			default:
				videoUrlPlayer = c.video_url.youtube;
		}
		return videoUrlPlayer;
	}

	/**
	 * build embed
	 * @param  {String} videoId     Id of the video on youtube or vimeo
	 * @param  {String} videoPlayer Type of player, youtube or vimeo. Default is youtube
	 * @return {String}             Html for the iframe embed
	 */
	function buildEmbed(videoId, videoPlayer, videoTitle) {

		var videoChoice = videoPlayerChoice(videoPlayer),
			videoUrl =  videoChoice + videoId + '?autoplay=1&rel=0',
			videoEmbed = document.createElement('div'),
			videoIframe = '<iframe width="1280" height="720" src="'+videoUrl+'" title="'+videoTitle+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';

		// set class name
		videoEmbed.className = c.class.embed + ' ' + c.class.ir;

		// append iframe html to embed div
		videoEmbed.innerHTML = videoIframe;

		return videoEmbed;
	}

	/**
	 * generate modal
	 * @return {Function}
	 */
	function generateModal() {
		var videoModal,
			md,
			modalWrap,
			videoId = this.getAttribute('data-video-id'),
			videoPlayer = this.getAttribute('data-video-player'),
			videoTitle = this.getAttribute('data-video-title'),
			videoChoice = videoPlayerChoice(videoPlayer),
			videoUrl = videoChoice + videoId + '?autoplay=1&rel=0',
			html = '<div class="vid__embed ir ir--vid">'+
					'<iframe width="1280" height="720" src="'+videoUrl+'" title="'+videoTitle+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'+
				'</div>';

		if (c.modal) {
			md = SDG.Modal.getHtml({
				modal : c.modal.modal_id,
				modifier : c.modal.modifier,
				overlay : c.modal.overlay,
				html : html
			});

			modalWrap = document.createElement('div');
			modalWrap.innerHTML = md;
			document.body.appendChild(modalWrap);

			setTimeout(function() {
                videoModal = SDG.Modal.init({
					dom: {
						modal_id: c.modal.modal_id,
						overlay : c.modal.overlay
					},
					cb: {
						after_close: attachCloseEvent
					}
                });
				videoModal.init();
                videoModal.open(c.modal.modal_id);
            },20);
		}

		function attachCloseEvent() {
			setTimeout(function() {
				SDG.Modal.clear({
					modal : c.modal.modal_id,
					overlay : c.modal.overlay,
					remove_parent: true
				});
			},500);
		}
	}

	return {
		init: init
	};
};
/**
 * https://github.com/aFarkas/lazysizes/tree/gh-pages/plugins/attrchange
 *
 * lazysizes attribute change / re-initialization extension
 *
 * In case you are changing the data-src/data-srcset attributes of already transformed lazyload elements dynamically, you normally
 * also must re-add the lazyload class to the element. This extension automatically detects changes to your data-* attributes and
 * adds the class for you.
 */

(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(require('lazysizes'));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	'use strict';
	if(!window.addEventListener){return;}

	var rAF = window.requestAnimationFrame || setTimeout;

	var addObserver = function(){
		var connect, disconnect, observer, connected;
		var lsCfg = lazySizes.cfg;
		var attributes = {'data-bgset': 1, 'data-include': 1, 'data-poster': 1, 'data-bg': 1, 'data-script': 1};
		var regClassTest = '(\\s|^)(' + lsCfg.loadedClass;
		var docElem = document.documentElement;

		var setClass = function(target){
			rAF(function(){
				lazySizes.rC(target, lsCfg.loadedClass);
				if(lsCfg.unloadedClass){
					lazySizes.rC(target, lsCfg.unloadedClass);
				}
				lazySizes.aC(target, lsCfg.lazyClass);
			});
		};

		var onMutation = function(mutations){
			var i, len, mutation, target;
			for(i = 0, len = mutations.length; i < len; i++){
				mutation = mutations[i];
				target = mutation.target;

				if(!target.getAttribute(mutation.attributeName)){continue;}

				if(target.localName == 'source' && target.parentNode){
					target = target.parentNode.querySelector('img');
				}

				if(target && regClassTest.test(target.className)){
					setClass(target);
				}
			}
		};

		if(lsCfg.unloadedClass){
			regClassTest += '|' + lsCfg.unloadedClass;
		}

		regClassTest += '|' + lsCfg.loadingClass + ')(\\s|$)';

		regClassTest = new RegExp(regClassTest);

		attributes[lsCfg.srcAttr] = 1;
		attributes[lsCfg.srcsetAttr] = 1;

		if(window.MutationObserver){
			observer = new MutationObserver(onMutation);

			connect = function(){
				if(!connected){
					connected = true;
					observer.observe( docElem, { subtree: true, attributes: true, attributeFilter: Object.keys(attributes)} );
				}
			};
			disconnect = function(){
				if(connected){
					connected = false;
					observer.disconnect();
				}
			};
		} else {
			docElem.addEventListener('DOMAttrModified', (function(){
				var runs;
				var modifications = [];
				var callMutations = function(){
					onMutation(modifications);
					modifications = [];
					runs = false;
				};
				return function(e){
					if(connected && attributes[e.attrName] && e.newValue){
						modifications.push({target: e.target, attributeName: e.attrName});
						if(!runs){
							setTimeout(callMutations);
							runs = true;
						}
					}
				};
			})(), true);

			connect = function(){
				connected = true;
			};
			disconnect = function(){
				connected = false;
			};
		}

		addEventListener('lazybeforeunveil', disconnect, true);
		addEventListener('lazybeforeunveil', connect);

		addEventListener('lazybeforesizes', disconnect, true);
		addEventListener('lazybeforesizes', connect);
		connect();

		removeEventListener('lazybeforeunveil', addObserver);
	};


	addEventListener('lazybeforeunveil', addObserver);
}));
/**
* Quick Add to Cart / Product Cross Sell
* @requires [lib/util.js,lib/bag-refresh.js]
*
* namespace
* run
* fire functions
*/

/**
* product namespace
* @type {Object}
*/
SDG.quickAdd = SDG.quickAdd || {};

/**
 * Quick Add Form
 */
SDG.quickAdd.Form = function() {

    /**
     * init - add event listener to form submit button
     * @type {Function}
     */
     function init() {

        var formClassName = '.quickAdd',
        quickAddBtn = document.querySelectorAll(formClassName);
		quickAddBtn = Array.prototype.slice.call(quickAddBtn);


        quickAddBtn.forEach(function(el) {
            el.addEventListener('submit', addToBag, false);
        });
     }

    /**
     * add to bag
     * @type {Function}
     */
    function addToBag(e) {
        e.preventDefault();
        var data = _.serialize(this);
        SDG.quickAdd.Item(data);
    }

    return init();
};


/**
 * add item
 */
SDG.quickAdd.Item = function(data) {

 	_.ajax({
 		data: data,
 		error: SDG.quickAdd.onError,
 		success: SDG.quickAdd.onSuccess,
 		type: 'POST',
 		url: '/cart/add.js'
 	});
};

/**
 * error function
 */
SDG.quickAdd.onError = function(e) {
	console.warn('There has been an error.');
};

/**
 * success function
 */
SDG.quickAdd.onSuccess = function(e) {

	SDG.Bag.refresh();
};

// fire function
SDG.quickAdd.Form();
/**
 * Add Free Item
 * if item is more than $X amount, add free item
 * @type {Object}
 */
SDG.giveaway = function(opts) {
	var config = {
			limit: giveawayLimit,
			product: giveawayProduct,
			active: true,
			inCart: false,
			cart: SDG.Bag.Cart
		},
		c = _.extend(config, opts);

	/**
	 * init
	 */
	function init() {
		checkItemInCart();
	}

	/**
	 * observe
	 */
	function observeCart() {

		if (!c.inCart) {
			// giveaway product not in cart
			if (c.cart.total_price > parseInt(c.limit)*100) {
				// cart over the limit, add giveaway item
				addItemToCart();
			}
		} else {
			if (c.cart.total_price <= parseInt(c.limit)*100) {
				// giveaway item in cart and cart below the limit
				removeItemFromCart();
			}
		}
	}

	/**
	 * check item in cart
	 */
	function checkItemInCart() {
		var itemCount = c.cart.item_count,
			items = c.cart.items;

		if (itemCount > 0) {
			items.forEach(function(item) {
				if (item.handle === c.product.handle) {
					itemCount -= 1;
					if (item.properties && item.properties._giveaway) {
						c.inCart = true;
					}
				}
			});
		}

		observeCart();
	}

	/**
	 * add to cart
	 */
	function addItemToCart() {
		var properties = {
			'_thumbnail_url': c.product.featured_image,
			'_giveaway': true,
		};

		var data = {
			quantity: 1,
			id: c.product.variants[0].id,
			properties: properties,
		};

		var params = {
			url: '/cart/add.js',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: function(data) {
				c.inCart = true;
				SDG.Bag.refresh();
			},
		};

		// init ajax
		_.ajax(params);
	}

	/**
	 * remove from cart
	 * @param {boolean} refreshCart
	 */
	function removeItemFromCart(refreshCart) {
		if (refreshCart === undefined) refreshCart = true;
		var params = {
			url: '/cart/update.js',
			type: 'POST',
			data: 'updates['+c.product.variants[0].id+']=0',
			success: function(res) {
				c.inCart = false;
				if (res.item_count === 0) {
					var el = document.getElementById('bagItem' + c.product.variants[0].id);
					el.remove();
				}
				if (refreshCart) {
					SDG.Bag.refresh();
				}
			},
		};

		// init ajax
		_.ajax(params);
	}

	/**
	 * return
	 * @type {Object}
	 */
	return {
		init: init()
	};
};
SDG.removePastGiveawayItem = function(opts) {

	var config = {
		giveaway_current: window.giveawayItemId,
		giveaway_enabled: window.giveawayEnabled,
		cart: SDG.Bag.Cart
	},
	c = _.extend(config, opts);

	/**
	* init
	*/
	function init() {
		checkItemInCart();
	}

	function checkItemInCart() {
		var itemCount = c.cart.item_count,
			items = c.cart.items,
			itemCurrent = c.giveaway_current;

		if (itemCount > 0) {

			items.forEach(function(item) {

				var val = item.properties ? item.properties._giveaway === true : false;
				var itemGiveaway = val !== undefined ? val : '';
				var itemId = item.product_id;

				if ((itemId !== itemCurrent && itemGiveaway === true) || (itemId === itemCurrent && c.giveaway_enabled === false)) {

					var params = {
						url: '/cart/update.js',
						type: 'POST',
						data: 'updates['+item.variant_id+']=0',
						success: function() {
							SDG.Bag.refresh();
						},
					};

					// init ajax
					_.ajax(params);
				}

			});
		}
	}

	/**
	* return
	* @type {Object}
	*/
	return init();
};
/**
 * searchspring on dom ready
 *
 * import dependencies
 * namespace
 * on after search
 * fire functions
 */

/**
 * namespace
 * @type {Object}
 */
SDG.SearchSpring = SDG.SearchSpring || {};

/**
 * flag
 * @type {Object}
 */
SDG.SearchSpring.OnAfterSearchFlag = {
	has_init: false
};

/**
 * on after search
 * @param {Object} $scope angular's scope
 */
SDG.SearchSpring.onAfterSearch = function($scope) {

	// scope globals
	$scope.storage = {};
	$scope.touts = [];

	// cached globals
	var facetFilters = $scope.filterSummary;

	if (facetFilters.length > 0) {
		// if filtered result, get first size value
		var firstFilterValue = facetFilters[0].filterValue.replace('  ',' ');
	}

	/**
	 * init
	 */
	function init() {

	}

	angular.forEach($scope.results, function (result) {

		// Product image sizes
		var thumb = result.thumbnailImageUrl;

		// Filtered result, switch image with corresponding size
		if (firstFilterValue) {

			var priceArray = result.variant_price.split('|');
			var sizeArray = result.variant_size;

			sizeArray.forEach(function(val, idx) {
				if (val.replace('  ',' ') == firstFilterValue) { // jshint ignore:line
					result.price = priceArray[idx];
				}
			});

			var imagesJson = JSON.parse(result.variant_images_json);

			// firstFilterValue
			imagesJson.forEach(function(val) {
				if (val.size == firstFilterValue) { // jshint ignore:line
					thumb = val.img;
				}
			});
		}

		// assign thumb image value
		if (thumb) {
			var product_image_standard = thumb.replace('_medium','_271x');
			result.product_image_standard = product_image_standard;
			var product_image_retina = thumb.replace('_medium','_542x');
			result.product_image_retina = product_image_retina;
			var product_image_ss_auto = thumb.replace('_medium','_60x');
			result.product_image_ss_auto = product_image_ss_auto;
		}

	});

	// is badge
	$scope.isBiobased = function(result) {
		if (! result.tags) return false;

		var tags = result.tags;

		for (var i = 0; i < tags.length; i++) {
			if (tags[i].indexOf('biobased') > -1) {
				return true;
			}
		}
	};


	return init();
};

/**
 * fire functions
 */
function fireFn() {
	var $main = document.getElementById('main');

	// set ready flag
	if ($main) {
		$main.setAttribute('data-ss-aftersearch-ready', 'true');
	}
}

fireFn();
/**
 * recharge js
 */

SDG.Recharge = SDG.Recharge || {};


(function() {

	// globals
	var $recharge = document.getElementById('ReCharge');
	var $cancelTitle = document.querySelector('.page__customers__subscriptions__cancel .rc_title-bar__title h2');
	var $cancelReasonTitle = document.querySelector('.page__customers__subscriptions__cancel .rc_title-bar__description p');
	var $cancelButton = document.querySelector('.page__customers__subscriptions__cancel #cancellation_flow_form a');

	function init() {

		if (!$recharge) return;
		formatInputs();
		removeHiddenOptions();
		bindBackBtn();
		replaceWording();
		updateFormClasses();
	}


	function updateFormClasses() {
		if(document.querySelector('#ReChargeForm_address')) {
			var rechargeWrap = document.querySelector('#ReCharge');
			var checkBoxes = rechargeWrap.querySelectorAll('.rc_form__checkbox');
			var textInputs = rechargeWrap.querySelectorAll('input[type="text"]:not(#shipping_province_state):not(#billing_province_state)');
			var telInputs = rechargeWrap.querySelectorAll('input[type="tel"]');
			var emailInputs = rechargeWrap.querySelectorAll('input[type="email"]');
			var selects = rechargeWrap.querySelectorAll('select:not(#ReCharge-Mobile-Nav)');
			var billingIsShipping = rechargeWrap.querySelector('#billing_is_shipping');
			var billingProvinceContainer = rechargeWrap.querySelector('#billing_province_container');
			var shippingProvinceContainer = rechargeWrap.querySelector('#shipping_province_container');

			checkBoxes.forEach(function(checkbox) {
				var parent = checkbox.parentElement;
				parent.classList.remove('form-group');
				parent.classList.add('checkbox');
			});

			textInputs.forEach(function(textInput) {
				var parent = textInput.parentElement;
				var label = parent.querySelector('label');
				textInput.classList.add('input-decor__input');
				parent.classList.add('input-placeholder', 'input-decor');
				label.classList.add('input-decor__label');
			});

			telInputs.forEach(function(telInput) {
				var parent = telInput.parentElement;
				var label = parent.querySelector('label');
				telInput.classList.add('input-decor__input');
				parent.classList.add('input-placeholder', 'input-decor');
				label.classList.add('input-decor__label');
			});

			emailInputs.forEach(function(emailInput) {
				var parent = emailInput.parentElement;
				var label = parent.querySelector('label');
				emailInput.classList.add('input-decor__input');
				parent.classList.add('input-placeholder', 'input-decor');
				label.classList.add('input-decor__label');
			});

			selects.forEach(function(select) {
				var parent = select.parentElement;
				var label = parent.querySelector('label');
				select.classList.add('input-decor__input');
				parent.classList.add('input-decor');
				label.classList.add('input-decor__label');
			});

			billingProvinceContainer.classList.add('input-decor');
			shippingProvinceContainer.classList.add('input-decor');

			billingIsShipping.parentElement.classList.add('billing-is-shipping');
		}
 	}


	function replaceWording(){
		if($cancelTitle) {
			var newString = $cancelTitle.innerHTML.replace('Cancel', 'Remove');
			$cancelTitle.innerHTML = newString;
		}

		if($cancelReasonTitle) {
			var newCancelReasonCopy = $cancelReasonTitle.innerHTML.replace('cancelling', 'deleting this product from your subscription');
			$cancelReasonTitle.innerHTML = newCancelReasonCopy;
		}

		if($cancelButton) {
			var newButtonText = $cancelButton.innerHTML.replace('Cancel my', 'Remove from');
			$cancelButton.innerHTML = newButtonText;
		}
	}

	function formatInputs() {
		var $addressForm = document.getElementById('ReChargeForm_address'),
			$inputWraps;

		if ($addressForm) {
			$inputWraps = $addressForm.querySelectorAll('.input-wrapper');

			$inputWraps.forEach(function(el) {
				_.addClass(el, 'has-value');
			});
		}

	}

	function removeHiddenOptions() {
		var $mobileNav = document.getElementById('ReCharge-Mobile-Nav');

		if ($mobileNav) {
			$mobileNav.querySelectorAll('option').forEach(function(opt, i) {

				if (i > 1) {
					$mobileNav.removeChild(opt);
				}
			});
		}
	}

	function bindBackBtn() {
		var	$acSidebar = document.getElementById('customer_tab_nav');

		if ($acSidebar) {

			_.addEvent({
				id: 'customer_tab_nav',
				event: 'click',
				fn: onSidebarClick
			});
		}
	}

	function onSidebarClick(e) {
		var $parents = _.parents(e.target, '#ReCharge-Nav');

		// if click is on back link, redirect to account
		if (!$parents) {
			window.location.href = '/account';
		}
	}

	return init();
}());
// Check IPStacks

SDG.IPStack = SDG.IPStack || {};

SDG.IPStack.config = {
	url: {
		jsonip : '//jsonip.com/',
		api_stack : '//api.ipstack.com/'
	},
	cls: {
		active: 'is-active',
		hidden: 'is-hidden',
		has_value: 'has-value'
	},
	session: {
		checkIp: 'checkIP',
		country: 'country'
	},
	country: {
		us: 'us',
		intl: 'intl'
	},
	access_key: 'e1e4e2c2cfaf6a249bee26b9f871063c' // ipstack API
};

var c = SDG.IPStack.config;

SDG.IPStack.getIp = function() {
	// getting client IP
	_.ajax({
		url: c.url.jsonip,
		type: 'GET',
		success: function(data) {
			SDG.IPStack.getIPStack(data.ip);
		},
		error: function(data) {
			console.log('error:', data);
		}
	});

	// console.log('country :', sessionStorage.getItem('country'));
};

SDG.IPStack.getIPStack = function(ip) {
	_.loadJSONP(c.url.api_stack + ip +'?access_key=' + c.access_key, function(data) {
		// if country not US
		if (data.country_code.toLowerCase() !== c.country.us) {
			sessionStorage.setItem('country', data.country_code);
		}

		sessionStorage.setItem(c.session.checkIp, 'true');
	});
	// console.log('country :', sessionStorage.getItem('country'));
};

SDG.IPStack.init = function() {

	// for debugging, set country to non-US
	// Ass url param "?country=intl"
	if (window.location.search.indexOf('country=intl') > -1) {
		sessionStorage.setItem(c.session.country, c.country.intl);
	}

	// Run IP checker
	if (sessionStorage.getItem(c.session.checkIp) !== 'true') {
		// Set initial country as US
		sessionStorage.setItem(c.session.country, c.country.us);

		// check IP
		SDG.IPStack.getIp();
	}
};
/**
* common functions
* @requires [lib/util.js, lib/header.js, lib/modal.js, build/variable-menu.js]
*/

/**
* run dom ready
* @type {Function}
*/
SDG.runDomReady = function() {
	_.ready(function() { // lib/util.js
		// Add functions here

	});
};

/**
* run
* @type {Function}
*/
SDG.run = function() {
	/**
	* variable menu
	* @src lib/variable-menu.js
	*/
	var variableMenu = document.getElementById('variableMenu');
	if (variableMenu) {
		require([path.variable_menu]);
	}

	/**
	* header
	* @src lib/header.js
	*/
	SDG.Header.init();

	/**
	 * newsletter (footer)
	 * @src lib/newsletter.js
	 */
	SDG.Newsletter.form({
		hide_form_on_success: false,
		namespace: 'foot',
		message_opts: {
			animation: {
				type: 'slideDown'
			}
		}
	});

	/**
	 * newsletter (modal)
	 * @src lib/modal.js
	 * @src lib/newsletter-banner.js
	 */
	SDG.Newsletter.banner({namespace: 'banner'});

	/**
	 * bag
	 * @src lib/bag.js
	 */
	SDG.Bag.init();

	/**
	 * input placeholder
	 * @src lib/input-placeholder.js
	 */
	SDG.placeholder().init();

	/**
	 * get IP
	 * @src lib/bag.js
	 */
	SDG.IPStack.init();


	/**
	 * * FAQ accordion
	 */
	//SDG.accordion('#accFaq .js-acc-btn','#accFaq .js-acc-menu',null);
};


/**
* execute run and run dom ready
*/
SDG.run();
SDG.runDomReady();

/**
 * Samples Modal
 *
 */


 SDG.SamplesModal = SDG.SamplesModal || {};

 /**
  * config
  * @type {Object}
  */
 SDG.SamplesModal.config = {
 
   samplesTimer: 50,
 
	 // classes
	 cls: {
		 bagCheckout: '.bag__checkout',
		 samplesEnabled: 'samples--enabled',
		 samplesDisabled: 'samples--disabled'
	 },
 
	 // ids
	 id: {
		 samplesModal: 'samplesModal',
		 samplesOverlay: 'modalSamplesOverlay',
		 samplesModalClose: 'samplesModalClose',
		 samplesRowFirst: 'samplesRowFirst',
		 samplesRowSecond: 'samplesRowSecond',
		 samplesRowThird: 'samplesRowThird',
		 samplesSelectOne: 'samplesSelectOne',
		 samplesSelectTwo: 'samplesSelectTwo',
		 samplesSelectThree: 'samplesSelectThree',
		 samplesCheckout: 'samplesCheckout',
		 storeSamples: 'storeSamples',
		 noThanks: 'noThanks',
		 pickForMe: 'pickForMe',
		 bagCheckout: 'bagCheckout',
		 samplesModalButton: 'samplesModalButton',
		 samplesImgEnabled: 'samplesEnabled',
		 samplesImgDisabled: 'samplesDisabled'
	 },
 };
 
 /**
  * run
  * @type {Function}
  */
 SDG.SamplesModal.run = function() {
 
	 if (SDG.enableSamples && SDG.samples.length > 0) {
		 SDG.SamplesModal.pullProductsData();
	 } else {
		 SDG.enableCheckoutButton();
	 }
 
 };
 
 SDG.SamplesModal.samplesData = [];
 
 SDG.SamplesModal.pullProductsData = function() {
	 var products = [];
 
	 SDG.samples.forEach(function(array){
		 array.forEach(function(handle){
			 products.push(handle);
		 });
	 });
 
	 var filteredProducts = removeDuplicates(products);
 
	 filteredProducts.forEach(function(handle, index, array) {
		 if (handle !== '') {
			 ajax(handle, index);
		 }
	 });
 
	 function removeDuplicates(array) {
		 var unique = {};
		 array.forEach(function(i) {
		   if(!unique[i]) {
			 unique[i] = true;
		   }
		 });
		 return Object.keys(unique);
	 }
 
	 function ajax(handle, index) {
 
		 var url = '/products/' + handle + '.js';
 
		 _.ajax({
			 error: onError,
			 success: onSuccess,
			 type: 'GET',
			 url: url
		 });
 
		 function onError(e) {
			 console.log('There has been an error.');
			 console.log(e);
		 }
 
		 function onSuccess(e) {
			 SDG.SamplesModal.samplesData.push(e);
			 if (index === filteredProducts.length - 1){
				 setTimeout(function(){
					 SDG.SamplesModal.settings();
				 }, 3000);
			 }
		 }
	 }
 };
 
 SDG.enableCheckoutButton = function() {
	 var c = SDG.SamplesModal.config;
	 var $checkoutButton = document.getElementById(c.id.bagCheckout);
 
	 $checkoutButton.disabled = false;
	 $checkoutButton.classList.remove('is-loading');
 };
 
 SDG.SamplesModal.settings = function(opts) {
	 var c = SDG.SamplesModal.config;
 
	 // globals
	 var $samplesModal = document.getElementById(c.id.samplesModal);
	 var $samplesModalButton = document.getElementById(c.id.samplesModalButton);
	 var $samplesOverlay = document.getElementById(c.id.samplesOverlay);
	 var $samplesCheckoutButton = document.getElementById(c.id.samplesCheckout);
	 var $samplesImgEnabled = document.getElementById(c.id.samplesImgEnabled);
	 var $samplesImgDisabled = document.getElementById(c.id.samplesImgDisabled);
	 var $samplesSelects = document.querySelectorAll('.samples-select');
	 var $samplesRows = document.querySelectorAll('.samples-row');
	 var storedSamples = [];
 
	 /**
	  * init
	  */
	 function init() {
 
		  SDG.enableCheckoutButton();
 
		 // Samples only available for US customers
		 if (sessionStorage.getItem('country').toLowerCase() === 'us' && checkSamplesState() === true) {
			 removeSamplesFromCart();
			 generateContent();
			 addEvents();
			 setImage();
			 checkCartTotal();
			 checkSamplesRowLength();
			 selectBasedOnStorage();
			 samplesTimer();
			 checkCartTotal();
 
		 } else {
			 hideSamplesImageInCheckout();
		 }
	 }
 
 
	 /**
	  * check if samples modal is enabled or disabled
	  */
	 function checkSamplesState() {
		 if ($samplesModal.classList.contains(c.cls.samplesEnabled)) {
			 return true;
		 } else {
			 return false;
		 }
	 }
 
	 function generateContent() {
 
		 $samplesSelects.forEach(function(select, index) {
			 SDG.samples[index].forEach(function(handle){
 
				 var obj = findObjectByKey(SDG.SamplesModal.samplesData, 'handle', handle);
				 var opt = document.createElement('option');
				 opt.value = obj.variants[0].id;
				 opt.innerHTML = obj.title;
				 opt.setAttribute('data-product-id', obj.id);
				 select.appendChild(opt);
			 });
		 });
 
		 $samplesSelects.forEach(function(select, index) {
			 if(select.options[0] !== undefined) {
				 select.options[0].selected = true;
			 }
		 });
 
		 function findObjectByKey(array, key, value) {
			 for (var i = 0; i < array.length; i++) {
				 if (array[i][key] === value) {
					 return array[i];
				 }
			 }
			 return null;
		 }
	 }
 
	 /**
	  * add events
	  */
	 function addEvents() {
 
		 // var samplesModalStatus = JSON.parse(sessionStorage.getItem('samplesModalHasBeenClosed'));
 
		 // Bag CTA Image Click
		 _.addEvent({
			 id: c.id.samplesImgEnabled,
			 event: 'click',
			 fn: bagCheckoutClick
		 });
 
		 // Bag Checkout Click - old Checkout Btn trigger
		 _.addEvent({
			 id: c.id.bagCheckout,
			 event: 'click',
			 fn: checkBagTotalPrice
		 });
 
		 // No Thanks Button Click
		 _.addEvent({
			 id: c.id.noThanks,
			 event: 'click',
			 fn: hideModalInner
		 });
 
		 // No Thanks Pick For Me Button Click
		 _.addEvent({
			 id: c.id.pickForMe,
			 event: 'click',
			 fn: checkoutPickForMe
		 });
 
		 // Store Samples Click
		 _.addEvent({
			 id: c.id.storeSamples,
			 event: 'click',
			 fn: storeSelectedSamples
		 });
 
		 // Close Icon Click
		 _.addEvent({
			 id: c.id.samplesModalClose,
			 event: 'click',
			 fn: hideModalInner
		 });
 
		 // Samples Checkout Button Click
		 _.addEvent({
			 id: c.id.samplesCheckout,
			 event: 'click',
			 fn: samplesCheckout
		 });
 
		 // Samples Select Change
		 $samplesSelects.forEach(function(select) {
			 select.addEventListener('change',function(event){
				 updateImage(event);
			 });
		 });
   }
 
	 function samplesTimer() {
		 var timer;
		 var timerStart;
		 var timeSpentOnSite = getTimeSpentOnSite();
 
		 function getTimeSpentOnSite(){
			 timeSpentOnSite = parseInt(sessionStorage.getItem('timeSpentOnSite'));
			 timeSpentOnSite = isNaN(timeSpentOnSite) ? 0 : timeSpentOnSite;
			 return timeSpentOnSite;
		 }
 
		 function startCounting(){
			 timerStart = Date.now();
			 timer = setInterval(function(){
				 var samplesModalCookie = getCookie('sampleModalOpen');
				 timeSpentOnSite = getTimeSpentOnSite()+(Date.now()-timerStart);
				 sessionStorage.setItem('timeSpentOnSite',timeSpentOnSite);
				 timerStart = parseInt(Date.now());
				 if(parseInt(timeSpentOnSite/1000) === c.samplesTimer) {
					 showModal();
					 document.cookie = 'sampleModalOpen=true';
				 }
 
				 if(samplesModalCookie !== null) {
					 clearInterval(timer);
				 }
 
				 function getCookie(name) {
					 var end;
					 var dc = document.cookie;
					 var prefix = name + '=';
					 var begin = dc.indexOf('; ' + prefix);
					 if (begin === -1) {
						 begin = dc.indexOf(prefix);
						 if (begin !== 0) return null;
					 } else {
						 begin += 2;
						 end = document.cookie.indexOf(';', begin);
						 if (end === -1) {
						 end = dc.length;
						 }
					 }
 
					 return decodeURI(dc.substring(begin + prefix.length, end));
				 }
			 },1000);
		 }
		 startCounting();
	 }
 
	 function hideSamplesImageInCheckout(){
		 $samplesModalButton.style.display = 'none';
	 }
 
	 function samplesCheckout() {
 
	 
		 var checkoutSamples = [];
		 $samplesSelects.forEach(function(select){
			 var selectedSample = getSelectedOption(select);
			 var selectedSampleId = selectedSample.value;
			 checkoutSamples.push(selectedSampleId);
		 });
 
		 if(checkoutSamples.length > 0) {
			 addSampleToCart(checkoutSamples);
		 } else {
			 checkoutPickForMe();
		 }
 
		 function getSelectedOption(sel) {
			 var opt;
			 for ( var i = 0, len = sel.options.length; i < len; i++ ) {
				 opt = sel.options[i];
				 if ( opt.selected === true ) {
					 break;
				 }
			 }
			 return opt;
		 }
 
		 console.log('Ilosc' + ' ' + checkoutSamples.length);
	 }
 
	 function addSampleToCart(checkoutSamples) {
		 
		 var checkoutSamplesLength = checkoutSamples.length;
		 var queue = 0;
 
		 function ajaxQueue() {
			 
			 if(queue < checkoutSamplesLength) {
				 var variantId = checkoutSamples[queue];
				 ajax(variantId);
			 }
		 }
 
		 function ajax(variantId) {
 
			 var properties = {
				 //'_thumbnail_url': c.product.featured_image,
				 'sample': 'yes',
			   };
		   
			 var data = {
				 quantity: 1,
				 id: variantId,
				 properties: properties
			   };
 
			   
			 _.ajax({
				 error: onError,
				 success: onSuccess,
				 url: '/cart/add.js',
				 type: 'POST',
				 contentType: 'application/json',
				 data: JSON.stringify(data)
			 });
 
		 }
 
		 function onError(e) {
			 // console.log('There has been an error.');
			 console.log(e);
		 }
 
		 function onSuccess(e) {
			 // console.log('are we even getting here?');
			 console.log(e);
			 queue++;
 
			 if(queue === checkoutSamplesLength) {
				 storeSelectedSamples();				
				 /*window.location.href = window.location.origin + '/cart/';*/
			 } else {
				 ajaxQueue();
				 
			 }
		 }
		 
		 ajaxQueue();		
		 disableSamplesImg();
		 
	 }
 
	 function disableSamplesImg(){
		 $samplesImgEnabled.style.display = 'none';
		 $samplesImgDisabled.style.display = 'block';
		 
		 $('#sampleMsg').delay(1000).fadeIn();
		 //$('#sampleDisabledMsg').delay(4050).fadeIn();
	 }
 
	 /*function enableSamplesImg(){
		 $samplesImgEnabled.style.display = 'block';
		 $samplesImgDisabled.style.display = 'none';
	 }*/
 
	 function removeSamplesFromCart() {
 
		 var bagItems = SDG.Bag.Cart.items;
		 var samples = [];
		 var samplesToRemove = [];
		 var samplesToRemoveLength;
		 var queue = 0;
 
		 samples = SDG.samples[0].concat(SDG.samples[1].concat(SDG.samples[2]));
		 samples = removeDuplicates(samples);
		 
		 function removeDuplicates(array) {
			 var unique = {};
			 array.forEach(function(i) {
				 if(!unique[i]) {
				 unique[i] = true;
				 }
			 });
			 return Object.keys(unique);
		 }
 
		 function onError(e) {
			 console.log('There has been an error.');
			 console.log(e);
		 }
 
		 function onSuccess(e) {
			 var cart = e;
			 cart.items.forEach(function(item){
				 // if this is sample, remove from cart
				 if(samples.indexOf(item.handle) > -1) {
					 samplesToRemove.push(item.id);
				 }
			 });
 
			 if(samplesToRemove !== null) {
				 samplesToRemoveLength = samplesToRemove.length;
 
				 if(samplesToRemoveLength !== 0) {
					 ajaxQueue();
				 }
			 }
		 }
 
		 if(bagItems !== undefined) {
			 bagItems.forEach(function(item){
				 // if this is sample, remove from cart
				 if(samples.indexOf(item.handle) > -1) {
					 samplesToRemove.push(item.id);
				 }
			 });
		 } else {
 
			 _.ajax({
				 error: onError,
				 success: onSuccess,
				 type: 'GET',
				 url: '/cart.js'
			 });
 
		 }
 
		 if(samplesToRemove !== null) {
			 samplesToRemoveLength = samplesToRemove.length;
 
 
			 if(samplesToRemoveLength !== 0) {
				 ajaxQueue();
			 }
		 }
 
		 function ajaxQueue() {
			 if(queue < samplesToRemoveLength) {
				 var variantId = samplesToRemove[queue];
				 ajax(variantId);
			 } else {
				 SDG.Bag.refresh();
			 }
		 }
 
		 function ajax(variantId) {
 
			 var data = {
				 quantity: 0,
				 id: variantId
			   };
 
			 _.ajax({
				 data: data,
				 error: onError,
				 success: onSuccess,
				 type: 'POST',
				 url: '/cart/change.js'
			 });
 
			 function onError(e) {
				 console.log('There has been an error.');
				 console.log(e);
				 queue++;
			 }
 
			 function onSuccess(e) {
				 if(queue !== samplesToRemoveLength) {
					 queue++;
					 ajaxQueue();
				 }
			 }
		 }
	 }
 
	 function checkoutPickForMe() {
		 $samplesSelects.forEach(function(select){
			 if(select) {
				 select[0].selected = true;
			 }
		 });
 
		 samplesCheckout();
	 }
 
	 function checkBagTotalPrice() {
 
		 if(SDG.Bag.Cart.items_subtotal_price === 0 && SDG.samples.length > 0) {
			e.preventDefault();
			var msg = document.getElementById('sampleMsg');
 
			   removeSamplesFromCart();
			   msg.style.display = 'none';
		   
			   console.log('Samples ' + SDG.samples.length);
			   console.log('Total Price ' + SDG.Bag.Cart.items_subtotal_price);
		 }/*else {
 
			 window.location.href = window.location.origin + '/checkout/';
		 }*/
	 }
 
	 function bagCheckoutClick() {
 
		 if(SDG.Bag.Cart.items_subtotal_price > 300) {
			 //e.preventDefault();
			 showModal();
			 $samplesModal.classList.add('samples-checkout');
			 console.log('Clicked to show modal');
		 }
 
	 }
 
	 function showModal() {
		 $samplesModal.classList.add('is-visible');
		 $samplesOverlay.classList.add('is-visible');
 
		 if(SDG.Bag.Cart.items_subtotal_price < 300 || SDG.Bag.Cart.items_subtotal_price === undefined ) {
			 $samplesModal.classList.add('samples--hide-checkout');
			 $samplesCheckoutButton.setAttribute('disabled', 'disabled');
		 } else {
			 $samplesModal.classList.remove('samples--hide-checkout');
			 $samplesCheckoutButton.removeAttribute('disabled');
		 }
	 }
	 // Closing modal - used by other function
	 function hideModalInner() {
		 $samplesModal.classList.remove('is-visible');
		 $samplesOverlay.classList.remove('is-visible');
	}
 
	/* Redirecting to Checkout only if open on Cart page - old
	function hideModal() {
		  if( $samplesModal.classList.contains('samples-checkout')){
			samplesCheckout();
		} else {
			$samplesModal.classList.remove('is-visible');
			$samplesOverlay.classList.remove('is-visible');
		}			
	}*/
 
	 function checkSamplesRowLength() {
		 if ($samplesRows.length === 1) {
			 $samplesRows[0].classList.add('only-one-row');
		 }
	 }
 
	 function setImage() {
 
		 var images = $samplesModal.querySelectorAll('img');
		 var selectedIds = [];
 
		 $samplesSelects.forEach(function(select) {
			 if (select.options[select.selectedIndex]) {
				 var selectedId = select.options[select.selectedIndex].getAttribute('data-product-id');
				 selectedIds.push(Number(selectedId));
			 }
		 });
 
		 images.forEach(function(image, index){
			 var selectedProductId = selectedIds[index];
			 var obj = findObjectByKey(SDG.SamplesModal.samplesData, 'id', selectedProductId);
			 if(obj) {
				 image.src = obj.images[0];
			 }
		 });
 
 
		 function findObjectByKey(array, key, value) {
			 for (var i = 0; i < array.length; i++) {
				 if (array[i][key] === value) {
					 return array[i];
				 }
			 }
			 return null;
		 }
	 }
 
	 function storeSelectedSamples(){
		 getSelectedSamples();
		 sessionStorage.setItem('storedSamples', JSON.stringify(storedSamples));
		 hideModalInner();
	 }
 
	 function selectBasedOnStorage() {
		 if(sessionStorage.getItem('storedSamples')) {
			 var localSorageSamples = JSON.parse(sessionStorage.getItem('storedSamples'));
 
			 $samplesSelects.forEach(function(select, index){
				 var options = Array.prototype.slice.call( select.options );
				 options.forEach(function(option) {
					 if (localSorageSamples[index] === option.value) {
						 option.selected = true;
					 }
				 });
 
				 var selectedProduct = getSelectedOption(select);
				 var selectedProductId = selectedProduct.getAttribute('data-product-id');
				 var parent = select.parentNode.parentNode.parentNode.parentNode;
				 var image = parent.querySelector('img');
				 var product = findObjectByKey(SDG.SamplesModal.samplesData, 'id', Number(selectedProductId));
 
				 image.src = product.images[0];
 
				 function findObjectByKey(array, key, value) {
					 for (var i = 0; i < array.length; i++) {
						 if (array[i][key] === value) {
							 return array[i];
						 }
					 }
					 return null;
				 }
 
			 });
		 }
	 }
 
	 function getSelectedSamples() {
		 storedSamples = [];
 
		 $samplesSelects.forEach(function(select){
			 var selectedSample = getSelectedOption(select);
			 var selectedSampleId = selectedSample.value;
 
			 storedSamples.push(selectedSampleId);
		 });
	 }
 
	 function getSelectedOption(sel) {
		 var opt;
		 for ( var i = 0, len = sel.options.length; i < len; i++ ) {
			 opt = sel.options[i];
			 if ( opt.selected === true ) {
				 break;
			 }
		 }
		 return opt;
	 }
 
	 function updateImage(event) {
 
		 var sel = event.path[0];
		 var selectedProduct = getSelectedOption(sel);
		 var selectedProductId = selectedProduct.getAttribute('data-product-id');
		 var parent = event.path[4];
		 var image = parent.querySelector('img');
		 var product = findObjectByKey(SDG.SamplesModal.samplesData, 'id', Number(selectedProductId));
 
		 function findObjectByKey(array, key, value) {
			 for (var i = 0; i < array.length; i++) {
				 if (array[i][key] === value) {
					 return array[i];
				 }
			 }
			 return null;
		 }
		 image.src = product.images[0];
	 }
 
	 function checkCartTotal() {
 
	 }
 
	 /**
	  * return
	  * @type {Object}
	  */
	 return {
		 init: init()
	 };
 };
 
 /**
  * fire functions
  */
 SDG.SamplesModal.run();
 
 
 
 /**
  * Hide Increment on Samples
  *
  */
 
 
 SDG.hideIncrementOnSamples = function(opts) {
 
	 var config = {
		 giveaway_current: window.giveawayItemId,
		 giveaway_enabled: window.giveawayEnabled,
		 cart: SDG.Bag.Cart
	 },
	 c = _.extend(config, opts);
 
	 /**
	 * init
	 */
	 function init() {
		 checkItemInCart();
	 }
 
	 function checkItemInCart() {
		 var items = c.cart.items,
			 samples = [];
			 samples = SDG.samples[0].concat(SDG.samples[1].concat(SDG.samples[2]));
			 samples = removeDuplicates(samples);
 
			 function removeDuplicates(array) {
				 var unique = {};
				 array.forEach(function(i) {
				   if(!unique[i]) {
					 unique[i] = true;
				   }
				 });
				 return Object.keys(unique);
			 }
 
			 items.forEach(function(item){
 
				 // if this is sample, remove incrementer
				 if(samples.indexOf(item.handle) > -1) {
					 var cartItem = document.getElementById('bagItem' + item.id);
					 var cartItemQtyButtons = cartItem.querySelectorAll('.increment__btn');
					 cartItemQtyButtons.forEach(function(button){
						 button.remove();
					 });
				 }
			 });
 
	 }
 
	 /**
	 * return
	 * @type {Object}
	 */
	 return init();
 };